/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 45:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomersList_CustomersList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomersList/CustomersList.vue?vue&type=template&id=ca5dd468
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading || !_vm.customFieldsLoaded)?_c('Spinner'):_c('k-table',{ref:"table",attrs:{"url":"/customer","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowActions":_vm.rowActions,"rowLink":_vm.rowLink,"stateKey":_vm.type + '-list',"exportable":"customer","importable":_vm.type}}),_c('CustomerDelete',{attrs:{"element":"modal","modal":_vm.deleteCustomer !== null},on:{"closed":function($event){_vm.deleteCustomer = null},"deleted":_vm.deleted},model:{value:(_vm.deleteCustomer),callback:function ($$v) {_vm.deleteCustomer=$$v},expression:"deleteCustomer"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: ./src/components/CustomerDelete/CustomerDelete.vue + 3 modules
var CustomerDelete = __webpack_require__(3878);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomersList/CustomersList.ts?vue&type=script&lang=ts&external







var CustomersList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomersList, _super);
    function CustomersList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.deleteCustomer = null;
        _this.deleteIndex = null;
        _this.include = [
            'activity', 'origin', 'tags', 'customFields', 'teamUser', 'address_invoice', 'parent', 'billing_contact'
        ];
        return _this;
    }
    CustomersList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.loadTags()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.loadActivities()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.loadOrigins()];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.loadCustomerTypes()];
                    case 6:
                        _a.sent();
                        this.loading = false;
                        interface_vue_.emitter.on('customerCreated', this.customerCreated);
                        interface_vue_.emitter.on('customerUpdated', this.customerUpdated);
                        interface_vue_.emitter.on('customerDeleted', this.customerDeleted);
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomersList.prototype.destroyed = function () {
        interface_vue_.emitter.off('customerCreated', this.customerCreated);
        interface_vue_.emitter.off('customerUpdated', this.customerUpdated);
        interface_vue_.emitter.off('customerDeleted', this.customerDeleted);
    };
    Object.defineProperty(CustomersList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            var actions = [];
            if (this.can(this.type, 3)) {
                actions.push({
                    icon: 'edit',
                    click: function (customer, index) {
                        _this.openModal({
                            key: _this.type + '-form',
                            value: customer,
                            submitted: function (response) {
                                var table = _this.$refs.table;
                                table.updateRow(index, response.data);
                            }
                        });
                    }
                });
            }
            if (this.can(this.type, 4)) {
                actions.push({
                    icon: 'delete',
                    click: function (customer, index) {
                        _this.toDelete(customer, index);
                    }
                });
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomersList.prototype, "columns", {
        get: function () {
            var columns = [];
            columns.push.apply(columns, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    data: 'reference.' + this.type,
                    name: this.$t('customers.' + this.type + '.listReference')
                },
                {
                    data: 'type.label',
                    name: this.$t('customers.list.customerType'),
                    visible: false
                },
                {
                    data: 'name',
                    name: this.$t('customers.list.name'),
                    sticky: true
                },
                {
                    data: 'company_name',
                    name: this.$t('customers.list.companyName'),
                    visible: false
                },
                {
                    data: 'civility.label',
                    name: this.$t('customers.list.civility'),
                    visible: false
                },
                {
                    data: 'firstname',
                    name: this.$t('customers.list.firstname'),
                    visible: false
                },
                {
                    data: 'lastname',
                    name: this.$t('customers.list.lastname'),
                    visible: false
                },
                {
                    data: 'birth_date',
                    name: this.$t('customers.list.birthDate'),
                    visible: false,
                    render: 'date'
                },
                {
                    data: 'activity.label',
                    name: this.$t('customers.list.activity')
                },
                {
                    data: 'origin.label',
                    name: this.$t('customers.list.origin')
                },
                {
                    data: 'address_invoice.road1',
                    name: this.$t('customers.list.addressRoad1'),
                    visible: false
                },
                {
                    data: 'address_invoice.road2',
                    name: this.$t('customers.list.addressRoad2'),
                    visible: false
                },
                {
                    data: 'address_invoice.road3',
                    name: this.$t('customers.list.addressRoad3'),
                    visible: false
                },
                {
                    data: 'address_invoice.postal_code',
                    name: this.$t('customers.list.postalCode')
                },
                {
                    data: 'address_invoice.town',
                    name: this.$t('customers.list.city')
                },
                {
                    data: 'address_invoice.country.name',
                    name: this.$t('customers.list.country')
                },
                {
                    data: 'phone',
                    name: this.$t('customers.list.phone'),
                    render: 'phone'
                },
                {
                    data: 'mobile',
                    name: this.$t('customers.list.mobile'),
                    render: 'phone'
                },
                {
                    data: 'fax',
                    name: this.$t('customers.list.fax'),
                    visible: false,
                    render: 'phone'
                },
                {
                    data: 'email',
                    name: this.$t('customers.list.email')
                },
                {
                    data: 'website',
                    name: this.$t('customers.list.website'),
                    visible: false
                },
                {
                    data: 'team_user.fullname',
                    name: this.$t('customers.list.commercial')
                },
                {
                    data: 'tags',
                    name: this.$t('customers.list.tags'),
                    render: function (tags) { return tags.map(function (tag) { return tag.name; }).join(', '); },
                    sortable: false
                },
                {
                    data: 'company_siret',
                    name: this.$t('customers.list.siret'),
                    visible: false
                },
                {
                    data: 'company_vatrate',
                    name: this.$t('customers.list.vatrate'),
                    visible: false
                },
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    visible: false,
                    render: 'datetime'
                },
                {
                    data: 'updated_at',
                    name: this.$t('interface.list.updatedAt'),
                    visible: false,
                    render: 'datetime'
                }
            ], this.customFieldTableColumns(this.type)));
            if (this.type === 'customer') {
                columns.push.apply(columns, [
                    {
                        data: 'customer_account',
                        name: this.$t('customers.list.customerAccount'),
                        visible: false
                    },
                    {
                        data: 'transformed_at',
                        name: this.$t('customers.item.transformedAt'),
                        visible: false,
                        render: 'datetime'
                    },
                    {
                        data: 'sales_statistics.total',
                        name: this.$t('customers.list.salesStatistics'),
                        visible: false,
                        render: 'currency'
                    },
                    {
                        data: 'sales_statistics.previous_year',
                        name: this.$t('customers.list.salesStatisticsPreviousYear'),
                        visible: false,
                        render: 'currency'
                    },
                    {
                        data: 'sales_statistics.current_year',
                        name: this.$t('customers.list.salesStatisticsCurrentYear'),
                        visible: false,
                        render: 'currency'
                    },
                    {
                        data: 'sales_statistics.to_paid',
                        name: this.$t('customers.list.toPaid'),
                        visible: false,
                        render: 'currency'
                    },
                    {
                        data: 'sales_statistics.quotations',
                        name: this.$t('customers.list.waitingQuotations'),
                        visible: false,
                        render: 'currency'
                    },
                    {
                        data: 'company_type',
                        name: 'Type d\'entreprise',
                        visible: false
                    },
                    {
                        data: 'company_rcs',
                        name: 'Numéro RCS',
                        visible: false
                    },
                    {
                        data: 'company_naf',
                        name: 'Code NAF',
                        visible: false
                    },
                    {
                        data: 'company_capital',
                        name: 'Capital',
                        visible: false
                    }
                ]);
            }
            if (this.type === 'provider') {
                columns.push({
                    data: 'provider_account',
                    name: this.$t('customers.list.providerAccount'),
                    visible: false
                });
            }
            if (this.hasModule('customers-group')) {
                columns.push({
                    data: 'parent.name',
                    name: this.teamConfigs.customer_group_parent_name
                });
            }
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomersList.prototype, "filters", {
        get: function () {
            var filters = (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    type: 'phone',
                    label: this.$t('customers.filters.phone'),
                    name: 'phone_number'
                },
                {
                    type: 'phone',
                    label: this.$t('customers.filters.mobile'),
                    name: 'mobile_number'
                },
                {
                    type: 'phone',
                    label: this.$t('customers.filters.allPhone'),
                    name: 'all_phone_number'
                },
                {
                    type: 'phone',
                    label: this.$t('customers.list.fax'),
                    name: 'fax_number'
                },
                {
                    type: 'period',
                    label: this.$t('interface.list.createdAt'),
                    name: 'created_since',
                    name2: 'created_until'
                },
                {
                    type: 'text',
                    label: this.$t('customers.filters.companyName'),
                    name: 'company_name'
                },
                {
                    type: 'text',
                    label: this.$t('customers.filters.lastname'),
                    name: 'lastname'
                },
                {
                    type: 'text',
                    label: this.$t('customers.list.siret'),
                    name: 'company_siret'
                },
                {
                    type: 'text',
                    label: this.$t('customers.list.vatrate'),
                    name: 'company_vatrate'
                },
                {
                    type: 'text',
                    label: this.$t('customers.list.email'),
                    name: 'email_address'
                },
                {
                    type: 'text',
                    label: this.$t('customers.list.website'),
                    name: 'website'
                },
                {
                    type: 'text',
                    label: this.$t('customers.' + this.type + '.listReference'),
                    name: this.type + '_reference'
                },
                {
                    type: 'text',
                    label: this.$t('customers.list.city'),
                    name: 'invoice_address_town'
                },
                {
                    type: 'text',
                    label: this.$t('customers.list.postalCode'),
                    name: 'invoice_address_postal_code'
                },
                {
                    type: 'select',
                    label: this.$t('customers.list.country'),
                    name: 'invoice_address_country',
                    options: this.countries,
                    multiple: true,
                    optionLabel: 'name',
                    value: 'code'
                },
                {
                    type: 'select',
                    label: this.$t('customers.list.origin'),
                    name: 'origin',
                    options: this.origins,
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('customers.list.customerType'),
                    name: 'customer_type',
                    options: this.customerTypes,
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('customers.list.activity'),
                    name: 'activity',
                    options: this.activities,
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('customers.filters.allTags'),
                    name: 'all_tags',
                    options: this.tags,
                    multiple: true,
                    optionLabel: 'name',
                    value: 'name'
                },
                {
                    type: 'select',
                    label: this.$t('customers.list.tags'),
                    name: 'any_tags',
                    options: this.tags,
                    multiple: true,
                    optionLabel: 'name',
                    value: 'name'
                },
                {
                    type: 'select',
                    label: this.$t('customers.list.commercial'),
                    name: 'team_user',
                    options: this.teamUsers,
                    multiple: true,
                    optionLabel: 'fullname',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('customers.filters.archived'),
                    name: 'archived',
                    options: [
                        { value: false, label: this.$t('interface.no') },
                        { value: true, label: this.$t('interface.yes') }
                    ],
                    defaultValue: { value: false, label: this.$t('interface.no') },
                    optionLabel: 'label',
                    value: 'value',
                    params: {
                        clearable: false
                    }
                }
            ], this.customFieldTableFilters(this.type));
            if (this.hasModule('customers-group')) {
                filters.push({
                    type: 'select',
                    label: this.teamConfigs.customer_group_parent_name,
                    name: 'hasParent',
                    multiple: true,
                    ajax: '/customer?sort=name',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomersList.prototype, "ajaxDatas", {
        get: function () {
            var _a;
            var datas = {
                include: this.include.join(','),
                filter: (_a = {},
                    _a['is_' + this.type] = true,
                    _a)
            };
            if (this.parent) {
                datas.filter.hasParent = this.parent;
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    CustomersList.prototype.rowLink = function (customer) {
        return {
            name: 'contacts-customer-item',
            params: {
                id: String(customer.id),
                type: this.type
            }
        };
    };
    CustomersList.prototype.toDelete = function (customer, index) {
        this.deleteCustomer = customer;
        this.deleteIndex = index;
    };
    CustomersList.prototype.deleted = function () {
        if (this.deleteIndex !== null) {
            var table = this.$refs.table;
            table.deleteRow(this.deleteIndex);
            this.deleteIndex = null;
            this.deleteCustomer = null;
        }
    };
    CustomersList.prototype.customerIsConcerned = function (customer) {
        var isConcerned;
        switch (this.type) {
            case 'customer':
                isConcerned = customer.reference.customer;
                break;
            case 'subcontractor':
                isConcerned = customer.reference.subcontractor;
                break;
            case 'prospect':
                isConcerned = customer.reference.prospect;
                break;
            case 'provider':
                isConcerned = customer.reference.provider;
                break;
        }
        return isConcerned !== undefined && isConcerned !== null && isConcerned !== '';
    };
    CustomersList.prototype.customerCreated = function (customer) {
        if (this.customerIsConcerned(customer)) {
            var table = this.$refs.table;
            table.addRow(customer);
        }
    };
    CustomersList.prototype.customerUpdated = function (event) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === event.new.id; });
        var isConcerned = this.customerIsConcerned(event.new);
        if (index >= 0) {
            if (isConcerned) {
                table.updateRow(index, event.new);
            }
            else {
                table.deleteRow(index);
            }
        }
        else if (isConcerned) {
            table.addRow(event.new);
        }
    };
    CustomersList.prototype.customerDeleted = function (customer) {
        var _a;
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === customer.id; });
        if (index >= 0) {
            table.deleteRow(index);
            if (((_a = this.deleteCustomer) === null || _a === void 0 ? void 0 : _a.id) === customer.id) {
                this.deleteCustomer = null;
                this.deleteIndex = null;
            }
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomersList.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomersList.prototype, "parent", void 0);
    CustomersList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('globalDatas', ['loadCountries', 'loadTeamUsers', 'loadTags'])), (0,external_vuex_.mapActions)('customers', ['loadOrigins', 'loadActivities', 'loadCustomerTypes'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['countries', 'teamUsers', 'tags'])), (0,external_vuex_.mapState)('customers', ['origins', 'activities', 'customerTypes'])), (0,external_vuex_.mapGetters)('user', ['can', 'teamConfigs'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                CustomerDelete: CustomerDelete/* default */.A,
                KTable: table_vue_.KTable,
                Spinner: interface_vue_.Spinner
            }
        })
    ], CustomersList);
    return CustomersList;
}((0,lib/* Mixins */.Xe)(custom_fields_vue_.CustomFieldsTableMixin)));
/* harmony default export */ var CustomersListvue_type_script_lang_ts_external = (CustomersList);

;// ./src/components/CustomersList/CustomersList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomersList_CustomersListvue_type_script_lang_ts_external = (CustomersListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomersList/CustomersList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomersList_CustomersListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomersList_CustomersList = (component.exports);

/***/ }),

/***/ 197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerItem_CustomerItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerItem/CustomerItem.vue?vue&type=template&id=4e829b4f
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"page-title":_vm.pageTitle,"buttons":_vm.headerButtons}}),_c('AppMessages'),(_vm.value.archived_at)?_c('b-alert',{staticClass:"text-center mx-auto",attrs:{"show":"","variant":"danger"}},[_c('p',{staticClass:"mb-2"},[_vm._v(" "+_vm._s(_vm.$t('customers.item.isArchived'))+" ")]),_c('CustomerArchivate',{attrs:{"value":_vm.value,"element":"button","variant":"secondary","size":"sm"},on:{"input":customer => _vm.$emit('input', customer)}})],1):_vm._e(),_c('b-row',[_c('b-col',{attrs:{"lg":"4","xxl":"3"}},[_c('CustomerInformations',{ref:"infos",attrs:{"type":_vm.type,"value":_vm.value},on:{"input":customer => _vm.$emit('input', customer)}})],1),_c('b-col',{staticClass:"mt-lg-0 mt-4",attrs:{"lg":"8","xxl":"9"}},[_c('tabs',{staticClass:"tabs-card",scopedSlots:_vm._u([{key:"sales",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.sales'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalSales)+" ")])]},proxy:true},{key:"provider",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.provider.label'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalProvider)+" ")])]},proxy:true},(_vm.hasModule('construction') && _vm.can('construction', 1) && (_vm.teamConfigs.construction_show_planifications_customer || _vm.teamConfigs.construction_active_contacts))?{key:"constructions",fn:function(){return [_vm._v(" "+_vm._s(_vm.upperFirst(_vm.termText('planification.tabTitle', 'chantier', true)))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalConstructionsGroup)+" ")])]},proxy:true}:null],null,true),model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('tab',{attrs:{"title":_vm.$t('customers.item.elements')}},[_c('AgregateDatas',{attrs:{"type":"customer","id":_vm.value.id,"model":_vm.value,"customer":_vm.value,"modelTitle":_vm.value.name},on:{"loaded":_vm.agregateLoaded}})],1),(_vm.can('admin-subscription', 1) && _vm.value.admin_team_id)?_c('tab',{attrs:{"title":_vm.$t('customers.item.subscription'),"lazy":""}},[_c('TeamManagement',{attrs:{"value":{ id: _vm.value.admin_team_id }},on:{"deleted":_vm.teamDeleted}})],1):_vm._e(),_c('tab',{attrs:{"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.contact.menu'))+" "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":_vm.activeTab === 1 ? 'primary' : 'secondary'}},[_vm._v(" "+_vm._s(_vm.totalContacts)+" ")]),(_vm.can('contact', 1))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0 pl-1",attrs:{"variant":"icon","title":_vm.$t('customers.contact.addLabel')},on:{"click":_vm.newContact}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1):_vm._e()]},proxy:true}])},[_c('CustomerContacts',{attrs:{"customer":_vm.value},on:{"totalUpdated":total => _vm.totalContacts = total}})],1),(_vm.hasModule('automotive'))?_c('tab',{attrs:{"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Véhicules "),_c('b-badge',{staticClass:"ml-1",attrs:{"variant":_vm.activeTab === 1 ? 'primary' : 'secondary'}},[_vm._v(" "+_vm._s(_vm.totalCars)+" ")]),(_vm.can(_vm.type, 3))?_c('CarFormButton',{staticClass:"p-0 pl-1",attrs:{"customer":_vm.value,"variant":"icon","addIcon":"plus-circle","size":"sm"}}):_vm._e()]},proxy:true}],null,false,3034076092)},[_c('CarList',{attrs:{"customer":_vm.value},on:{"totalUpdated":total => _vm.totalContacts = total}}),_vm._v("CarList ")],1):_vm._e(),(_vm.value.custom_fields.length > 0 && _vm.team.configs['custom_field_' + _vm.type + '_tab'])?_c('CustomFieldsDisplayTab',{attrs:{"type":_vm.type,"value":_vm.value.custom_fields,"formUrl":'/customer/' + _vm.value.id,"component":"tab","canUpdate":_vm.can(_vm.type, 3)},on:{"input":customer => _vm.$emit('input', customer)}}):_vm._e(),(_vm.hasModule('opportunities') && (_vm.value.reference.prospect || _vm.value.reference.customer) && _vm.can('opportunities', 1))?_c('tab',{attrs:{"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.opportunities'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalOpportunities)+" ")]),(_vm.can('opportunities', 2))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0 pl-1",attrs:{"variant":"icon","title":"Créer une opportunité"},on:{"click":_vm.newOpportunity}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1):_vm._e()]},proxy:true}],null,false,3202263086)},[_c('OpportunityList',{attrs:{"customer":_vm.value,"withoutPageTitle":"","customStateKey":"customer-opportunities","disableMainSearchSave":""}})],1):_vm._e(),(_vm.hasModule('sales-contracts') && (_vm.value.reference.prospect || _vm.value.reference.customer) && _vm.can('sales-contracts', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.contracts'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalContracts)+" ")]),(_vm.can('sales-contracts', 2))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0 pl-1",attrs:{"variant":"icon","title":"Créer un contrat"},on:{"click":_vm.newContract}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1):_vm._e()]},proxy:true}],null,false,560742435)},[_c('ContractList',{attrs:{"customerId":_vm.value.id,"customStateKey":"customer-contracts","disableMainSearchSave":""}})],1):_vm._e(),(_vm.hasModule('sales-sepa') && (_vm.value.reference.prospect || _vm.value.reference.customer) && _vm.can('sales-invoice', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.sepa'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalSepa)+" ")])]},proxy:true}],null,false,3866857678)},[_c('CustomerSepaList',{attrs:{"customerId":_vm.value.id}})],1):_vm._e(),((_vm.value.reference.prospect || _vm.value.reference.customer) && _vm.can('sales-quotation', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.quotations'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalQuotations)+" ")]),(_vm.can('sales-quotation', 2))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0 pl-1",attrs:{"variant":"icon","title":"Créer un devis"},on:{"click":function($event){return _vm.newDocument('quotation')}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1):_vm._e()]},proxy:true}],null,false,271671493)},[_c('QuotationList',{attrs:{"customer":_vm.value.id,"customStateKey":"customer-quotation","disableMainSearchSave":""}})],1):_vm._e(),(_vm.hasModule('sales-commands') && (_vm.value.reference.prospect || _vm.value.reference.customer) && _vm.can('sales-command', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.commands'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalCommands)+" ")]),(_vm.can('sales-command', 2))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0 pl-1",attrs:{"variant":"icon","title":"Créer un bon de commande"},on:{"click":function($event){return _vm.newDocument('command')}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1):_vm._e()]},proxy:true}],null,false,1458699752)},[_c('CommandList',{attrs:{"customer":_vm.value.id,"customStateKey":"customer-command","disableMainSearchSave":""}})],1):_vm._e(),(_vm.hasModule('sales-deliveries') && (_vm.value.reference.prospect || _vm.value.reference.customer) && _vm.can('sales-delivery', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.deliveries'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalDeliveries)+" ")]),(_vm.can('sales-delivery', 2))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0 pl-1",attrs:{"variant":"icon","title":"Créer un bon de livraison"},on:{"click":function($event){return _vm.newDocument('delivery')}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1):_vm._e()]},proxy:true}],null,false,4057312977)},[_c('DeliveryList',{attrs:{"customer":_vm.value.id,"customStateKey":"customer-delivery","disableMainSearchSave":""}})],1):_vm._e(),(_vm.hasModule('sales-proformas') && (_vm.value.reference.prospect || _vm.value.reference.customer) && _vm.can('sales-proforma', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.proformas'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalProformas)+" ")]),(_vm.can('sales-proforma', 2))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0 pl-1",attrs:{"variant":"icon","title":"Créer une facture proforma"},on:{"click":function($event){return _vm.newDocument('proforma')}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1):_vm._e()]},proxy:true}],null,false,3753527173)},[_c('ProformaList',{attrs:{"customer":_vm.value.id,"customStateKey":"customer-proforma","disableMainSearchSave":""}})],1):_vm._e(),(_vm.value.reference.customer && _vm.can('sales-invoice', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.invoices'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalInvoices)+" ")]),(_vm.can('sales-invoice', 2))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0 pl-1",attrs:{"variant":"icon","title":"Créer une facture"},on:{"click":function($event){return _vm.newDocument('invoice')}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1):_vm._e()]},proxy:true}],null,false,3159634303)},[_c('InvoiceList',{attrs:{"customer":_vm.value.id,"customStateKey":"customer-invoice","disableMainSearchSave":""}})],1):_vm._e(),(_vm.value.reference.customer && _vm.can('sales-credit', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.credits'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalCredits)+" ")]),(_vm.can('sales-credit', 2))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0 pl-1",attrs:{"variant":"icon","title":"Créer un avoir"},on:{"click":function($event){return _vm.newDocument('credit')}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})],1):_vm._e()]},proxy:true}],null,false,3116614091)},[_c('CreditList',{attrs:{"customer":_vm.value.id,"customStateKey":"customer-credit","disableMainSearchSave":""}})],1):_vm._e(),(_vm.value.reference.customer && _vm.can('invoice-quotation', 1))?_c('tab',{attrs:{"groupSlot":"sales","title":_vm.$t('customers.item.payments'),"groupDividerBefore":"","lazy":""}}):_vm._e(),(_vm.value.reference.provider && (_vm.hasModule('stock') || _vm.hasModule('charges') && _vm.can('catalog-products', 1)))?_c('tab',{attrs:{"groupSlot":"provider","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.catalog'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalProducts)+" ")])]},proxy:true}],null,false,983682789)},[_c('ProductList',{attrs:{"provider":_vm.value.id,"stateKey":"provider-products","disableMainSearchSave":""}})],1):_vm._e(),(_vm.value.reference.provider && _vm.hasModule('stock') && _vm.can('see-stock', 1))?_c('tab',{attrs:{"groupSlot":"provider","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.catalogCommands'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalProviderCommands)+" ")])]},proxy:true}],null,false,1427782524)},[_c('ProviderCommandList',{attrs:{"provider":_vm.value.id,"customStateKey":"provider-commands","disableMainSearchSave":""}})],1):_vm._e(),(_vm.value.reference.provider && _vm.hasModule('charges') && _vm.can('charges', 1))?_c('tab',{attrs:{"groupSlot":"provider","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.charges'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalCharges)+" ")])]},proxy:true}],null,false,591618062)},[_c('ChargesList',{attrs:{"provider":_vm.value.id,"customStateKey":"provider-charges","disableMainSearchSave":""}})],1):_vm._e(),(_vm.hasModule('construction') && _vm.can('construction', 1))?[_c('tab',{attrs:{"lazy":"","groupSlot":_vm.teamConfigs.construction_show_planifications_customer || _vm.teamConfigs.construction_active_contacts ? 'constructions' : null},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.upperFirst(_vm.termText('planification.tabTitle', 'chantier', true)))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalConstructions)+" ")])]},proxy:true}],null,false,2379595282)},[_c('ConstructionList',{attrs:{"customer":_vm.value}})],1),(_vm.teamConfigs.construction_show_planifications_customer)?_c('tab',{attrs:{"lazy":"","groupSlot":_vm.teamConfigs.construction_show_planifications_customer || _vm.teamConfigs.construction_active_contacts ? 'constructions' : null},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.upperFirst(_vm.termText('planification.tabTitle', 'planning', true)))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalPlanifications)+" ")])]},proxy:true}],null,false,529019351)},[_c('PlanificationList',{attrs:{"customer":_vm.value}})],1):_vm._e(),(_vm.teamConfigs.construction_active_contacts)?_c('tab',{attrs:{"lazy":"","groupSlot":_vm.teamConfigs.construction_show_planifications_customer || _vm.teamConfigs.construction_active_contacts ? 'constructions' : null},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Contact chantiers "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalConstructionsContacts)+" ")])]},proxy:true}],null,false,1742352944)},[_c('ConstructionList',{attrs:{"contactCustomerId":_vm.value.id}})],1):_vm._e()]:_vm._e(),(_vm.hasModule('tickets') && _vm.can('tickets', 1))?_c('tab',{attrs:{"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Tickets "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalTickets)+" ")]),(_vm.can('tickets', 2))?_c('TicketForm',{attrs:{"isIcon":"","value":{ customer: _vm.value }}}):_vm._e()]},proxy:true}],null,false,1175492571)},[_c('TicketsList',{attrs:{"customer":_vm.value}})],1):_vm._e()],2)],1)],1),_c('FormModal',{attrs:{"title":_vm.$t('customers.salesPreferences.title'),"size":"lg"},model:{value:(_vm.salePreferencesModal),callback:function ($$v) {_vm.salePreferencesModal=$$v},expression:"salePreferencesModal"}},[_c('CustomerSaleParams',{attrs:{"value":_vm.value},on:{"input":customer => _vm.$emit('input', customer)}})],1),_c('FormModal',{attrs:{"title":_vm.$t('customers.chargesPreferences.title'),"size":"lg"},model:{value:(_vm.chargePreferencesModal),callback:function ($$v) {_vm.chargePreferencesModal=$$v},expression:"chargePreferencesModal"}},[_c('CustomerChargeParams',{attrs:{"value":_vm.value},on:{"input":customer => _vm.$emit('input', customer)}})],1),(_vm.can('admin-subscription', 1) && !_vm.value.admin_team_id)?_c('CreateTeamForm',{attrs:{"modal":_vm.adminTeamFormModal,"customer":_vm.value},on:{"created":_vm.adminAccountCreated,"hidden":function($event){_vm.adminTeamFormModal = false}}}):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/CustomerContacts/CustomerContacts.vue + 3 modules
var CustomerContacts = __webpack_require__(8402);
// EXTERNAL MODULE: ./src/components/CustomerDelete/CustomerDelete.vue + 3 modules
var CustomerDelete = __webpack_require__(3878);
// EXTERNAL MODULE: ./src/components/CustomerArchivate/CustomerArchivate.vue + 3 modules
var CustomerArchivate = __webpack_require__(8031);
// EXTERNAL MODULE: ./src/components/CustomerReference/CustomerReference.vue + 3 modules
var CustomerReference = __webpack_require__(5950);
// EXTERNAL MODULE: ./src/components/CustomerMerge/CustomerMerge.vue + 3 modules
var CustomerMerge = __webpack_require__(6867);
// EXTERNAL MODULE: ./src/components/CustomerInformations/CustomerInformations.vue + 3 modules
var CustomerInformations = __webpack_require__(5278);
// EXTERNAL MODULE: ./src/components/CustomerSaleParams/CustomerSaleParams.vue + 3 modules
var CustomerSaleParams = __webpack_require__(5911);
// EXTERNAL MODULE: ./src/components/CustomerChargeParams/CustomerChargeParams.vue + 3 modules
var CustomerChargeParams = __webpack_require__(3407);
// EXTERNAL MODULE: external "@kwixeo/calendars-vue"
var calendars_vue_ = __webpack_require__(9792);
;// external "@kwixeo/catalog-vue"
var catalog_vue_namespaceObject = require("@kwixeo/catalog-vue");
// EXTERNAL MODULE: external "@kwixeo/communication-vue"
var communication_vue_ = __webpack_require__(3055);
// EXTERNAL MODULE: external "@kwixeo/sales-vue"
var sales_vue_ = __webpack_require__(2779);
// EXTERNAL MODULE: external "@kwixeo/opportunities-vue"
var opportunities_vue_ = __webpack_require__(8266);
;// external "@kwixeo/charges-vue"
var charges_vue_namespaceObject = require("@kwixeo/charges-vue");
// EXTERNAL MODULE: external "@kwixeo/subscriptions-vue"
var subscriptions_vue_ = __webpack_require__(8129);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: external "@kwixeo/tickets-vue"
var tickets_vue_ = __webpack_require__(8742);
// EXTERNAL MODULE: external "@kwixeo/constructions-vue"
var constructions_vue_ = __webpack_require__(3781);
// EXTERNAL MODULE: ./node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__(5808);
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);
// EXTERNAL MODULE: ./src/components/CustomerSpeedItem/CustomerSpeedItem.vue + 3 modules
var CustomerSpeedItem = __webpack_require__(2930);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerPdf/CustomerPdf.vue?vue&type=template&id=57d35fe7
var CustomerPdfvue_type_template_id_57d35fe7_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" Exporter la fiche en PDF "),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.close'),"ok-only":"","body-class":"pb-2"},on:{"hidden":_vm.closeModal},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('Spinner'),_vm._v(" Génération du PDF en cours... ")],1):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:_c('div',{staticClass:"text-center"},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"secondary"},on:{"click":_vm.send}},[_vm._v(" Envoyer par email ")]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.download}},[_vm._v(" "+_vm._s(_vm.$t('interface.download'))+" ")]),_c('b-button',{staticClass:"mt-4",attrs:{"variant":"link","size":"sm","to":{ name: 'tiers-params' },"target":"_blank"}},[_vm._v(" Personnaliser le fichier PDF ")])],1)],2)],1)
}
var CustomerPdfvue_type_template_id_57d35fe7_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerPdf/CustomerPdf.ts?vue&type=script&lang=ts&external





var CustomerPdf = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerPdf, _super);
    function CustomerPdf() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.modalState = false;
        _this.errorMsg = null;
        _this.file = null;
        return _this;
    }
    Object.defineProperty(CustomerPdf.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    CustomerPdf.prototype.watchModalState = function (state, old) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(state && !old)) return [3 /*break*/, 2];
                        this.loading = true;
                        return [4 /*yield*/, this.process()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CustomerPdf.prototype.process = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.errorMsg) {
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        return [4 /*yield*/, this.$kwSales.axios.get('/customer/' + this.customer.id + '/pdf')
                                .then(function (response) {
                                _this.file = response.data;
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                _this.errorMsg = error.response.data.message;
                                _this.file = null;
                                throw new Error(error);
                            })
                                .then(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerPdf.prototype.closeModal = function () {
        this.errorMsg = null;
        return false;
    };
    CustomerPdf.prototype.download = function () {
        var _a, _b;
        this.downloadFile((_a = this.file) === null || _a === void 0 ? void 0 : _a.file, (_b = this.file) === null || _b === void 0 ? void 0 : _b.filename);
    };
    CustomerPdf.prototype.send = function () {
        var _a, _b;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var datas;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadSenders()];
                    case 1:
                        _c.sent();
                        datas = new FormData();
                        if (this.defaultSender) {
                            datas.append('sender', String(this.defaultSender.id));
                        }
                        datas.append('elements[0][id]', String(this.customer.id));
                        datas.append('elements[0][type]', 'customer');
                        datas.append('add_attachments[0]', new File([this.base64ToBlob((_a = this.file) === null || _a === void 0 ? void 0 : _a.file)], (_b = this.file) === null || _b === void 0 ? void 0 : _b.filename, { type: 'application/pdf' }));
                        return [4 /*yield*/, this.$kwSales.axios.post('/mail/draft', datas, { headers: { 'Content-Type': 'multipart/form-data' } })
                                .then(function (response) {
                                _this.openMailForm({
                                    customer: _this.customer,
                                    mail: response.data
                                });
                                _this.modalState = false;
                                _this.loading = false;
                            })];
                    case 2:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerPdf.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], CustomerPdf.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerPdf.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], CustomerPdf.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], CustomerPdf.prototype, "closeModal", null);
    CustomerPdf = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal, BButton: external_bootstrap_vue_.BButton
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['openMailForm', 'loadSenders'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('communication', ['defaultSender'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CustomerPdf);
    return CustomerPdf;
}((0,lib/* Mixins */.Xe)(interface_vue_.FileMixin)));
/* harmony default export */ var CustomerPdfvue_type_script_lang_ts_external = (CustomerPdf);

;// ./src/components/CustomerPdf/CustomerPdf.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerPdf_CustomerPdfvue_type_script_lang_ts_external = (CustomerPdfvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerPdf/CustomerPdf.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerPdf_CustomerPdfvue_type_script_lang_ts_external,
  CustomerPdfvue_type_template_id_57d35fe7_render,
  CustomerPdfvue_type_template_id_57d35fe7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerPdf_CustomerPdf = (component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerItem/CustomerItem.ts?vue&type=script&lang=ts&external



























var CustomerItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerItem, _super);
    function CustomerItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeTab = 0;
        _this.saveTabKey = 'customerTab';
        _this.totalContacts = 0;
        _this.totalQuotations = 0;
        _this.totalCommands = 0;
        _this.totalProformas = 0;
        _this.totalDeliveries = 0;
        _this.totalInvoices = 0;
        _this.totalCredits = 0;
        _this.totalOpportunities = 0;
        _this.totalProducts = 0;
        _this.totalProviderCommands = 0;
        _this.totalCharges = 0;
        _this.totalContracts = 0;
        _this.totalTickets = 0;
        _this.totalConstructions = 0;
        _this.totalPlanifications = 0;
        _this.totalConstructionsContacts = 0;
        _this.totalConstructionsGroup = 0;
        _this.totalSepa = 0;
        _this.totalCars = 0;
        _this.salePreferencesModal = false;
        _this.chargePreferencesModal = false;
        _this.totalSales = 0;
        _this.totalProvider = 0;
        _this.adminTeamFormModal = false;
        return _this;
    }
    CustomerItem.prototype.mounted = function () {
        if (this.setPageTitle !== false) {
            document.title = this.pageTitle;
        }
        interface_vue_.emitter.on('contactCreated', this.contactCreated);
        interface_vue_.emitter.on('contactUpdated', this.contactUpdated);
        interface_vue_.emitter.on('contactDeleted', this.contactDeleted);
        if (this.teamConfigs.params_remember_tab) {
            this.activeTab = Number(localStorage.getItem(this.saveTabKey + '-' + this.type));
        }
    };
    CustomerItem.prototype.destroyed = function () {
        interface_vue_.emitter.off('contactCreated', this.contactCreated);
        interface_vue_.emitter.off('contactUpdated', this.contactUpdated);
        interface_vue_.emitter.off('contactDeleted', this.contactDeleted);
    };
    Object.defineProperty(CustomerItem.prototype, "pageTitle", {
        get: function () {
            var name = this.value.name;
            var type = this.value.type;
            if (type.is_company && type.is_person && this.value.company_name && this.value.lastname) {
                name += ' - ' + [
                    this.value.civility ? this.value.civility.short_name : null,
                    this.value.firstname,
                    this.value.lastname
                ].filter(function (val) { return val !== null; }).join(' ');
            }
            return name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerItem.prototype, "headerButtons", {
        get: function () {
            var _this = this;
            var buttons = [];
            if (this.can(this.type, 3)) {
                buttons.push.apply(buttons, [
                    {
                        label: this.$t('interface.edit'),
                        click: function () {
                            _this.openModal({
                                key: _this.type + '-form',
                                value: _this.value,
                                submitted: function (response) {
                                    _this.$emit('input', response.data);
                                }
                            });
                        }
                    },
                    {
                        label: this.$t('customers.item.' + this.type + 'Item'),
                        items: this.customerActions
                    }
                ]);
            }
            if (this.hasModule('task') && this.can('task', 1)) {
                buttons.push({
                    label: this.$t('tasks.newBtn'),
                    click: this.newTask
                });
            }
            var relations = [];
            if (this.can('send-mail', 1)) {
                relations.push({
                    component: communication_vue_.SendEmailButton,
                    attributes: {
                        customer: this.value,
                        element: 'dropdown'
                    }
                });
            }
            if (this.hasModule('communication-reports') && this.can('communication-reports', 1)) {
                relations.push({
                    component: communication_vue_.ReportFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Compte-rendu',
                        customer: this.value,
                        linkedElements: this.linkedElements
                    }
                });
            }
            if (this.hasModule('communication-letters') && this.can('communication-letters', 1)) {
                relations.push({
                    component: communication_vue_.LetterFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Lettre',
                        customer: this.value,
                        linkedElements: this.linkedElements
                    }
                });
            }
            if (this.hasModule('calendar') && this.can('calendar', 1)) {
                relations.push({
                    component: calendars_vue_.CalendarButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Rendez-vous',
                        linkedElements: this.linkedElements
                    }
                });
            }
            if (relations.length > 1) {
                buttons.push.apply(buttons, [
                    {
                        label: 'Relation',
                        items: relations
                    }
                ]);
            }
            else if (this.can('send-mail', 1)) {
                buttons.push({
                    component: communication_vue_.SendEmailButton,
                    attributes: {
                        customer: this.value,
                        element: 'button'
                    }
                });
            }
            var actions = [];
            if (this.value.reference.customer || this.value.reference.prospect) {
                if (this.hasModule('opportunities') && this.can('opportunities', 2)) {
                    actions.push.apply(actions, [
                        {
                            label: 'Opportunité',
                            click: this.newOpportunity
                        },
                        { isSeparator: true }
                    ]);
                }
                if (this.can('sales-quotation', 2)) {
                    actions.push({
                        label: 'Devis',
                        click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.newDocument('quotation')];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    });
                }
                if (this.hasModule('sales-commands') && this.can('sales-command', 2)) {
                    actions.push({
                        label: 'Bon de commande',
                        click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.newDocument('command')];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    });
                }
                if (this.hasModule('sales-deliveries') && this.can('sales-delivery', 2)) {
                    actions.push({
                        label: 'Bon de livraison',
                        click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.newDocument('delivery')];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    });
                }
                if (this.hasModule('sales-proformas') && this.can('sales-proforma', 2)) {
                    actions.push({
                        label: 'Facture proforma',
                        click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.newDocument('proforma')];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    });
                }
                if (this.can('sales-invoice', 2)) {
                    actions.push({
                        label: 'Facture',
                        click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.newDocument('invoice')];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    });
                }
                if (this.can('sales-credit', 2)) {
                    actions.push({
                        label: 'Avoir',
                        click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.newDocument('credit')];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    });
                }
                if (this.hasModule('sales-contracts') && this.can('sales-contracts', 2)) {
                    actions.push({
                        label: 'Contrat',
                        click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.newContract()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    });
                }
                if (this.hasModule('tickets') && this.can('tickets', 2)) {
                    actions.push({
                        component: tickets_vue_.TicketForm,
                        attributes: {
                            element: 'dropdown',
                            label: 'Ticket',
                            value: {
                                customer: this.value
                            }
                        }
                    });
                }
            }
            if (this.value.reference.provider && this.hasModule('charges') && this.can('charges', 2)) {
                if (actions.length > 0) {
                    actions.push({ isSeparator: true });
                }
                actions.push({
                    label: 'Charge',
                    click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                        return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.newCharge()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                });
            }
            if (actions.length > 0) {
                buttons.push({
                    label: 'Nouveau',
                    items: actions
                });
            }
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerItem.prototype, "customerActions", {
        get: function () {
            var _this = this;
            var references = this.value.reference;
            var buttons = [];
            if (this.can('admin-subscription', 1) && !this.value.admin_team_id) {
                buttons.push.apply(buttons, [
                    {
                        label: 'Créer un compte APP',
                        click: function () {
                            _this.adminTeamFormModal = true;
                        }
                    },
                    {
                        isSeparator: true
                    }
                ]);
            }
            buttons.push.apply(buttons, [
                {
                    label: this.$t('customers.item.addContact'),
                    click: this.newContact
                },
                {
                    label: this.$t('interface.files.addFiles'),
                    click: function () { return interface_vue_.emitter.emit('selectFiles-customer-' + _this.value.id); }
                },
                {
                    label: this.$t('customers.address.manage'),
                    click: function () {
                        var component = _this.$refs.infos;
                        component.showCustomerAddresses = true;
                    }
                },
                {
                    isSeparator: true
                }
            ]);
            if ((references.prospect || references.customer) && this.can(this.type, 3)) {
                buttons.push({
                    label: this.$t('customers.item.salesPreferences'),
                    click: function () {
                        _this.salePreferencesModal = true;
                    }
                });
            }
            if (references.provider && this.can(this.type, 3)) {
                buttons.push({
                    label: this.$t('customers.item.chargesPreferences'),
                    click: function () {
                        _this.chargePreferencesModal = true;
                    }
                });
            }
            buttons.push.apply(buttons, [
                {
                    isSeparator: true
                },
                {
                    component: CustomerPdf_CustomerPdf,
                    attributes: {
                        element: 'dropdown',
                        customer: this.value
                    }
                }
            ]);
            if (this.can(this.type, 4)) {
                buttons.push.apply(buttons, [
                    {
                        label: this.$t('customers.item.merge'),
                        component: CustomerMerge/* default */.A,
                        attributes: {
                            value: this.value,
                            element: 'dropdown'
                        },
                        events: {
                            merged: function (customer) { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                                return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.$router.push({
                                                name: 'contacts-customer-item',
                                                params: {
                                                    id: String(customer.id),
                                                    type: this.type
                                                }
                                            })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }
                    },
                    {
                        component: CustomerArchivate/* default */.A,
                        attributes: {
                            value: this.value,
                            element: 'dropdown'
                        },
                        events: {
                            input: this.customerUpdated
                        }
                    },
                    {
                        label: this.$t('interface.delete'),
                        component: CustomerDelete/* default */.A,
                        attributes: {
                            value: this.value,
                            element: 'dropdown'
                        },
                        events: {
                            deleted: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                                return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.$router.push({
                                                name: 'contacts-' + this.type + 's-list'
                                            })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }
                    },
                    {
                        isSeparator: true
                    }
                ]);
            }
            if (this.can('customer', 2) && (!references.customer || references.provider || references.subcontractor)) {
                buttons.push({
                    component: CustomerReference/* default */.A,
                    attributes: {
                        value: this.value,
                        element: 'dropdown',
                        type: 'customer'
                    },
                    events: {
                        updated: this.customerUpdated
                    }
                });
            }
            if (this.can('prospect', 2) && this.hasModule('customers-prospects') && (!references.prospect || references.customer || references.provider || references.subcontractor)) {
                buttons.push({
                    component: CustomerReference/* default */.A,
                    attributes: {
                        value: this.value,
                        element: 'dropdown',
                        type: 'prospect'
                    },
                    events: {
                        updated: this.customerUpdated
                    }
                });
            }
            if (this.can('provider', 2) && (!references.provider || references.prospect || references.customer || references.subcontractor)) {
                buttons.push({
                    component: CustomerReference/* default */.A,
                    attributes: {
                        value: this.value,
                        element: 'dropdown',
                        type: 'provider'
                    },
                    events: {
                        updated: this.customerUpdated
                    }
                });
            }
            if (this.can('subcontractor', 2) && this.hasModule('customers-subcontractors') && (!references.subcontractor || references.prospect || references.customer || references.provider)) {
                buttons.push({
                    component: CustomerReference/* default */.A,
                    attributes: {
                        value: this.value,
                        element: 'dropdown',
                        type: 'subcontractor'
                    },
                    events: {
                        updated: this.customerUpdated
                    }
                });
            }
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerItem.prototype, "linkedElements", {
        get: function () {
            return [{
                    title: this.value.name,
                    type: 'customer',
                    id: this.value.id,
                    data: this.value
                }];
        },
        enumerable: false,
        configurable: true
    });
    CustomerItem.prototype.newContact = function () {
        this.openModal({
            key: 'contact-form',
            attributes: {
                customer: this.value,
                withRedirection: false
            }
        });
    };
    CustomerItem.prototype.newOpportunity = function () {
        this.openModal({
            key: 'opportunity-form',
            value: {
                customer: this.value
            }
        });
    };
    CustomerItem.prototype.newContract = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setPageParams({ customer: this.value });
                        return [4 /*yield*/, this.$router.push({ name: 'contract-form' })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerItem.prototype.newDocument = function (type) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setPageParams({ customer: this.value });
                        return [4 /*yield*/, this.$router.push({ name: type + '-form' })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerItem.prototype.newCharge = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setPageParams({ customer: this.value });
                        return [4 /*yield*/, this.$router.push({ name: 'charges-form' })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Event when a contact is created
    CustomerItem.prototype.contactCreated = function (contact) {
        var _this = this;
        if (contact.customers.find(function (customer) { return customer.id === _this.value.id; })) {
            interface_vue_.emitter.emit('contactTotal', { change: 1 });
        }
    };
    // Event when a contact is updated
    CustomerItem.prototype.contactUpdated = function (event) {
        var _this = this;
        var previous = event.old.customers.find(function (customer) { return customer.id === _this.value.id; });
        var next = event.new.customers.find(function (customer) { return customer.id === _this.value.id; });
        if (previous && !next) {
            interface_vue_.emitter.emit('contactTotal', { change: -1 });
        }
        else if (!previous && next) {
            interface_vue_.emitter.emit('contactTotal', { change: 1 });
        }
    };
    // Event when a contact is deleted
    CustomerItem.prototype.contactDeleted = function (contact) {
        var _this = this;
        if (contact.customers.find(function (customer) { return customer.id === _this.value.id; })) {
            interface_vue_.emitter.emit('contactTotal', { change: -1 });
        }
    };
    // Create a new task
    CustomerItem.prototype.newTask = function () {
        this.openModal({
            key: 'task-form',
            value: {
                elements: this.linkedElements
            }
        });
    };
    CustomerItem.prototype.onActiveTabChange = function () {
        if (this.teamConfigs.params_remember_tab) {
            localStorage.setItem(this.saveTabKey + '-' + this.type, String(this.activeTab));
        }
    };
    CustomerItem.prototype.customerUpdated = function (customer) {
        return customer;
    };
    CustomerItem.prototype.agregateLoaded = function (data) {
        var _a;
        var totals = data.totals;
        this.totalContacts = totals.contact;
        this.totalQuotations = totals.quotation;
        this.totalCommands = totals.command;
        this.totalProformas = totals.proforma;
        this.totalDeliveries = totals.delivery;
        this.totalInvoices = totals.invoice;
        this.totalCredits = totals.credit;
        this.totalOpportunities = totals.opportunity;
        this.totalProducts = totals.product;
        this.totalProviderCommands = totals.provider_command;
        this.totalCharges = totals.charge;
        this.totalContracts = totals.contract;
        this.totalSepa = totals.sepa;
        this.totalCars = totals.car;
        this.totalTickets = totals.ticket;
        this.totalConstructions = totals.construction;
        this.totalConstructionsContacts = (_a = totals.construction_contact) !== null && _a !== void 0 ? _a : 0;
        this.totalPlanifications = totals.planification;
        this.totalSales = 0;
        if (this.value.reference.prospect || this.value.reference.customer) {
            if (this.hasModule('sales-contracts') && this.can('sales-contracts', 1)) {
                this.totalSales += this.totalContracts;
            }
            if (this.hasModule('sales-sepa') && this.can('sales-invoice', 1)) {
                this.totalSales += this.totalSepa;
            }
            if (this.can('sales-quotation', 1)) {
                this.totalSales += this.totalQuotations;
            }
            if (this.hasModule('sales-commands') && this.can('sales-command', 1)) {
                this.totalSales += this.totalCommands;
            }
            if (this.hasModule('sales-deliveries') && this.can('sales-delivery', 1)) {
                this.totalSales += this.totalDeliveries;
            }
            if (this.hasModule('sales-proformas') && this.can('sales-proforma', 1)) {
                this.totalSales += this.totalProformas;
            }
        }
        if (this.value.reference.customer) {
            if (this.can('sales-invoice', 1)) {
                this.totalSales += this.totalInvoices;
            }
            if (this.can('sales-credit', 1)) {
                this.totalSales += this.totalCredits;
            }
        }
        this.totalProvider = 0;
        if (this.value.reference.provider) {
            if ((this.hasModule('stock') || this.hasModule('charges')) && this.can('catalog-products', 1)) {
                this.totalProvider += this.totalProducts;
            }
            if (this.hasModule('stock') && this.can('see-stock', 1)) {
                this.totalProvider += this.totalProviderCommands;
            }
            if (this.hasModule('charges') && this.can('charges', 1)) {
                this.totalProvider += this.totalCharges;
            }
        }
        this.totalConstructionsGroup = 0;
        if (this.hasModule('construction') && this.can('construction', 1)) {
            this.totalConstructionsGroup += this.totalConstructions;
            if (this.teamConfigs.construction_show_planifications_customer) {
                this.totalConstructionsGroup += this.totalPlanifications;
            }
            if (this.teamConfigs.construction_active_contacts) {
                this.totalConstructionsGroup += this.totalConstructionsContacts;
            }
        }
    };
    CustomerItem.prototype.teamDeleted = function () {
        var customer = JSON.parse(JSON.stringify(this.value));
        delete customer.admin_team;
        customer.admin_team_id = null;
        this.$emit('input', customer);
        this.activeTab = 0;
    };
    CustomerItem.prototype.adminAccountCreated = function (team) {
        var customer = JSON.parse(JSON.stringify(this.value));
        customer.admin_team_id = team.id;
        this.$emit('input', customer);
        this.activeTab = 0;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerItem.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerItem.prototype, "setPageTitle", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('activeTab')
    ], CustomerItem.prototype, "onActiveTabChange", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], CustomerItem.prototype, "customerUpdated", null);
    CustomerItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('app', ['setPageParams'])), { termText: constructions_vue_.termText,
                upperFirst: (upperFirst_default()) }),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'team', 'teamConfigs'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                AgregateDatas: communication_vue_.AgregateDatas,
                CustomFieldsDisplayTab: custom_fields_vue_.CustomFieldsDisplayTab,
                CustomerContacts: CustomerContacts/* default */.A, CustomerArchivate: CustomerArchivate/* default */.A, CustomerInformations: CustomerInformations/* default */.A, CustomerSaleParams: CustomerSaleParams/* default */.A, CustomerChargeParams: CustomerChargeParams/* default */.A, CustomerSpeedItem: CustomerSpeedItem/* default */.A, CustomerPdf: CustomerPdf_CustomerPdf,
                CustomerSepaList: sales_vue_.CustomerSepaList, ContractList: sales_vue_.ContractList,
                PageHeader: interface_vue_.PageHeader, Tabs: interface_vue_.Tabs, Tab: interface_vue_.Tab, FormModal: interface_vue_.FormModal,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BBadge: external_bootstrap_vue_.BBadge, BAlert: external_bootstrap_vue_.BAlert, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                QuotationList: sales_vue_.QuotationList, CommandList: sales_vue_.CommandList, ProformaList: sales_vue_.ProformaList, DeliveryList: sales_vue_.DeliveryList, InvoiceList: sales_vue_.InvoiceList, CreditList: sales_vue_.CreditList, CarList: sales_vue_.CarList, CarFormButton: sales_vue_.CarFormButton,
                ProductList: catalog_vue_namespaceObject.ProductList, ProviderCommandList: catalog_vue_namespaceObject.CommandList,
                OpportunityList: opportunities_vue_.OpportunityList,
                ChargesList: charges_vue_namespaceObject.ChargesList,
                TeamManagement: subscriptions_vue_.TeamManagement, CreateTeamForm: subscriptions_vue_.CreateTeamForm,
                TicketForm: tickets_vue_.TicketForm, TicketsList: tickets_vue_.TicketsList,
                ConstructionList: constructions_vue_.ConstructionList, PlanificationList: constructions_vue_.PlanificationList,
                Spinner: interface_vue_.Spinner, AppMessages: interface_vue_.AppMessages
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CustomerItem);
    return CustomerItem;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerItemvue_type_script_lang_ts_external = (CustomerItem);

;// ./src/components/CustomerItem/CustomerItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerItem_CustomerItemvue_type_script_lang_ts_external = (CustomerItemvue_type_script_lang_ts_external); 
;// ./src/components/CustomerItem/CustomerItem.vue





/* normalize component */
;
var CustomerItem_component = (0,componentNormalizer/* default */.A)(
  CustomerItem_CustomerItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerItem_CustomerItem = (CustomerItem_component.exports);

/***/ }),

/***/ 294:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 314:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'caret-up';
var width = 320;
var height = 512;
var ligatures = [];
var unicode = 'f0d8';
var svgPathData = 'M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.S$ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 346:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 361:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 622:
/***/ (function(module) {

"use strict";
module.exports = require("vue");

/***/ }),

/***/ 641:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(6649),
    keys = __webpack_require__(3569);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(8096),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isIndex = __webpack_require__(361),
    isTypedArray = __webpack_require__(7167);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 726:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'search';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f002';
var svgPathData = 'M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Mj = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ProvidersListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ProvidersListView.vue?vue&type=template&id=49f0cd1e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CustomersList',{attrs:{"type":"provider"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CustomersList/CustomersList.vue + 3 modules
var CustomersList = __webpack_require__(45);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ProvidersListView.vue?vue&type=script&lang=ts



var ProvidersListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProvidersListView, _super);
    function ProvidersListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProvidersListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CustomersList: CustomersList/* default */.A
            }
        })
    ], ProvidersListView);
    return ProvidersListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ProvidersListViewvue_type_script_lang_ts = (ProvidersListView);

;// ./src/views/ProvidersListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ProvidersListViewvue_type_script_lang_ts = (ProvidersListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ProvidersListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ProvidersListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ProvidersListView = (component.exports);

/***/ }),

/***/ 877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ProspectsListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ProspectsListView.vue?vue&type=template&id=f461294e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CustomersList',{attrs:{"type":"prospect"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CustomersList/CustomersList.vue + 3 modules
var CustomersList = __webpack_require__(45);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ProspectsListView.vue?vue&type=script&lang=ts



var ProspectsListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ProspectsListView, _super);
    function ProspectsListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProspectsListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CustomersList: CustomersList/* default */.A
            }
        })
    ], ProspectsListView);
    return ProspectsListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ProspectsListViewvue_type_script_lang_ts = (ProspectsListView);

;// ./src/views/ProspectsListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ProspectsListViewvue_type_script_lang_ts = (ProspectsListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ProspectsListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ProspectsListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ProspectsListView = (component.exports);

/***/ }),

/***/ 906:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'plus';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f067';
var svgPathData = 'M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.QL = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(641),
    createBaseEach = __webpack_require__(8329);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 1074:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 1223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerAddressList_CustomerAddressList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerAddressList/CustomerAddressList.vue?vue&type=template&id=9f408344
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"visible":_vm.modalState,"title":_vm.$t('customers.address.list'),"size":"xl","ok-only":"","ok-title":_vm.$t('interface.close')},on:{"hidden":function($event){return _vm.$emit('hidden')}}},[(_vm.loading)?_c('Spinner'):_c('div',[(_vm.can(_vm.type, 3))?_c('b-button',{staticClass:"mb-4",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.toCreate = true}}},[_vm._v(" "+_vm._s(_vm.$t('customers.address.addAddress'))+" ")]):_vm._e(),_c('b-row',_vm._l((_vm.addresses),function(address,i){return _c('b-col',{key:i,staticClass:"mb-4",attrs:{"cols":"12","md":"6","lg":"4","xl":"3"}},[_c('b-form-group',{class:{
            'customer-address': true,
            'no-name': !address.label
          },scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._v(" "+_vm._s(address.label ? address.label : ' ')+" ")]},proxy:true},{key:"description",fn:function(){return [(address.use_for_invoice || address.use_for_delivery)?_c('p',{staticClass:"mt-3"}):_vm._e(),(address.use_for_invoice)?_c('p',{staticClass:"font-weight-bold text-danger mb-0"},[_vm._v(" "+_vm._s(_vm.$t('customers.address.forInvoice'))+" ")]):_vm._e(),(address.use_for_delivery)?_c('p',{staticClass:"font-weight-bold text-danger mb-0"},[_vm._v(" "+_vm._s(_vm.$t('customers.address.forDelivery'))+" ")]):_vm._e(),(address.use_for_invoice || address.use_for_delivery)?_c('p',{staticClass:"mb-3"}):_vm._e(),(_vm.can(_vm.type, 3))?_c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.toEdit = address}}},[_vm._v(" "+_vm._s(_vm.$t('interface.edit'))+" ")]):_vm._e(),(_vm.can(_vm.type, 3))?_c('b-button',{attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.toDelete = address}}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")]):_vm._e()]},proxy:true}],null,true)},[(address.road1)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(address.road1)+" ")]):_vm._e(),(address.road2)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(address.road2)+" ")]):_vm._e(),(address.road3)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(address.road3)+" ")]):_vm._e(),(address.postal_code || address.town)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(address.postal_code)+" "+_vm._s(address.town)+" ")]):_vm._e(),(address.country)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(address.country.name)+" ")]):_vm._e()])],1)}),1),_c('CustomerAddressForm',{attrs:{"customer":_vm.customer,"value":_vm.toEdit,"modalState":_vm.toEdit !== null},on:{"hidden":function($event){_vm.toEdit = null},"submitComplete":_vm.addressUpdated}}),_c('CustomerAddressForm',{attrs:{"customer":_vm.customer,"modalState":_vm.toCreate},on:{"hidden":function($event){_vm.toCreate = false},"submitComplete":_vm.addressCreated}}),(_vm.toDelete !== null)?_c('CustomerAddressDelete',{attrs:{"customer":_vm.customer,"value":_vm.toDelete},on:{"hidden":function($event){_vm.toDelete = null},"deleted":_vm.addressDeleted}}):_vm._e()],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/components/CustomerAddressForm/CustomerAddressForm.vue + 3 modules
var CustomerAddressForm = __webpack_require__(2661);
// EXTERNAL MODULE: ./src/components/CustomerAddressDelete/CustomerAddressDelete.vue + 3 modules
var CustomerAddressDelete = __webpack_require__(8223);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerAddressList/CustomerAddressList.ts?vue&type=script&lang=ts&external







var CustomerAddressList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerAddressList, _super);
    function CustomerAddressList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addresses = [];
        _this.loading = false;
        _this.toCreate = false;
        _this.toEdit = null;
        _this.toDelete = null;
        return _this;
    }
    CustomerAddressList.prototype.watchCustomer = function (customer) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!customer.addresses) return [3 /*break*/, 1];
                        this.addresses = JSON.parse(JSON.stringify(customer.addresses));
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.loadAddresses()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerAddressList.prototype.loadAddresses = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCustomers.axios.get('/customer/' + this.customer.id + '/address', {
                                params: {
                                    per_page: 500
                                }
                            })
                                .then(function (response) {
                                _this.addresses = response.data.data;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerAddressList.prototype.addressCreated = function (address) {
        this.addresses.push(address);
        return address;
    };
    CustomerAddressList.prototype.addressUpdated = function (address) {
        var index = this.addresses.findIndex(function (value) { return value.id === address.id; });
        if (index >= 0) {
            lib/* Vue */.lD.set(this.addresses, index, address);
        }
        return address;
    };
    CustomerAddressList.prototype.addressDeleted = function () {
        var _this = this;
        var index = this.addresses.findIndex(function (value) { var _a; return value.id === ((_a = _this.toDelete) === null || _a === void 0 ? void 0 : _a.id); });
        if (index >= 0) {
            lib/* Vue */.lD.delete(this.addresses, index);
        }
        this.$emit('deleted', this.toDelete);
        this.toDelete = null;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerAddressList.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerAddressList.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerAddressList.prototype, "modalState", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('customer', { immediate: true, deep: true })
    ], CustomerAddressList.prototype, "watchCustomer", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('created')
    ], CustomerAddressList.prototype, "addressCreated", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('updated')
    ], CustomerAddressList.prototype, "addressUpdated", null);
    CustomerAddressList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])),
            components: {
                CustomerAddressForm: CustomerAddressForm/* default */.A,
                CustomerAddressDelete: CustomerAddressDelete/* default */.A,
                Spinner: interface_vue_.Spinner,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal
            }
        })
    ], CustomerAddressList);
    return CustomerAddressList;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerAddressListvue_type_script_lang_ts_external = (CustomerAddressList);

;// ./src/components/CustomerAddressList/CustomerAddressList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerAddressList_CustomerAddressListvue_type_script_lang_ts_external = (CustomerAddressListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerAddressList/CustomerAddressList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerAddressList_CustomerAddressListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerAddressList_CustomerAddressList = (component.exports);

/***/ }),

/***/ 1506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LO: function() { return /* binding */ fetchCustomer; },
/* harmony export */   qD: function() { return /* binding */ customerRelations; },
/* harmony export */   t3: function() { return /* binding */ needFetchCustomer; }
/* harmony export */ });
/* unused harmony export getCustomerRelations */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var customerRelations = [
    'activity', 'origin', 'tags', 'custom_fields', 'teamUser', 'address_invoice', 'address_delivery', 'addresses',
    'configurations', 'parent', 'childs', 'billing_contact'
];
var getCustomerRelations = function (extraRelations) {
    if (extraRelations === void 0) { extraRelations = []; }
    var relations = Array.from(customerRelations);
    relations.push.apply(relations, extraRelations);
    return relations;
};
var needFetchCustomer = function (customer, extraRelations) {
    if (extraRelations === void 0) { extraRelations = []; }
    return !getCustomerRelations(extraRelations).every(function (relation) { return relation in customer; });
};
var fetchCustomer = function (id, extraRelations) {
    if (extraRelations === void 0) { extraRelations = []; }
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwCustomers.axios.get('/customer/' + id, {
                        params: {
                            include: getCustomerRelations(extraRelations).join(',')
                        }
                    })
                        .then(function (response) {
                        return response.data;
                    })
                        .catch(function (error) {
                        var _a;
                        throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
};



/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C6: function() { return /* binding */ __extends; },
/* harmony export */   Cg: function() { return /* binding */ __decorate; },
/* harmony export */   Cl: function() { return /* binding */ __assign; },
/* harmony export */   YH: function() { return /* binding */ __generator; },
/* harmony export */   aN: function() { return /* binding */ __spreadArrays; },
/* harmony export */   sH: function() { return /* binding */ __awaiter; }
/* harmony export */ });
/* unused harmony exports __rest, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources, __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ }),

/***/ 1656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ normalizeComponent; }
/* harmony export */ });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1848:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

;// external "@fortawesome/fontawesome-svg-core"
var fontawesome_svg_core_namespaceObject = require("@fortawesome/fontawesome-svg-core");
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faIdCard.js
var faIdCard = __webpack_require__(5837);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faMapSigns.js
var faMapSigns = __webpack_require__(8358);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPlus.js
var faPlus = __webpack_require__(906);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPlusCircle.js
var faPlusCircle = __webpack_require__(6598);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPencil.js
var faPencil = __webpack_require__(4831);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faUserFriends.js
var faUserFriends = __webpack_require__(3928);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faArrowAltLeft.js
var faArrowAltLeft = __webpack_require__(6059);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSearch.js
var faSearch = __webpack_require__(726);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCaretDown.js
var faCaretDown = __webpack_require__(7711);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCaretUp.js
var faCaretUp = __webpack_require__(314);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faUsers.js
var faUsers = __webpack_require__(8540);
;// ./src/fontawesome.ts












fontawesome_svg_core_namespaceObject.library.add(faIdCard/* faIdCard */.Lm, faMapSigns/* faMapSigns */.kn, faPlus/* faPlus */.QL, faPlusCircle/* faPlusCircle */.OQ, faPencil/* faPencil */.zL, faUserFriends/* faUserFriends */.O2, faArrowAltLeft/* faArrowAltLeft */.XZ, faSearch/* faSearch */.Mj, faCaretDown/* faCaretDown */.xB, faCaretUp/* faCaretUp */.S$, faUsers/* faUsers */.gd);


/***/ }),

/***/ 1873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 1882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObject = __webpack_require__(3805);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 2054:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 2279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CustomersItemView_CustomersItemView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CustomersItemView/CustomersItemView.vue?vue&type=template&id=6bf38ada
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('CustomerItem',{attrs:{"type":_vm.type,"setPageTitle":""},model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/CustomerItem/CustomerItem.vue + 9 modules
var CustomerItem = __webpack_require__(197);
// EXTERNAL MODULE: ./src/fetchDatas/customer.ts
var fetchDatas_customer = __webpack_require__(1506);
// EXTERNAL MODULE: external "@kwixeo/subscriptions-vue"
var subscriptions_vue_ = __webpack_require__(8129);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/CustomersItemView/CustomersItemView.ts?vue&type=script&lang=ts&external








var getExtraRelations = function () {
    if (!lib/* Vue */.lD.prototype.$kwCustomers.store.state.user.is_admin && lib/* Vue */.lD.prototype.$kwCustomers.store.getters['user/can']('admin-subscription', 1)) {
        return ['adminTeam'];
    }
    return [];
};
var CustomersItemView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomersItemView, _super);
    function CustomersItemView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.customer = null;
        _this.type = null;
        return _this;
    }
    CustomersItemView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['pageParams'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setPageParams'])),
            components: {
                CustomerItem: CustomerItem/* default */.A,
                Spinner: interface_vue_.Spinner
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var type, pageParams;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                type = to.params.type;
                                if ((type === 'prospect' && !(0,subscriptions_vue_.checkAppModule)('customers-prospects'))
                                    || (type === 'subcontractor' && !(0,subscriptions_vue_.checkAppModule)('customers-subcontractors'))
                                    || !(0,interface_vue_.checkUserPermission)([type, 1])) {
                                    next({ path: '/error-404' });
                                    return [2 /*return*/];
                                }
                                pageParams = lib/* Vue */.lD.prototype.$kwCustomers.store.state.app.pageParams;
                                if (pageParams && !(0,fetchDatas_customer/* needFetchCustomer */.t3)(pageParams, getExtraRelations())) {
                                    next(function (vm) {
                                        vm.type = type;
                                        vm.customer = JSON.parse(JSON.stringify(vm.pageParams));
                                        vm.setPageParams(null);
                                        vm.loading = false;
                                    });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,fetchDatas_customer/* fetchCustomer */.LO)(to.params.id, getExtraRelations())
                                        .then(function (customer) {
                                        next(function (vm) {
                                            vm.type = to.params.type;
                                            vm.customer = customer;
                                            vm.loading = false;
                                            if (vm.pageParams) {
                                                vm.setPageParams(null);
                                            }
                                        });
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var type, customer;
                    var _this = this;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                type = to.params.type;
                                if ((type === 'prospect' && !(0,subscriptions_vue_.checkAppModule)('customers-prospects'))
                                    || (type === 'subcontractor' && !(0,subscriptions_vue_.checkAppModule)('customers-subcontractors'))
                                    || !(0,interface_vue_.checkUserPermission)([type, 1])) {
                                    this.$router.push({ path: '/error-404' });
                                    return [2 /*return*/];
                                }
                                if (!to.params.id) {
                                    next();
                                    return [2 /*return*/];
                                }
                                if (this.pageParams) {
                                    customer = JSON.parse(JSON.stringify(this.pageParams));
                                    this.setPageParams(null);
                                    if ((0,fetchDatas_customer/* needFetchCustomer */.t3)(customer, getExtraRelations())) {
                                        this.customer = customer;
                                        next();
                                        return [2 /*return*/];
                                    }
                                }
                                this.loading = true;
                                this.customer = null;
                                return [4 /*yield*/, (0,fetchDatas_customer/* fetchCustomer */.LO)(to.params.id, getExtraRelations())
                                        .then(function (customer) {
                                        _this.customer = customer;
                                        _this.type = type;
                                        _this.loading = false;
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], CustomersItemView);
    return CustomersItemView;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomersItemViewvue_type_script_lang_ts_external = (CustomersItemView);

;// ./src/views/CustomersItemView/CustomersItemView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomersItemView_CustomersItemViewvue_type_script_lang_ts_external = (CustomersItemViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/CustomersItemView/CustomersItemView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomersItemView_CustomersItemViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomersItemView_CustomersItemView = (component.exports);

/***/ }),

/***/ 2324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomersParams_CustomersParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomersParams/CustomersParams.vue?vue&type=template&id=7fb0ce5d
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{staticClass:"customers-params",attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.params.newsletterTitle'),"description":_vm.$t('customers.params.newsletterExplain')}},[_c('b-form-radio-group',{attrs:{"name":"configs[automatic_newsletter_subscription]"},model:{value:(_vm.localConfig.automatic_newsletter_subscription),callback:function ($$v) {_vm.$set(_vm.localConfig, "automatic_newsletter_subscription", $$v)},expression:"localConfig.automatic_newsletter_subscription"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" "+_vm._s(_vm.$t('interface.yes'))+" ")]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" "+_vm._s(_vm.$t('interface.no'))+" ")])],1)],1),_c('b-form-group',{attrs:{"label":"Informations complémentaires sur les entreprises"}},[_c('input',{attrs:{"type":"hidden","name":"configs[customer_add_company_datas]"},domProps:{"value":_vm.localConfig.customer_add_company_datas ? true : false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.customer_add_company_datas),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_add_company_datas", $$v)},expression:"localConfig.customer_add_company_datas"}},[_vm._v(" Ajouter la possibilité de saisir le type d'entreprise, le numéro RCS, le code NAF et le capital ")])],1),_c('h2',{staticClass:"form-title-alt"},[_vm._v(" Gestion des doublons ")]),_c('b-form-radio-group',{attrs:{"name":"configs[check_duplicates_for_person]","stacked":""},model:{value:(_vm.localConfig.check_duplicates_for_person),callback:function ($$v) {_vm.$set(_vm.localConfig, "check_duplicates_for_person", $$v)},expression:"localConfig.check_duplicates_for_person"}},[_c('b-form-radio',{attrs:{"value":true}},[_c('p',{staticClass:"font-weight-bold mb-1"},[_vm._v(" "+_vm._s(_vm.$t('customers.params.cannotCreateDouble'))+" ")]),_vm._v(" "+_vm._s(_vm.$t('customers.params.cannotCreateDoubleExplain'))+" ")]),_c('b-form-radio',{staticClass:"mt-3",attrs:{"value":false}},[_c('p',{staticClass:"font-weight-bold mb-1"},[_vm._v(" "+_vm._s(_vm.$t('customers.params.canCreateDouble'))+" ")]),_vm._v(" "+_vm._s(_vm.$t('customers.params.canCreateDoubleExplain'))+" ")])],1),_c('h2',{staticClass:"form-title-alt"},[_vm._v(" Recherche dans la base SIRENE des entreprises ")]),_c('input',{attrs:{"type":"hidden","name":"configs[fetch_customer_sirene_api]"},domProps:{"value":_vm.localConfig.fetch_customer_sirene_api ? true : false}}),_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.localConfig.fetch_customer_sirene_api),callback:function ($$v) {_vm.$set(_vm.localConfig, "fetch_customer_sirene_api", $$v)},expression:"localConfig.fetch_customer_sirene_api"}},[_vm._v(" Lors de la création d'un client, effectuer une recherche dans la base SIRENE des entreprises afin de remplir automatiquement les informations. ")]),_c('input',{attrs:{"type":"hidden","name":"configs[fetch_customer_sirene_api_styles]"},domProps:{"value":_vm.localConfig.fetch_customer_sirene_api_styles ? true : false}}),_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.localConfig.fetch_customer_sirene_api_styles),callback:function ($$v) {_vm.$set(_vm.localConfig, "fetch_customer_sirene_api_styles", $$v)},expression:"localConfig.fetch_customer_sirene_api_styles"}},[_vm._v(" Mettre en forme les informations (Première lettre en majuscule, puis minuscules) ")]),_c('p',{staticClass:"mt-2 mb-0 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomersParams/CustomersParams.ts?vue&type=script&lang=ts&external





var CustomersParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomersParams, _super);
    function CustomersParams() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomersParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormCheckbox: form_vue_.KFormCheckbox,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], CustomersParams);
    return CustomersParams;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var CustomersParamsvue_type_script_lang_ts_external = (CustomersParams);

;// ./src/components/CustomersParams/CustomersParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomersParams_CustomersParamsvue_type_script_lang_ts_external = (CustomersParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomersParams/CustomersParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomersParams_CustomersParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomersParams_CustomersParams = (component.exports);

/***/ }),

/***/ 2428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(7534),
    isObjectLike = __webpack_require__(346);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 2507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castSlice = __webpack_require__(8754),
    hasUnicode = __webpack_require__(9698),
    stringToArray = __webpack_require__(3912),
    toString = __webpack_require__(3222);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),

/***/ 2541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CustomersListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CustomersListView.vue?vue&type=template&id=b795192a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CustomersList',{attrs:{"type":"customer"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CustomersList/CustomersList.vue + 3 modules
var CustomersList = __webpack_require__(45);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CustomersListView.vue?vue&type=script&lang=ts



var CustomersListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomersListView, _super);
    function CustomersListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomersListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CustomersList: CustomersList/* default */.A
            }
        })
    ], CustomersListView);
    return CustomersListView;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomersListViewvue_type_script_lang_ts = (CustomersListView);

;// ./src/views/CustomersListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CustomersListViewvue_type_script_lang_ts = (CustomersListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/CustomersListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_CustomersListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CustomersListView = (component.exports);

/***/ }),

/***/ 2552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    getRawTag = __webpack_require__(659),
    objectToString = __webpack_require__(9350);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 2652:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/interface-vue");

/***/ }),

/***/ 2661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerAddressForm_CustomerAddressForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerAddressForm/CustomerAddressForm.vue?vue&type=template&id=26bb9f2e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"visible":_vm.modalState,"title":_vm.modalTitle},on:{"hidden":function($event){return _vm.$emit('hidden')}}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.address.name')}},[_c('k-form-input',{attrs:{"name":"label"},model:{value:(_vm.localValue.label),callback:function ($$v) {_vm.$set(_vm.localValue, "label", $$v)},expression:"localValue.label"}})],1),_c('input',{attrs:{"type":"hidden","name":"use_for_invoice"},domProps:{"value":_vm.localValue.use_for_invoice}}),_c('k-form-checkbox',{model:{value:(_vm.localValue.use_for_invoice),callback:function ($$v) {_vm.$set(_vm.localValue, "use_for_invoice", $$v)},expression:"localValue.use_for_invoice"}},[_vm._v(" "+_vm._s(_vm.$t('customers.address.useInvoice'))+" ")]),_c('input',{attrs:{"type":"hidden","name":"use_for_delivery"},domProps:{"value":_vm.localValue.use_for_delivery}}),_c('k-form-checkbox',{staticClass:"mt-2",model:{value:(_vm.localValue.use_for_delivery),callback:function ($$v) {_vm.$set(_vm.localValue, "use_for_delivery", $$v)},expression:"localValue.use_for_delivery"}},[_vm._v(" "+_vm._s(_vm.$t('customers.address.useDelivery'))+" ")]),_c('b-form-group',{staticClass:"mt-4",attrs:{"label":_vm.$t('customers.address.address')}},[_c('k-form-address',{attrs:{"with-road3":"","countries-list":_vm.countries,"required":"","valuesMap":{
          road: 'road1',
          road2: 'road2',
          road3: 'road3',
          postalCode: 'postal_code',
          city: 'town',
          country: 'country'
        }},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerAddressForm/CustomerAddressForm.ts?vue&type=script&lang=ts&external






var CustomerAddressForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerAddressForm, _super);
    function CustomerAddressForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localValue = {
            use_for_invoice: false,
            use_for_delivery: false
        };
        return _this;
    }
    Object.defineProperty(CustomerAddressForm.prototype, "formAction", {
        get: function () {
            var url = '/customer/' + this.customer.id + '/address';
            if (this.value && this.value.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerAddressForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerAddressForm.prototype, "modalTitle", {
        get: function () {
            var _a;
            return this.$t('customers.address.' + (((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'editTitle' : 'newTitle'));
        },
        enumerable: false,
        configurable: true
    });
    CustomerAddressForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerAddressForm.prototype.watchValue = function (value) {
        if (value) {
            this.localValue = JSON.parse(JSON.stringify(value));
        }
        else {
            if (!this.customer.address_invoice) {
                this.localValue.use_for_invoice = true;
            }
            if (!this.customer.address_delivery) {
                this.localValue.use_for_delivery = true;
            }
        }
    };
    CustomerAddressForm.prototype.submitComplete = function (response) {
        return response.data;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerAddressForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerAddressForm.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerAddressForm.prototype, "modalState", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CustomerAddressForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitComplete')
    ], CustomerAddressForm.prototype, "submitComplete", null);
    CustomerAddressForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormAddress: form_vue_.KFormAddress, KFormCheckbox: form_vue_.KFormCheckbox,
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                FormModal: interface_vue_.FormModal
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['countries'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries']))
        })
    ], CustomerAddressForm);
    return CustomerAddressForm;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerAddressFormvue_type_script_lang_ts_external = (CustomerAddressForm);

;// ./src/components/CustomerAddressForm/CustomerAddressForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerAddressForm_CustomerAddressFormvue_type_script_lang_ts_external = (CustomerAddressFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerAddressForm/CustomerAddressForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerAddressForm_CustomerAddressFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerAddressForm_CustomerAddressForm = (component.exports);

/***/ }),

/***/ 2779:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/sales-vue");

/***/ }),

/***/ 2913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ContactOriginsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContactOriginsView.vue?vue&type=template&id=b89745ac
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContactOrigins')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ContactOrigins/ContactOrigins.vue + 3 modules
var ContactOrigins = __webpack_require__(7785);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContactOriginsView.vue?vue&type=script&lang=ts



var ContactOriginsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactOriginsView, _super);
    function ContactOriginsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContactOriginsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ContactOrigins: ContactOrigins/* default */.A
            }
        })
    ], ContactOriginsView);
    return ContactOriginsView;
}(lib/* Vue */.lD));
/* harmony default export */ var ContactOriginsViewvue_type_script_lang_ts = (ContactOriginsView);

;// ./src/views/ContactOriginsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ContactOriginsViewvue_type_script_lang_ts = (ContactOriginsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ContactOriginsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ContactOriginsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ContactOriginsView = (component.exports);

/***/ }),

/***/ 2930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerSpeedItem_CustomerSpeedItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerSpeedItem/CustomerSpeedItem.vue?vue&type=template&id=3f6ba5bc
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-button',{staticClass:"p-0 text-left",attrs:{"to":_vm.route,"variant":"link","size":_vm.size},on:{"contextmenu":_vm.onContextMenu}},[_vm._v(" "+_vm._s(_vm.value.name)+" ")]),(_vm.showMore)?_c('div',{staticClass:"customer-speed-coordinates"},[(_vm.route)?_c('b-button',{staticClass:"mb-2 mr-2",attrs:{"size":"sm","variant":"primary","to":_vm.route}},[_vm._v(" Fiche ")]):_vm._e(),_c('b-button',{staticClass:"mb-2 mr-2",attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.showMore = false}}},[_vm._v(" Fermer ")]),_c('table',{staticClass:"w-100",attrs:{"cellpadding":"3"}},[_c('tr',[_c('td',{staticClass:"font-weight-bold pb-3",attrs:{"colspan":"2"}},[_vm._v(" "+_vm._s(_vm.value.name)+" ")])]),(_vm.haveNoCoordinates)?_c('tr',[_c('td',{staticClass:"text-center text-muted p-3",attrs:{"colspan":"2"}},[_vm._v(" "+_vm._s(_vm.$t('customers.item.noCoordinates'))+" ")])]):_vm._e(),(_vm.value.phone)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.form.phone')))]),_c('td',[(_vm.teamConfigs.phone_clickable)?_c('a',{attrs:{"href":'tel:' + _vm.value.phone}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.value.phone))+" ")]):[_vm._v(" "+_vm._s(_vm.showPhone(_vm.value.phone))+" ")]],2)]):_vm._e(),(_vm.value.mobile)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.form.mobile'))+" :")]),_c('td',[(_vm.teamConfigs.phone_clickable)?_c('a',{attrs:{"href":'tel:' + _vm.value.mobile}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.value.mobile))+" ")]):[_vm._v(" "+_vm._s(_vm.showPhone(_vm.value.mobile))+" ")]],2)]):_vm._e(),(_vm.value.fax)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.form.fax')))]),_c('td',[_vm._v(_vm._s(_vm.showPhone(_vm.value.fax)))])]):_vm._e(),(_vm.value.email)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.form.email')))]),_c('td',[_vm._v(_vm._s(_vm.value.email))])]):_vm._e(),(_vm.value.website)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.form.website')))]),_c('td',[_vm._v(_vm._s(_vm.value.website))])]):_vm._e()])],1):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerSpeedItem/CustomerSpeedItem.ts?vue&type=script&lang=ts&external





var CustomerSpeedItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerSpeedItem, _super);
    function CustomerSpeedItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showMore = false;
        return _this;
    }
    Object.defineProperty(CustomerSpeedItem.prototype, "route", {
        get: function () {
            var _a;
            if (this.link === null) {
                return null;
            }
            else if (this.link !== undefined) {
                return this.link;
            }
            var references = (_a = this.value.reference) !== null && _a !== void 0 ? _a : {};
            var type;
            if (this.type) {
                type = this.type;
            }
            else if (references.prospect) {
                type = 'prospect';
            }
            else {
                type = 'customer';
            }
            if (!this.can(type, 1)) {
                return null;
            }
            return {
                name: 'contacts-customer-item',
                params: {
                    id: String(this.value.id),
                    type: type
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSpeedItem.prototype, "haveNoCoordinates", {
        get: function () {
            return this.isEmpty(this.value.phone) && this.isEmpty(this.value.mobile) && this.isEmpty(this.value.fax) &&
                this.isEmpty(this.value.email) && this.isEmpty(this.value.website);
        },
        enumerable: false,
        configurable: true
    });
    CustomerSpeedItem.prototype.isEmpty = function (value) {
        return value === undefined || value === null || value === '';
    };
    CustomerSpeedItem.prototype.onContextMenu = function (event) {
        if (!this.showMore) {
            event.preventDefault();
        }
        this.showMore = true;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerSpeedItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSpeedItem.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: undefined })
    ], CustomerSpeedItem.prototype, "link", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSpeedItem.prototype, "size", void 0);
    CustomerSpeedItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'teamConfigs']))
        })
    ], CustomerSpeedItem);
    return CustomerSpeedItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.PhoneMixin)));
/* harmony default export */ var CustomerSpeedItemvue_type_script_lang_ts_external = (CustomerSpeedItem);

;// ./src/components/CustomerSpeedItem/CustomerSpeedItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerSpeedItem_CustomerSpeedItemvue_type_script_lang_ts_external = (CustomerSpeedItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerSpeedItem/CustomerSpeedItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerSpeedItem_CustomerSpeedItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerSpeedItem_CustomerSpeedItem = (component.exports);

/***/ }),

/***/ 3055:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/communication-vue");

/***/ }),

/***/ 3095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContactItem_ContactItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContactItem/ContactItem.vue?vue&type=template&id=0cafbd3f
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"page-title":_vm.value.fullname,"buttons":_vm.headerButtons}}),_c('AppMessages'),_c('b-row',[_c('b-col',{attrs:{"cols":"3"}},[_c('ContactInformations',{ref:"infos",attrs:{"contact":_vm.value}})],1),_c('b-col',{attrs:{"cols":"9"}},[_c('tabs',{staticClass:"tabs-card",scopedSlots:_vm._u([{key:"sales",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.sales'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalSales)+" ")])]},proxy:true},(_vm.hasModule('construction') && _vm.can('construction', 1) && _vm.teamConfigs.construction_active_contacts)?{key:"constructions",fn:function(){return [_vm._v(" "+_vm._s(_vm.upperFirst(_vm.termText('planification.tabTitle', 'chantier', true)))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalConstructionsGroup)+" ")])]},proxy:true}:null],null,true),model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('tab',{attrs:{"title":_vm.$t('customers.item.elements')}},[_c('AgregateDatas',{attrs:{"type":"contact","id":_vm.value.id,"model":_vm.value,"contact":_vm.value,"modelTitle":_vm.value.fullname,"url":'/customer/contact/' + _vm.value.id + '/agregate-datas'},on:{"loaded":_vm.agregateLoaded}})],1),(_vm.value.custom_fields.length > 0 && _vm.team.configs.custom_field_contact_tab)?_c('CustomFieldsDisplayTab',{attrs:{"type":"contact","value":_vm.value.custom_fields,"formUrl":'/customer/contact/' + _vm.value.id,"component":"tab","canUpdate":_vm.can('contact', 2)},on:{"input":contact => _vm.$emit('input', contact)}}):_vm._e(),(_vm.hasModule('opportunities') && _vm.can('opportunities', 1))?_c('tab',{attrs:{"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.opportunities'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalOpportunities)+" ")])]},proxy:true}],null,false,3112971854)},[_c('OpportunityList',{attrs:{"contact":_vm.value}})],1):_vm._e(),(_vm.can('sales-quotation', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":"","groupDividerBefore":1 === 2},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.quotations'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalQuotations)+" ")])]},proxy:true}],null,false,881588238)},[_c('QuotationList',{attrs:{"contact":_vm.value.id}})],1):_vm._e(),(_vm.hasModule('sales-commands') && _vm.can('sales-command', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.commands'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalCommands)+" ")])]},proxy:true}],null,false,1356274542)},[_c('CommandList',{attrs:{"contact":_vm.value.id}})],1):_vm._e(),(_vm.hasModule('sales-deliveries') && _vm.can('sales-delivery', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.deliveries'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalDeliveries)+" ")])]},proxy:true}],null,false,3394501166)},[_c('DeliveryList',{attrs:{"contact":_vm.value.id}})],1):_vm._e(),(_vm.hasModule('sales-proformas') && _vm.can('sales-proforma', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.proformas'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalProformas)+" ")])]},proxy:true}],null,false,4155975182)},[_c('ProformaList',{attrs:{"contact":_vm.value.id}})],1):_vm._e(),(_vm.can('sales-invoice', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.invoices'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalInvoices)+" ")])]},proxy:true}],null,false,958659502)},[_c('InvoiceList',{attrs:{"contact":_vm.value.id}})],1):_vm._e(),(_vm.can('sales-credit', 1))?_c('tab',{attrs:{"groupSlot":"sales","lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('customers.item.credits'))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalCredits)+" ")])]},proxy:true}],null,false,229538702)},[_c('CreditList',{attrs:{"contact":_vm.value.id}})],1):_vm._e(),(_vm.hasModule('construction') && _vm.can('construction', 1))?_c('tab',{attrs:{"groupSlot":_vm.teamConfigs.construction_active_contacts ? 'constructions' : null,"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.upperFirst(_vm.termText('planification.tabTitle', 'chantier', true)))+" "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalConstructions)+" ")])]},proxy:true}],null,false,2379595282)},[_c('ConstructionList',{attrs:{"contact":_vm.value}})],1):_vm._e(),(_vm.hasModule('construction') && _vm.can('construction', 1) && _vm.teamConfigs.construction_active_contacts)?_c('tab',{attrs:{"groupSlot":_vm.teamConfigs.construction_active_contacts ? 'constructions' : null,"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Contact chantiers "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalConstructionsContacts)+" ")])]},proxy:true}],null,false,1742352944)},[_c('ConstructionList',{attrs:{"contactContactId":_vm.value.id}})],1):_vm._e(),(_vm.hasModule('tickets') && _vm.can('tickets', 1))?_c('tab',{attrs:{"lazy":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Tickets "),_c('b-badge',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(_vm.totalTickets)+" ")]),(_vm.can('tickets', 2))?_c('TicketForm',{attrs:{"isIcon":"","value":{ contact: _vm.value, customer: _vm.value.customers.length > 0 ? _vm.value.customers[0] : null }}}):_vm._e()]},proxy:true}],null,false,354849401)},[_c('TicketsList',{attrs:{"contact":_vm.value}})],1):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/calendars-vue"
var calendars_vue_ = __webpack_require__(9792);
// EXTERNAL MODULE: external "@kwixeo/communication-vue"
var communication_vue_ = __webpack_require__(3055);
// EXTERNAL MODULE: ./src/components/ContactInformations/ContactInformations.vue + 3 modules
var ContactInformations = __webpack_require__(5469);
// EXTERNAL MODULE: ./src/components/ContactDelete/ContactDelete.vue + 3 modules
var ContactDelete = __webpack_require__(4779);
// EXTERNAL MODULE: external "@kwixeo/sales-vue"
var sales_vue_ = __webpack_require__(2779);
// EXTERNAL MODULE: external "@kwixeo/opportunities-vue"
var opportunities_vue_ = __webpack_require__(8266);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: external "@kwixeo/tickets-vue"
var tickets_vue_ = __webpack_require__(8742);
// EXTERNAL MODULE: external "@kwixeo/constructions-vue"
var constructions_vue_ = __webpack_require__(3781);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContactMerge/ContactMerge.vue?vue&type=template&id=a41bb356
var ContactMergevue_type_template_id_a41bb356_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e(),_c('FormModal',{attrs:{"title":_vm.$t('customers.contact.mergeTitle'),"ok-title":_vm.$t('customers.contact.mergeBtn'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":"PUT"},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.contact.mergeDestination')}},[_c('input',{attrs:{"type":"hidden","name":"id"},domProps:{"value":_vm.contact ? _vm.contact.id : null}}),_c('k-form-select',{attrs:{"ajax":"/customer/contact","ajaxDatas":{
            sort: 'lastname,firstname',
            filter: {
              exclude: _vm.value.id
            }
          },"ajaxSearch":_vm.selectSearch,"label":"fullname","required":""},model:{value:(_vm.contact),callback:function ($$v) {_vm.contact=$$v},expression:"contact"}})],1)],1),_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('customers.contact.mergeExplain1'))+" ")]),_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('customers.contact.mergeExplain2'))+" ")])])],1)],1)
}
var ContactMergevue_type_template_id_a41bb356_staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContactMerge/ContactMerge.ts?vue&type=script&lang=ts&external





var ContactMerge = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactMerge, _super);
    function ContactMerge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.contact = null;
        return _this;
    }
    Object.defineProperty(ContactMerge.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactMerge.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('customers.contact.merge');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactMerge.prototype, "formAction", {
        get: function () {
            return '/customer/contact/' + this.value.id + '/merge';
        },
        enumerable: false,
        configurable: true
    });
    ContactMerge.prototype.selectSearch = function (params, term) {
        if (!('filter' in params)) {
            params.filter = {};
        }
        if (term !== '' && term !== null) {
            term = '%25' + term + '%25';
        }
        params.filter.lastname = term;
        return params;
    };
    ContactMerge.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    ContactMerge.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    ContactMerge.prototype.submitComplete = function (response) {
        return response.data;
    };
    ContactMerge.prototype.closeModal = function () {
        this.$emit('closed');
    };
    ContactMerge.prototype.canceled = function () {
        this.$emit('canceled');
    };
    ContactMerge.prototype.deleted = function () {
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContactMerge.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], ContactMerge.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactMerge.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactMerge.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContactMerge.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContactMerge.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], ContactMerge.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], ContactMerge.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('merged')
    ], ContactMerge.prototype, "submitComplete", null);
    ContactMerge = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal,
                KForm: form_vue_.KForm,
                KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                BAlert: external_bootstrap_vue_.BAlert
            }
        })
    ], ContactMerge);
    return ContactMerge;
}(lib/* Vue */.lD));
/* harmony default export */ var ContactMergevue_type_script_lang_ts_external = (ContactMerge);

;// ./src/components/ContactMerge/ContactMerge.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContactMerge_ContactMergevue_type_script_lang_ts_external = (ContactMergevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ContactMerge/ContactMerge.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContactMerge_ContactMergevue_type_script_lang_ts_external,
  ContactMergevue_type_template_id_a41bb356_render,
  ContactMergevue_type_template_id_a41bb356_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContactMerge_ContactMerge = (component.exports);
// EXTERNAL MODULE: ./node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__(5808);
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContactItem/ContactItem.ts?vue&type=script&lang=ts&external

















var ContactItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactItem, _super);
    function ContactItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeTab = 0;
        _this.saveTabKey = 'contactTab';
        _this.totalQuotations = 0;
        _this.totalCommands = 0;
        _this.totalProformas = 0;
        _this.totalDeliveries = 0;
        _this.totalInvoices = 0;
        _this.totalCredits = 0;
        _this.totalOpportunities = 0;
        _this.totalTickets = 0;
        _this.totalSales = 0;
        _this.totalConstructions = 0;
        _this.totalConstructionsContacts = 0;
        _this.totalConstructionsGroup = 0;
        return _this;
    }
    ContactItem.prototype.mounted = function () {
        if (this.teamConfigs.params_remember_tab) {
            this.activeTab = Number(localStorage.getItem(this.saveTabKey));
        }
    };
    Object.defineProperty(ContactItem.prototype, "headerButtons", {
        get: function () {
            var _this = this;
            var buttons = [];
            if (this.can('contact', 2)) {
                buttons.push.apply(buttons, [
                    {
                        label: this.$t('interface.edit'),
                        click: function () {
                            _this.openModal({
                                key: 'contact-form',
                                value: _this.value,
                                submitted: function (response) {
                                    _this.$emit('input', response.data);
                                }
                            });
                        }
                    },
                    {
                        label: this.$t('customers.item.contactItem'),
                        items: this.contactActions
                    }
                ]);
            }
            if (this.hasModule('task') && this.can('task', 1)) {
                buttons.push({
                    label: this.$t('tasks.newBtn'),
                    click: this.newTask
                });
            }
            var relations = [];
            if (this.can('send-mail', 1)) {
                relations.push({
                    component: communication_vue_.SendEmailButton,
                    attributes: {
                        contact: this.value,
                        element: 'dropdown',
                        linkedElements: this.linkedElements
                    }
                });
            }
            if (this.hasModule('communication-reports') && this.can('communication-reports', 1)) {
                relations.push({
                    component: communication_vue_.ReportFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Compte-rendu',
                        contact: this.value,
                        linkedElements: this.linkedElements
                    }
                });
            }
            if (this.hasModule('communication-letters') && this.can('communication-letters', 1)) {
                relations.push({
                    component: communication_vue_.LetterFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Lettre',
                        contact: this.value,
                        linkedElements: this.linkedElements
                    }
                });
            }
            if (this.hasModule('calendar') && this.can('calendar', 1)) {
                relations.push({
                    component: calendars_vue_.CalendarButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Rendez-vous',
                        linkedElements: this.linkedElements
                    }
                });
            }
            if (relations.length > 1) {
                buttons.push.apply(buttons, [
                    {
                        label: 'Relation',
                        items: relations
                    }
                ]);
            }
            else if (this.can('send-email', 1)) {
                buttons.push({
                    component: communication_vue_.SendEmailButton,
                    attributes: {
                        contact: this.value,
                        element: 'button'
                    }
                });
            }
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactItem.prototype, "contactActions", {
        get: function () {
            var _this = this;
            var buttons = [
                {
                    label: this.$t('interface.files.addFiles'),
                    click: function () { return interface_vue_.emitter.emit('selectFiles-contact-' + _this.value.id); }
                }
            ];
            if (this.can('contact', 3)) {
                buttons.push.apply(buttons, [
                    {
                        isSeparator: true
                    },
                    {
                        label: this.$t('customers.contact.merge'),
                        component: ContactMerge_ContactMerge,
                        attributes: {
                            value: this.value,
                            element: 'dropdown'
                        },
                        events: {
                            merged: function (contact) { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                                return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.$router.push({
                                                name: 'contacts-contact-item',
                                                params: {
                                                    id: String(contact.id),
                                                }
                                            })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }
                    },
                    {
                        label: this.$t('interface.delete'),
                        component: ContactDelete/* default */.A,
                        attributes: {
                            value: this.value,
                            element: 'dropdown'
                        },
                        events: {
                            deleted: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                                return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.$router.push({
                                                name: 'contacts-contacts-list'
                                            })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }
                    }
                ]);
            }
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    ContactItem.prototype.onActiveTabChange = function () {
        if (this.teamConfigs.params_remember_tab) {
            localStorage.setItem(this.saveTabKey, String(this.activeTab));
        }
    };
    // Create a new task
    ContactItem.prototype.newTask = function () {
        this.openModal({
            key: 'task-form',
            value: {
                elements: this.linkedElements
            }
        });
    };
    Object.defineProperty(ContactItem.prototype, "linkedElements", {
        get: function () {
            return [{
                    title: this.value.fullname,
                    type: 'contact',
                    id: this.value.id,
                    data: this.value
                }];
        },
        enumerable: false,
        configurable: true
    });
    ContactItem.prototype.agregateLoaded = function (data) {
        var _a;
        var totals = data.totals;
        this.totalQuotations = totals.quotation;
        this.totalCommands = totals.command;
        this.totalProformas = totals.proforma;
        this.totalDeliveries = totals.delivery;
        this.totalInvoices = totals.invoice;
        this.totalCredits = totals.credit;
        this.totalOpportunities = totals.opportunity;
        this.totalTickets = totals.ticket;
        this.totalConstructions = totals.construction;
        this.totalConstructionsContacts = (_a = totals.construction_contact) !== null && _a !== void 0 ? _a : 0;
        this.totalSales = 0;
        if (this.can('sales-quotation', 1)) {
            this.totalSales += this.totalQuotations;
        }
        if (this.hasModule('sales-commands') && this.can('sales-command', 1)) {
            this.totalSales += this.totalCommands;
        }
        if (this.hasModule('sales-deliveries') && this.can('sales-delivery', 1)) {
            this.totalSales += this.totalDeliveries;
        }
        if (this.hasModule('sales-proformas') && this.can('sales-proforma', 1)) {
            this.totalSales += this.totalProformas;
        }
        if (this.can('sales-invoice', 1)) {
            this.totalSales += this.totalInvoices;
        }
        if (this.can('sales-credit', 1)) {
            this.totalSales += this.totalCredits;
        }
        this.totalConstructionsGroup = 0;
        if (this.hasModule('construction') && this.can('construction', 1)) {
            this.totalConstructionsGroup += this.totalConstructions;
            if (this.teamConfigs.construction_active_contacts) {
                this.totalConstructionsGroup += this.totalConstructionsContacts;
            }
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContactItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('activeTab')
    ], ContactItem.prototype, "onActiveTabChange", null);
    ContactItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), { termText: constructions_vue_.termText,
                upperFirst: (upperFirst_default()) }),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'team', 'teamConfigs'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                AgregateDatas: communication_vue_.AgregateDatas,
                ContactInformations: ContactInformations/* default */.A,
                CustomFieldsDisplayTab: custom_fields_vue_.CustomFieldsDisplayTab,
                PageHeader: interface_vue_.PageHeader, Tabs: interface_vue_.Tabs, Tab: interface_vue_.Tab, AppMessages: interface_vue_.AppMessages,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BBadge: external_bootstrap_vue_.BBadge, BAlert: external_bootstrap_vue_.BAlert, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                QuotationList: sales_vue_.QuotationList, CommandList: sales_vue_.CommandList, ProformaList: sales_vue_.ProformaList, DeliveryList: sales_vue_.DeliveryList, InvoiceList: sales_vue_.InvoiceList, CreditList: sales_vue_.CreditList,
                OpportunityList: opportunities_vue_.OpportunityList,
                TicketForm: tickets_vue_.TicketForm, TicketsList: tickets_vue_.TicketsList,
                ConstructionList: constructions_vue_.ConstructionList
            }
        })
    ], ContactItem);
    return ContactItem;
}(lib/* Vue */.lD));
/* harmony default export */ var ContactItemvue_type_script_lang_ts_external = (ContactItem);

;// ./src/components/ContactItem/ContactItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContactItem_ContactItemvue_type_script_lang_ts_external = (ContactItemvue_type_script_lang_ts_external); 
;// ./src/components/ContactItem/ContactItem.vue





/* normalize component */
;
var ContactItem_component = (0,componentNormalizer/* default */.A)(
  ContactItem_ContactItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContactItem_ContactItem = (ContactItem_component.exports);

/***/ }),

/***/ 3221:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 3222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(7556);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 3407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerChargeParams_CustomerChargeParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerChargeParams/CustomerChargeParams.vue?vue&type=template&id=533e87f6
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.chargesPreferences.vatRate')}},[_c('input',{attrs:{"type":"hidden","name":"configs[charges_vat_rate]"},domProps:{"value":_vm.localConfig.charges_vat_rate ? _vm.localConfig.charges_vat_rate.id : null}}),_c('VatRateSelect',{attrs:{"clearable":""},model:{value:(_vm.localConfig.charges_vat_rate),callback:function ($$v) {_vm.$set(_vm.localConfig, "charges_vat_rate", $$v)},expression:"localConfig.charges_vat_rate"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('customers.chargesPreferences.currency')}},[_c('input',{attrs:{"type":"hidden","name":"configs[charges_currency]"},domProps:{"value":_vm.localConfig.charges_currency ? _vm.localConfig.charges_currency.id : null}}),_c('CurrencySelect',{attrs:{"clearable":""},model:{value:(_vm.localConfig.charges_currency),callback:function ($$v) {_vm.$set(_vm.localConfig, "charges_currency", $$v)},expression:"localConfig.charges_currency"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('customers.chargesPreferences.chargeCategory')}},[_c('input',{attrs:{"type":"hidden","name":"configs[charges_category]"},domProps:{"value":_vm.localConfig.charges_category ? _vm.localConfig.charges_category.id : null}}),_c('k-form-select',{attrs:{"options":_vm.chargeCategories},model:{value:(_vm.localConfig.charges_category),callback:function ($$v) {_vm.$set(_vm.localConfig, "charges_category", $$v)},expression:"localConfig.charges_category"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('customers.chargesPreferences.paymentTerm')}},[_c('PaymentTermSelect',{attrs:{"name":"configs[charges_payment_term]","reduce":opt => opt.id,"clearable":""},model:{value:(_vm.localConfig.charges_payment_term),callback:function ($$v) {_vm.$set(_vm.localConfig, "charges_payment_term", $$v)},expression:"localConfig.charges_payment_term"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('customers.chargesPreferences.paymentDelay')}},[_c('input',{attrs:{"type":"hidden","name":"configs[charges_payment_use_term]"},domProps:{"value":_vm.localConfig.charges_payment_use_term ? true : false}}),_c('k-form-checkbox',{staticClass:"my-2",attrs:{"validation-name":"configs[charges_payment_use_term]"},model:{value:(_vm.localConfig.charges_payment_use_term),callback:function ($$v) {_vm.$set(_vm.localConfig, "charges_payment_use_term", $$v)},expression:"localConfig.charges_payment_use_term"}},[_vm._v(" "+_vm._s(_vm.$t('customers.chargesPreferences.paymentDelayUseTerm'))+" ")]),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_vm._v(" "+_vm._s(_vm.$t('customers.chargesPreferences.paymentDelayPart1'))+" ")]),_c('b-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_c('k-form-spinner',{attrs:{"disabled":_vm.localConfig.charges_payment_use_term,"name":"configs[charges_payment_delay]","min":0,"noDefaultValue":"","size":"sm"},model:{value:(_vm.localConfig.charges_payment_delay),callback:function ($$v) {_vm.$set(_vm.localConfig, "charges_payment_delay", $$v)},expression:"localConfig.charges_payment_delay"}})],1),_c('b-col',[_vm._v(" "+_vm._s(_vm.$t('customers.chargesPreferences.paymentDelayPart2'))+" ")])],1)],1),_c('b-form-group',{attrs:{"label":_vm.$t('customers.chargesPreferences.fecExports')}},[_c('input',{attrs:{"type":"hidden","name":"configs[charges_fec_include_charges]"},domProps:{"value":_vm.localConfig.charges_fec_include_charges ? true : false}}),_c('k-form-checkbox',{attrs:{"validation-name":"configs[charges_fec_include_charges]"},model:{value:(_vm.localConfig.charges_fec_include_charges),callback:function ($$v) {_vm.$set(_vm.localConfig, "charges_fec_include_charges", $$v)},expression:"localConfig.charges_fec_include_charges"}},[_vm._v(" "+_vm._s(_vm.$t('customers.chargesPreferences.fecIncludeCharge'))+" ")]),_c('input',{attrs:{"type":"hidden","name":"configs[charges_fec_include_bank]"},domProps:{"value":_vm.localConfig.charges_fec_include_bank ? true : false}}),_c('k-form-checkbox',{attrs:{"validation-name":"configs[charges_fec_include_bank]"},model:{value:(_vm.localConfig.charges_fec_include_bank),callback:function ($$v) {_vm.$set(_vm.localConfig, "charges_fec_include_bank", $$v)},expression:"localConfig.charges_fec_include_bank"}},[_vm._v(" "+_vm._s(_vm.$t('customers.chargesPreferences.fecIncludeBank'))+" ")])],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerChargeParams/CustomerChargeParams.ts?vue&type=script&lang=ts&external






var CustomerChargeParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerChargeParams, _super);
    function CustomerChargeParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localConfig = {};
        return _this;
    }
    CustomerChargeParams.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadChargeCategories()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CustomerChargeParams.prototype, "formAction", {
        get: function () {
            return '/customer/' + this.value.id;
        },
        enumerable: false,
        configurable: true
    });
    CustomerChargeParams.prototype.watchValue = function (value) {
        var _a;
        this.localConfig = JSON.parse(JSON.stringify((_a = value.configs) !== null && _a !== void 0 ? _a : {}));
    };
    CustomerChargeParams.prototype.formSubmitted = function (response) {
        this.$emit('input', response.data);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerChargeParams.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CustomerChargeParams.prototype, "watchValue", null);
    CustomerChargeParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormSpinner: form_vue_.KFormSpinner, KFormCheckbox: form_vue_.KFormCheckbox,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                VatRateSelect: interface_vue_.VatRateSelect, CurrencySelect: interface_vue_.CurrencySelect, PaymentTermSelect: interface_vue_.PaymentTermSelect
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('catalog', ['loadChargeCategories'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('catalog', ['chargeCategories']))
        })
    ], CustomerChargeParams);
    return CustomerChargeParams;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerChargeParamsvue_type_script_lang_ts_external = (CustomerChargeParams);

;// ./src/components/CustomerChargeParams/CustomerChargeParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerChargeParams_CustomerChargeParamsvue_type_script_lang_ts_external = (CustomerChargeParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerChargeParams/CustomerChargeParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerChargeParams_CustomerChargeParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerChargeParams_CustomerChargeParams = (component.exports);

/***/ }),

/***/ 3408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Hz: function() { return /* binding */ needFetchContact; },
/* harmony export */   tY: function() { return /* binding */ fetchContact; },
/* harmony export */   uE: function() { return /* binding */ contactRelations; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var contactRelations = ['function', 'customers', 'tags', 'custom_fields'];
var needFetchContact = function (contact) {
    return !contactRelations.every(function (relation) { return relation in contact; });
};
var fetchContact = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwCustomers.axios.get('/customer/contact/' + id, {
                    params: {
                        include: contactRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 3462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ContactsListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContactsListView.vue?vue&type=template&id=49ab922c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContactsList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ContactsList/ContactsList.vue + 3 modules
var ContactsList = __webpack_require__(5097);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContactsListView.vue?vue&type=script&lang=ts



var ContactsListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactsListView, _super);
    function ContactsListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContactsListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ContactsList: ContactsList/* default */.A
            }
        })
    ], ContactsListView);
    return ContactsListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ContactsListViewvue_type_script_lang_ts = (ContactsListView);

;// ./src/views/ContactsListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ContactsListViewvue_type_script_lang_ts = (ContactsListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ContactsListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ContactsListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ContactsListView = (component.exports);

/***/ }),

/***/ 3488:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 3569:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(695),
    baseKeys = __webpack_require__(8984),
    isArrayLike = __webpack_require__(4894);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 3645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_SubcontractorsListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SubcontractorsListView.vue?vue&type=template&id=73e77460
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CustomersList',{attrs:{"type":"subcontractor"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CustomersList/CustomersList.vue + 3 modules
var CustomersList = __webpack_require__(45);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SubcontractorsListView.vue?vue&type=script&lang=ts



var SubcontractorsListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SubcontractorsListView, _super);
    function SubcontractorsListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubcontractorsListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CustomersList: CustomersList/* default */.A
            }
        })
    ], SubcontractorsListView);
    return SubcontractorsListView;
}(lib/* Vue */.lD));
/* harmony default export */ var SubcontractorsListViewvue_type_script_lang_ts = (SubcontractorsListView);

;// ./src/views/SubcontractorsListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_SubcontractorsListViewvue_type_script_lang_ts = (SubcontractorsListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/SubcontractorsListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_SubcontractorsListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_SubcontractorsListView = (component.exports);

/***/ }),

/***/ 3650:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(4335);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 3656:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325),
    stubFalse = __webpack_require__(9935);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 3729:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 3781:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/constructions-vue");

/***/ }),

/***/ 3805:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 3836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ContactFunctionsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContactFunctionsView.vue?vue&type=template&id=08cbf010
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContactFunctions')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ContactFunctions/ContactFunctions.vue + 3 modules
var ContactFunctions = __webpack_require__(4771);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContactFunctionsView.vue?vue&type=script&lang=ts



var ContactFunctionsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactFunctionsView, _super);
    function ContactFunctionsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContactFunctionsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ContactFunctions: ContactFunctions/* default */.A
            }
        })
    ], ContactFunctionsView);
    return ContactFunctionsView;
}(lib/* Vue */.lD));
/* harmony default export */ var ContactFunctionsViewvue_type_script_lang_ts = (ContactFunctionsView);

;// ./src/views/ContactFunctionsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ContactFunctionsViewvue_type_script_lang_ts = (ContactFunctionsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ContactFunctionsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ContactFunctionsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ContactFunctionsView = (component.exports);

/***/ }),

/***/ 3878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerDelete_CustomerDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerDelete/CustomerDelete.vue?vue&type=template&id=28155849
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_c('p',[_vm._v(_vm._s(_vm.$t('customers.deleteMsg')))])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerDelete/CustomerDelete.ts?vue&type=script&lang=ts&external




var CustomerDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerDelete, _super);
    function CustomerDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(CustomerDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerDelete.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('interface.delete');
        },
        enumerable: false,
        configurable: true
    });
    CustomerDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    CustomerDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    CustomerDelete.prototype.process = function (event) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        event.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCustomers.axios.delete('/customer/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id))
                                .then(function () {
                                _this.deleted();
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerDelete.prototype.closeModal = function () {
        this.$emit('closed');
    };
    CustomerDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    CustomerDelete.prototype.deleted = function () {
        interface_vue_.emitter.emit('customerDeleted', this.value);
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], CustomerDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CustomerDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], CustomerDelete.prototype, "watchModalState", null);
    CustomerDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay,
                Spinner: interface_vue_.Spinner
            }
        })
    ], CustomerDelete);
    return CustomerDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerDeletevue_type_script_lang_ts_external = (CustomerDelete);

;// ./src/components/CustomerDelete/CustomerDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerDelete_CustomerDeletevue_type_script_lang_ts_external = (CustomerDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerDelete/CustomerDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerDelete_CustomerDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerDelete_CustomerDelete = (component.exports);

/***/ }),

/***/ 3912:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1074),
    hasUnicode = __webpack_require__(9698),
    unicodeToArray = __webpack_require__(2054);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 3928:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'user-friends';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f500';
var svgPathData = 'M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.O2 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 4016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContactActivities_ContactActivities; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContactActivities/ContactActivities.vue?vue&type=template&id=38af8182
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('customers.contactActivity.new'),"updateTitle":_vm.$t('customers.contactActivity.edit'),"deleteMsg":_vm.$t('customers.contactActivity.deleteMsg'),"sort":"label","withDefault":"","exportable":"activity"},on:{"submitted":activity => _vm.setActivity(activity),"deleted":activity => _vm.deleteActivity(activity)}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContactActivities/ContactActivities.ts?vue&type=script&lang=ts&external




var ContactActivities = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactActivities, _super);
    function ContactActivities() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columns = [
            {
                label: _this.$t('customers.contactActivity.label'),
                key: 'label',
                required: true
            }
        ];
        return _this;
    }
    Object.defineProperty(ContactActivities.prototype, "apiUrl", {
        get: function () {
            return '/customer/activity';
        },
        enumerable: false,
        configurable: true
    });
    ContactActivities = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customers', ['setActivity', 'deleteActivity'])),
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], ContactActivities);
    return ContactActivities;
}(lib/* Vue */.lD));
/* harmony default export */ var ContactActivitiesvue_type_script_lang_ts_external = (ContactActivities);

;// ./src/components/ContactActivities/ContactActivities.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContactActivities_ContactActivitiesvue_type_script_lang_ts_external = (ContactActivitiesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ContactActivities/ContactActivities.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContactActivities_ContactActivitiesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContactActivities_ContactActivities = (component.exports);

/***/ }),

/***/ 4066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(3488);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 4256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContactSpeedItem_ContactSpeedItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContactSpeedItem/ContactSpeedItem.vue?vue&type=template&id=1a913541
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-button',{staticClass:"p-0 text-left",attrs:{"to":_vm.route,"variant":"link","size":_vm.size},on:{"contextmenu":_vm.onContextMenu}},[_vm._v(" "+_vm._s(_vm.value.fullname)+" ")]),(_vm.showMore)?_c('div',{staticClass:"contact-speed-coordinates"},[(_vm.route)?_c('b-button',{staticClass:"mb-2 mr-2",attrs:{"size":"sm","variant":"primary","to":_vm.route}},[_vm._v(" "+_vm._s(_vm.$t('interface.item'))+" ")]):_vm._e(),_c('b-button',{staticClass:"mb-2 mr-2",attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.showMore = false}}},[_vm._v(" "+_vm._s(_vm.$t('interface.close'))+" ")]),_c('table',{staticClass:"w-100",attrs:{"cellpadding":"3"}},[_c('tr',[_c('td',{staticClass:"font-weight-bold pb-3",attrs:{"colspan":"2"}},[_vm._v(" "+_vm._s(_vm.value.fullname)+" ")])]),(_vm.haveNoCoordinates)?_c('tr',[_c('td',{staticClass:"text-center text-muted p-3",attrs:{"colspan":"2"}},[_vm._v(" "+_vm._s(_vm.$t('customers.item.noCoordinates'))+" ")])]):_vm._e(),(_vm.value.phone)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.form.phone')))]),_c('td',[(_vm.teamConfigs.phone_clickable)?_c('a',{attrs:{"href":'tel:' + _vm.value.phone}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.value.phone))+" ")]):[_vm._v(" "+_vm._s(_vm.showPhone(_vm.value.phone))+" ")]],2)]):_vm._e(),(_vm.value.mobile)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.form.mobile'))+" :")]),_c('td',[(_vm.teamConfigs.phone_clickable)?_c('a',{attrs:{"href":'tel:' + _vm.value.mobile}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.value.mobile))+" ")]):[_vm._v(" "+_vm._s(_vm.showPhone(_vm.value.mobile))+" ")]],2)]):_vm._e(),(_vm.value.fax)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.form.fax'))+" :")]),_c('td',[_vm._v(_vm._s(_vm.showPhone(_vm.value.fax)))])]):_vm._e(),(_vm.value.email)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.form.email')))]),_c('td',[_vm._v(_vm._s(_vm.value.email))])]):_vm._e(),(_vm.value.website)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.form.website')))]),_c('td',[_vm._v(_vm._s(_vm.value.website))])]):_vm._e()])],1):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContactSpeedItem/ContactSpeedItem.ts?vue&type=script&lang=ts&external





var ContactSpeedItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactSpeedItem, _super);
    function ContactSpeedItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showMore = false;
        return _this;
    }
    Object.defineProperty(ContactSpeedItem.prototype, "route", {
        get: function () {
            if (this.link === null) {
                return null;
            }
            else if (this.link !== undefined) {
                return this.link;
            }
            if (!this.can('customer', 1) && !this.can('prospect', 1) && !this.can('provider', 1) && !this.can('subcontractor', 1)) {
                return null;
            }
            return {
                name: 'contacts-contact-item',
                params: { id: String(this.value.id) }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactSpeedItem.prototype, "haveNoCoordinates", {
        get: function () {
            return this.isEmpty(this.value.phone) && this.isEmpty(this.value.mobile) && this.isEmpty(this.value.fax) &&
                this.isEmpty(this.value.email) && this.isEmpty(this.value.website);
        },
        enumerable: false,
        configurable: true
    });
    ContactSpeedItem.prototype.isEmpty = function (value) {
        return value === undefined || value === null || value === '';
    };
    ContactSpeedItem.prototype.onContextMenu = function (event) {
        if (!this.showMore) {
            event.preventDefault();
        }
        this.showMore = true;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContactSpeedItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: undefined })
    ], ContactSpeedItem.prototype, "link", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactSpeedItem.prototype, "size", void 0);
    ContactSpeedItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                BButton: external_bootstrap_vue_.BButton
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'teamConfigs']))
        })
    ], ContactSpeedItem);
    return ContactSpeedItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.PhoneMixin)));
/* harmony default export */ var ContactSpeedItemvue_type_script_lang_ts_external = (ContactSpeedItem);

;// ./src/components/ContactSpeedItem/ContactSpeedItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContactSpeedItem_ContactSpeedItemvue_type_script_lang_ts_external = (ContactSpeedItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ContactSpeedItem/ContactSpeedItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContactSpeedItem_ContactSpeedItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContactSpeedItem_ContactSpeedItem = (component.exports);

/***/ }),

/***/ 4335:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 4388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerTypes_CustomerTypes; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerTypes/CustomerTypes.vue?vue&type=template&id=9ad4b9ae
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('customers.customerType.new'),"updateTitle":_vm.$t('customers.customerType.edit'),"deleteMsg":_vm.$t('customers.customerType.deleteMsg'),"sort":"label","withDefault":"","exportable":"customerType"},on:{"submitted":type => _vm.setCustomerType(type),"deleted":type => _vm.deleteCustomerType(type)}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerTypes/CustomerTypes.ts?vue&type=script&lang=ts&external




var CustomerTypes = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerTypes, _super);
    function CustomerTypes() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columns = [
            {
                label: _this.$t('customers.customerType.label'),
                key: 'label',
                required: true
            },
            {
                label: _this.$t('customers.company'),
                formLabel: _this.$t('customers.customerType.isCompanylabel'),
                key: 'is_company',
                type: 'boolean',
                show: function (value) { return value ? _this.$t('interface.yes') : _this.$t('interface.no'); },
                noFormLabel: true
            },
            {
                label: _this.$t('customers.person'),
                formLabel: _this.$t('customers.customerType.isPersonlabel'),
                key: 'is_person',
                type: 'boolean',
                show: function (value) { return value ? _this.$t('interface.yes') : _this.$t('interface.no'); },
                noFormLabel: true
            }
        ];
        return _this;
    }
    Object.defineProperty(CustomerTypes.prototype, "apiUrl", {
        get: function () {
            return '/customer/type';
        },
        enumerable: false,
        configurable: true
    });
    CustomerTypes = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customers', ['setCustomerType', 'deleteCustomerType'])),
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], CustomerTypes);
    return CustomerTypes;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerTypesvue_type_script_lang_ts_external = (CustomerTypes);

;// ./src/components/CustomerTypes/CustomerTypes.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerTypes_CustomerTypesvue_type_script_lang_ts_external = (CustomerTypesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerTypes/CustomerTypes.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerTypes_CustomerTypesvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerTypes_CustomerTypes = (component.exports);

/***/ }),

/***/ 4394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 4658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ContactActivitiesView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContactActivitiesView.vue?vue&type=template&id=a6fb99d4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContactActivities')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ContactActivities/ContactActivities.vue + 3 modules
var ContactActivities = __webpack_require__(4016);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContactActivitiesView.vue?vue&type=script&lang=ts



var ContactActivitiesView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactActivitiesView, _super);
    function ContactActivitiesView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContactActivitiesView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ContactActivities: ContactActivities/* default */.A
            }
        })
    ], ContactActivitiesView);
    return ContactActivitiesView;
}(lib/* Vue */.lD));
/* harmony default export */ var ContactActivitiesViewvue_type_script_lang_ts = (ContactActivitiesView);

;// ./src/views/ContactActivitiesView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ContactActivitiesViewvue_type_script_lang_ts = (ContactActivitiesViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ContactActivitiesView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ContactActivitiesViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ContactActivitiesView = (component.exports);

/***/ }),

/***/ 4696:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/custom-fields-vue");

/***/ }),

/***/ 4771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContactFunctions_ContactFunctions; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContactFunctions/ContactFunctions.vue?vue&type=template&id=3945cfed
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('customers.contactFunction.new'),"updateTitle":_vm.$t('customers.contactFunction.edit'),"deleteMsg":_vm.$t('customers.contactFunction.deleteMsg'),"sort":"label","withDefault":"","exportable":"contactFunction"},on:{"submitted":contactFunction => _vm.setContactFunction(contactFunction),"deleted":contactFunction => _vm.deleteContactFunction(contactFunction)}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContactFunctions/ContactFunctions.ts?vue&type=script&lang=ts&external




var ContactFunctions = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactFunctions, _super);
    function ContactFunctions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columns = [
            {
                label: _this.$t('customers.contactFunction.label'),
                key: 'label',
                required: true
            }
        ];
        return _this;
    }
    Object.defineProperty(ContactFunctions.prototype, "apiUrl", {
        get: function () {
            return '/customer/contact/function';
        },
        enumerable: false,
        configurable: true
    });
    ContactFunctions = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customers', ['setContactFunction', 'deleteContactFunction'])),
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], ContactFunctions);
    return ContactFunctions;
}(lib/* Vue */.lD));
/* harmony default export */ var ContactFunctionsvue_type_script_lang_ts_external = (ContactFunctions);

;// ./src/components/ContactFunctions/ContactFunctions.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContactFunctions_ContactFunctionsvue_type_script_lang_ts_external = (ContactFunctionsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ContactFunctions/ContactFunctions.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContactFunctions_ContactFunctionsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContactFunctions_ContactFunctions = (component.exports);

/***/ }),

/***/ 4779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContactDelete_ContactDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContactDelete/ContactDelete.vue?vue&type=template&id=5d19d7e3
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_c('p',[_vm._v(_vm._s(_vm.$t('customers.contact.deleteMsg')))])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContactDelete/ContactDelete.ts?vue&type=script&lang=ts&external




var ContactDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactDelete, _super);
    function ContactDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(ContactDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactDelete.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('interface.delete');
        },
        enumerable: false,
        configurable: true
    });
    ContactDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    ContactDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    ContactDelete.prototype.process = function (event) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        event.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCustomers.axios.delete('/customer/contact/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id))
                                .then(function () {
                                _this.deleted();
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactDelete.prototype.closeModal = function () {
        this.$emit('closed');
    };
    ContactDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    ContactDelete.prototype.deleted = function () {
        interface_vue_.emitter.emit('contactDeleted', this.value);
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContactDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], ContactDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContactDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContactDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], ContactDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], ContactDelete.prototype, "watchModalState", null);
    ContactDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay,
                Spinner: interface_vue_.Spinner
            }
        })
    ], ContactDelete);
    return ContactDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var ContactDeletevue_type_script_lang_ts_external = (ContactDelete);

;// ./src/components/ContactDelete/ContactDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContactDelete_ContactDeletevue_type_script_lang_ts_external = (ContactDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ContactDelete/ContactDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContactDelete_ContactDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContactDelete_ContactDelete = (component.exports);

/***/ }),

/***/ 4831:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'pencil';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f040';
var svgPathData = 'M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.zL = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 4840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 4894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isLength = __webpack_require__(294);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 4901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isLength = __webpack_require__(294),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 4932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 5097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContactsList_ContactsList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContactsList/ContactsList.vue?vue&type=template&id=11b83316
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading || !_vm.customFieldsLoaded)?_c('Spinner'):_c('k-table',{ref:"table",attrs:{"url":"/customer/contact","ajaxDatas":{ include: _vm.include.join(',') },"columns":_vm.columns,"filters":_vm.filters,"rowActions":_vm.rowActions,"rowLink":_vm.rowLink,"exportable":"contact","importable":"contact","stateKey":"contact-list"}}),_c('ContactDelete',{attrs:{"element":"modal","modal":_vm.deleteElement !== null},on:{"closed":function($event){_vm.deleteElement = null}},model:{value:(_vm.deleteElement),callback:function ($$v) {_vm.deleteElement=$$v},expression:"deleteElement"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: ./src/components/ContactDelete/ContactDelete.vue + 3 modules
var ContactDelete = __webpack_require__(4779);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContactsList/ContactsList.ts?vue&type=script&lang=ts&external







var ContactsList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactsList, _super);
    function ContactsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deleteElement = null;
        _this.include = [
            'customers', 'function', 'tags', 'customFields'
        ];
        _this.loading = false;
        return _this;
    }
    ContactsList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadCivilities()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.loadTags()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.loadContactFunctions()];
                    case 4:
                        _a.sent();
                        this.loading = false;
                        interface_vue_.emitter.on('contactCreated', this.contactCreated);
                        interface_vue_.emitter.on('contactUpdated', this.contactUpdated);
                        interface_vue_.emitter.on('contactDeleted', this.contactDeleted);
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactsList.prototype.destroyed = function () {
        interface_vue_.emitter.off('contactCreated', this.contactCreated);
        interface_vue_.emitter.off('contactUpdated', this.contactUpdated);
        interface_vue_.emitter.off('contactDeleted', this.contactDeleted);
    };
    Object.defineProperty(ContactsList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            var actions = [];
            if (this.can('contact', 2)) {
                actions.push({
                    icon: 'edit',
                    click: function (contact, index) {
                        _this.openModal({
                            key: 'contact-form',
                            value: contact,
                            submitted: function (response) {
                                var table = _this.$refs.table;
                                table.updateRow(index, response.data);
                            }
                        });
                    }
                });
            }
            if (this.can('contact', 3)) {
                actions.push({
                    icon: 'delete',
                    click: function (contact) {
                        _this.toDelete(contact);
                    }
                });
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactsList.prototype, "columns", {
        get: function () {
            return (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    data: 'customers',
                    name: this.$t('customers.list.tiers'),
                    render: function (customers) {
                        return customers.map(function (customer) { return customer.name; }).join(', ');
                    },
                    sortable: false
                },
                {
                    data: 'civility.name',
                    name: this.$t('customers.list.civility'),
                    visible: false
                },
                {
                    data: 'firstname',
                    name: this.$t('customers.list.firstname'),
                    visible: false
                },
                {
                    data: 'lastname',
                    name: this.$t('customers.list.lastname'),
                    visible: false
                },
                {
                    data: 'fullname',
                    name: this.$t('customers.list.name'),
                    sticky: true
                },
                {
                    data: 'function.label',
                    name: this.$t('customers.list.function')
                },
                {
                    data: 'comments',
                    name: this.$t('customers.list.comments'),
                    visible: false,
                    isHtml: true
                },
                {
                    data: 'road1',
                    name: this.$t('customers.list.addressRoad1'),
                    visible: false
                },
                {
                    data: 'road2',
                    name: this.$t('customers.list.addressRoad2'),
                    visible: false
                },
                {
                    data: 'road3',
                    name: this.$t('customers.list.addressRoad3'),
                    visible: false
                },
                {
                    data: 'postal_code',
                    name: this.$t('customers.list.postalCode')
                },
                {
                    data: 'town',
                    name: this.$t('customers.list.city')
                },
                {
                    data: 'country.name',
                    name: this.$t('customers.list.country')
                },
                {
                    data: 'phone',
                    name: this.$t('customers.list.phone'),
                    render: 'phone'
                },
                {
                    data: 'mobile',
                    name: this.$t('customers.list.mobile'),
                    render: 'phone'
                },
                {
                    data: 'fax',
                    name: this.$t('customers.list.fax'),
                    visible: false,
                    render: 'phone'
                },
                {
                    data: 'email',
                    name: this.$t('customers.list.email')
                },
                {
                    data: 'website',
                    name: this.$t('customers.list.website'),
                    visible: false
                },
                {
                    data: 'tags',
                    name: this.$t('customers.list.tags'),
                    render: function (data) {
                        return data.map(function (tag) { return tag.name; }).join(', ');
                    },
                    sortable: false
                },
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    visible: false,
                    render: 'datetime'
                },
                {
                    data: 'updated_at',
                    name: this.$t('interface.list.updatedAt'),
                    visible: false,
                    render: 'datetime'
                }
            ], this.customFieldTableColumns('contact'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactsList.prototype, "filters", {
        get: function () {
            return (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    type: 'phone',
                    label: this.$t('customers.filters.phone'),
                    name: 'phone_number'
                },
                {
                    type: 'phone',
                    label: this.$t('customers.filters.mobile'),
                    name: 'mobile_number'
                },
                {
                    type: 'phone',
                    label: this.$t('customers.filters.allPhone'),
                    name: 'all_phone_number'
                },
                {
                    type: 'phone',
                    label: this.$t('customers.list.fax'),
                    name: 'fax_number'
                },
                {
                    type: 'period',
                    label: this.$t('interface.list.createdAt'),
                    name: 'created_since',
                    name2: 'created_until'
                },
                {
                    type: 'select',
                    label: this.$t('customers.list.tiers'),
                    name: 'with_customer',
                    multiple: true,
                    ajax: '/customer?sort=name',
                    optionLabel: 'fullname',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('customers.list.civility'),
                    name: 'civility',
                    options: this.civilities,
                    multiple: true,
                    optionLabel: 'name',
                    value: 'id'
                },
                {
                    type: 'text',
                    label: this.$t('customers.list.firstname'),
                    name: 'firstname'
                },
                {
                    type: 'text',
                    label: this.$t('customers.list.lastname'),
                    name: 'lastname'
                },
                {
                    type: 'text',
                    label: this.$t('customers.list.email'),
                    name: 'email_address'
                },
                {
                    type: 'text',
                    label: this.$t('customers.list.website'),
                    name: 'website'
                },
                {
                    type: 'text',
                    label: this.$t('customers.list.city'),
                    name: 'address_town'
                },
                {
                    type: 'text',
                    label: this.$t('customers.list.postalCode'),
                    name: 'address_postal_code'
                },
                {
                    type: 'select',
                    label: this.$t('customers.list.country'),
                    name: 'address_country',
                    options: this.countries,
                    multiple: true,
                    optionLabel: 'name',
                    value: 'code'
                },
                {
                    type: 'select',
                    label: this.$t('customers.list.function'),
                    name: 'function',
                    options: this.contactFunctions,
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('customers.filters.allTags'),
                    name: 'all_tags',
                    options: this.tags,
                    multiple: true,
                    optionLabel: 'name',
                    value: 'name'
                },
                {
                    type: 'select',
                    label: this.$t('customers.list.tags'),
                    name: 'any_tags',
                    options: this.tags,
                    multiple: true,
                    optionLabel: 'name',
                    value: 'name'
                },
                {
                    type: 'select',
                    label: 'Type de contact',
                    name: 'attached_to',
                    options: [
                        { value: 'customer', label: 'Rattaché à un client' },
                        { value: 'prospect', label: 'Rattaché à un prospect' },
                        { value: 'provider', label: 'Rattaché à un fournisseur' },
                        { value: 'subcontractor', label: 'Rattaché à un sous-traitant' },
                        { value: 'none', label: 'Non rattaché' }
                    ],
                    multiple: true,
                    optionLabel: 'label',
                    value: 'value'
                }
            ], this.customFieldTableFilters('contact'));
        },
        enumerable: false,
        configurable: true
    });
    ContactsList.prototype.rowLink = function (contact) {
        return {
            name: 'contacts-contact-item',
            params: {
                id: String(contact.id),
                customer: JSON.stringify(contact)
            }
        };
    };
    ContactsList.prototype.toDelete = function (contact) {
        this.deleteElement = contact;
    };
    ContactsList.prototype.contactCreated = function (contact) {
        var table = this.$refs.table;
        if (!table) {
            return;
        }
        table.addRow(contact);
    };
    ContactsList.prototype.contactUpdated = function (event) {
        var table = this.$refs.table;
        if (!table) {
            return;
        }
        var index = table.getDatas().findIndex(function (data) { return data.id === event.new.id; });
        if (index >= 0) {
            table.updateRow(index, event.new);
        }
        else {
            table.addRow(event.new);
        }
    };
    ContactsList.prototype.contactDeleted = function (contact) {
        var table = this.$refs.table;
        if (!table) {
            return;
        }
        var index = table.getDatas().findIndex(function (data) { return data.id === contact.id; });
        if (index >= 0) {
            table.deleteRow(index);
        }
    };
    ContactsList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('globalDatas', ['loadCountries', 'loadCivilities', 'loadTags'])), (0,external_vuex_.mapActions)('customers', ['loadContactFunctions'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['countries', 'civilities', 'tags'])), (0,external_vuex_.mapState)('customers', ['contactFunctions'])), (0,external_vuex_.mapGetters)('user', ['can'])),
            components: {
                ContactDelete: ContactDelete/* default */.A,
                KTable: table_vue_.KTable,
                Spinner: interface_vue_.Spinner
            }
        })
    ], ContactsList);
    return ContactsList;
}((0,lib/* Mixins */.Xe)(custom_fields_vue_.CustomFieldsTableMixin)));
/* harmony default export */ var ContactsListvue_type_script_lang_ts_external = (ContactsList);

;// ./src/components/ContactsList/ContactsList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContactsList_ContactsListvue_type_script_lang_ts_external = (ContactsListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ContactsList/ContactsList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContactsList_ContactsListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContactsList_ContactsList = (component.exports);

/***/ }),

/***/ 5160:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 5278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerInformations_CustomerInformations; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerInformations/CustomerInformations.vue?vue&type=template&id=f52dfcae
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.customer)?_c('div',[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"6","lg":"12"}},[(_vm.customer.tags.length > 0)?_c('div',{staticClass:"mb-3"},_vm._l((_vm.customer.tags),function(tag,i){return _c('b-badge',{key:i,class:{
                'px-2': true,
                'py-1': true,
                'mb-1': true,
                'ml-1': i > 0
              },attrs:{"variant":"tag"}},[_vm._v(" "+_vm._s(tag.name)+" ")])}),1):_vm._e(),(_vm.hasModule('customers-group') && _vm.customer.parent)?_c('b-form-group',{attrs:{"label":_vm.teamConfigs.customer_group_parent_name}},[_c('CustomerSpeedItem',{model:{value:(_vm.customer.parent),callback:function ($$v) {_vm.$set(_vm.customer, "parent", $$v)},expression:"customer.parent"}})],1):_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.type')}},[_vm._v(" "+_vm._s(_vm.customer.type.label)+" ")]),(_vm.customer.team_user)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.commercial')}},[_vm._v(" "+_vm._s(_vm.customer.team_user.fullname)+" ")]):_vm._e(),(_vm.customer.activity)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.activity')}},[_vm._v(" "+_vm._s(_vm.customer.activity.label)+" ")]):_vm._e(),(_vm.customer.origin)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.origin')}},[_vm._v(" "+_vm._s(_vm.customer.origin.label)+" ")]):_vm._e(),(_vm.customer.billing_contact)?_c('b-form-group',{attrs:{"label":"Contact de facturation"}},[(_vm.customer.billing_contact)?_c('ContactSpeedItem',{model:{value:(_vm.customer.billing_contact),callback:function ($$v) {_vm.$set(_vm.customer, "billing_contact", $$v)},expression:"customer.billing_contact"}}):_vm._e()],1):_vm._e(),(_vm.customer.custom_fields.length > 0 && !_vm.team.configs['custom_field_' + _vm.type + '_tab'])?_c('CustomFieldsDisplay',{attrs:{"type":_vm.type,"value":_vm.customer.custom_fields,"titleClass":"form-title-alt"}}):_vm._e(),(_vm.hasModule('customers-group') && _vm.customer.childs?.length > 0)?[_c('table',{staticClass:"w-100 table table-sm align-middle"},[_c('thead',[_c('tr',[_c('th',{staticClass:"border-bottom"},[_c('h3',{staticClass:"form-title-alt border-bottom-0 m-0"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'users']}}),_vm._v(" "+_vm._s(_vm.teamConfigs.customer_group_child_name)+" ")],1)]),_c('th',{staticClass:"border-bottom text-right",staticStyle:{"width":"120px"}},[_c('k-form-select',{staticClass:"d-inline-block",staticStyle:{"width":"100px"},attrs:{"size":"sm","options":_vm.caOptions,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.childCa),callback:function ($$v) {_vm.childCa=$$v},expression:"childCa"}})],1)])]),_c('tbody',{staticClass:"small"},_vm._l((_vm.customer.childs),function(customer,i){return _c('tr',{key:i},[_c('td',[_c('CustomerSpeedItem',{staticClass:"small",attrs:{"value":customer}})],1),_c('td',{staticClass:"text-right"},[_vm._v(" "+_vm._s(_vm.formattedNumber(customer.sales_statistics[_vm.childCa]))+" ")])])}),0)])]:_vm._e()],2),_c('b-col',{attrs:{"cols":"12","sm":"6","lg":"12"}},[_c('h3',{staticClass:"form-title-alt mt-0 mt-lg-4"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'id-card']}}),_vm._v(" "+_vm._s(_vm.$t('customers.form.coordinates'))+" ")],1),(_vm.customer.phone)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.phone')}},[(_vm.teamConfigs.phone_clickable)?_c('a',{attrs:{"href":'tel:' + _vm.customer.phone}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.customer.phone))+" ")]):[_vm._v(" "+_vm._s(_vm.showPhone(_vm.customer.phone))+" ")]],2):_vm._e(),(_vm.customer.mobile)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.mobile')}},[(_vm.teamConfigs.phone_clickable)?_c('a',{attrs:{"href":'tel:' + _vm.customer.mobile}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.customer.mobile))+" ")]):[_vm._v(" "+_vm._s(_vm.showPhone(_vm.customer.mobile))+" ")]],2):_vm._e(),(_vm.customer.fax)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.fax')}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.customer.fax))+" ")]):_vm._e(),(_vm.customer.email)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.email')}},[_vm._v(" "+_vm._s(_vm.customer.email)+" ")]):_vm._e(),(_vm.customer.website)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.website')}},[_vm._v(" "+_vm._s(_vm.customer.website)+" ")]):_vm._e(),(_vm.customer.address_invoice)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.invoiceAddress')}},[(_vm.customer.address_invoice.road1)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.customer.address_invoice.road1)+" ")]):_vm._e(),(_vm.customer.address_invoice.road2)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.customer.address_invoice.road2)+" ")]):_vm._e(),(_vm.customer.address_invoice.road3)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.customer.address_invoice.road3)+" ")]):_vm._e(),(_vm.customer.address_invoice.postal_code || _vm.customer.address_invoice.town)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.customer.address_invoice.postal_code)+" "+_vm._s(_vm.customer.address_invoice.town)+" ")]):_vm._e(),(_vm.customer.address_invoice.country)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.customer.address_invoice.country.name)+" ")]):_vm._e()]):_vm._e(),(_vm.customer.address_delivery && (!_vm.customer.address_invoice || _vm.customer.address_delivery.id !== _vm.customer.address_invoice.id))?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.deliveryAddress')}},[(_vm.customer.address_delivery.road1)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.customer.address_delivery.road1)+" ")]):_vm._e(),(_vm.customer.address_delivery.road2)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.customer.address_delivery.road2)+" ")]):_vm._e(),(_vm.customer.address_delivery.road3)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.customer.address_delivery.road3)+" ")]):_vm._e(),(_vm.customer.address_delivery.postal_code || _vm.customer.address_delivery.town)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.customer.address_delivery.postal_code)+" "+_vm._s(_vm.customer.address_delivery.town)+" ")]):_vm._e(),(_vm.customer.address_delivery.country)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.customer.address_delivery.country.name)+" ")]):_vm._e()]):_vm._e(),(_vm.can(_vm.type, 3))?_c('b-button',{staticClass:"mr-2 mb-1",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.addCustomerAddress = true}}},[_vm._v(" "+_vm._s(_vm.$t('customers.address.addAddress'))+" ")]):_vm._e(),_c('b-button',{staticClass:"mb-1",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.showCustomerAddresses = true}}},[_vm._v(" "+_vm._s(_vm.$t('customers.address.manage'))+" ")]),(_vm.addCustomerAddress)?_c('CustomerAddressForm',{attrs:{"modalState":true,"customer":_vm.customer},on:{"hidden":function($event){_vm.addCustomerAddress = false},"submitComplete":_vm.addressesUpdated}}):_vm._e(),(_vm.showCustomerAddresses)?_c('CustomerAddressList',{attrs:{"modalState":true,"customer":_vm.customer,"type":_vm.type},on:{"hidden":function($event){_vm.showCustomerAddresses = false},"created":_vm.addressesUpdated,"updated":_vm.addressesUpdated,"deleted":_vm.addressesDeleted}}):_vm._e()],1)],1)],1),((_vm.customer.reference.prospect || _vm.customer.reference.customer) && _vm.can('sales-quotation', 1))?_c('div',{staticClass:"customer-amounts"},[_c('p',[_c('span',{staticClass:"label"},[_vm._v("Devis en attente")]),_c('span',{staticClass:"amount text-success"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.customer.sales_statistics.quotations)))])])]):_vm._e(),(_vm.customer.reference.customer && _vm.can('sales-invoice', 1))?_c('div',{staticClass:"customer-amounts"},[_c('p',[_c('span',{staticClass:"label"},[_vm._v("Chiffre d'affaires total")]),_c('span',{staticClass:"amount text-success"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.customer.sales_statistics.total)))])]),_c('p',[_c('span',{staticClass:"label"},[_vm._v("Chiffre d'affaires "+_vm._s(new Date().getFullYear()))]),_c('span',{staticClass:"amount text-success"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.customer.sales_statistics.current_year)))])]),_c('p',[_c('span',{staticClass:"label"},[_vm._v("Chiffre d'affaires "+_vm._s(new Date().getFullYear() - 1))]),_c('span',{staticClass:"amount text-success"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.customer.sales_statistics.previous_year)))])]),_c('p',[_c('span',{staticClass:"label"},[_vm._v("Paiement en attente")]),_c('span',{staticClass:"amount text-danger"},[_vm._v(_vm._s(_vm.formattedNumber(_vm.customer.sales_statistics.to_paid)))])])]):_vm._e(),_c('b-card',{class:{ 'mt-3': !(_vm.customer.reference.customer && _vm.can('sales-invoice', 1)) }},[(_vm.customer.company_siret)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.siret')}},[_vm._v(" "+_vm._s(_vm.customer.company_siret)+" ")]):_vm._e(),(_vm.customer.company_vatrate)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.vatrate')}},[_vm._v(" "+_vm._s(_vm.customer.company_vatrate)+" ")]):_vm._e(),(_vm.customer.company_type)?_c('b-form-group',{attrs:{"label":"Type d'entreprise"}},[_vm._v(" "+_vm._s(_vm.customer.company_type)+" ")]):_vm._e(),(_vm.customer.company_rcs)?_c('b-form-group',{attrs:{"label":"Numéro RCS"}},[_vm._v(" "+_vm._s(_vm.customer.company_rcs)+" ")]):_vm._e(),(_vm.customer.company_naf)?_c('b-form-group',{attrs:{"label":"Code NAF"}},[_vm._v(" "+_vm._s(_vm.customer.company_naf)+" ")]):_vm._e(),(_vm.customer.company_capital)?_c('b-form-group',{attrs:{"label":"Capital"}},[_vm._v(" "+_vm._s(_vm.customer.company_capital)+" ")]):_vm._e(),(_vm.customer.birth_date)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.birthDate')}},[_vm._v(" "+_vm._s(_vm.date(_vm.customer.birth_date))+" ")]):_vm._e(),(_vm.customer.reference.customer)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.item.customerReference')}},[_vm._v(" "+_vm._s(_vm.customer.reference.customer)+" ")]):(_vm.customer.reference.prospect)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.item.prospectReference')}},[_vm._v(" "+_vm._s(_vm.customer.reference.prospect)+" ")]):_vm._e(),(_vm.customer.reference.provider)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.item.providerReference')}},[_vm._v(" "+_vm._s(_vm.customer.reference.provider)+" ")]):_vm._e(),(_vm.customer.reference.subcontractor)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.item.subcontractorReference')}},[_vm._v(" "+_vm._s(_vm.customer.reference.subcontractor)+" ")]):_vm._e(),(_vm.customer.customer_account)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.item.customerAccount')}},[_vm._v(" "+_vm._s(_vm.customer.customer_account)+" ")]):_vm._e(),(_vm.customer.provider_account)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.item.providerAccount')}},[_vm._v(" "+_vm._s(_vm.customer.provider_account)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('customers.item.createdAt')}},[_vm._v(" "+_vm._s(_vm.datetime(_vm.customer.created_at))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('customers.item.updatedAt')}},[_vm._v(" "+_vm._s(_vm.datetime(_vm.customer.updated_at))+" ")]),(_vm.customer.reference.customer && _vm.customer.transformed_at)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.item.transformedAt')}},[_vm._v(" "+_vm._s(_vm.datetime(_vm.customer.transformed_at))+" ")]):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/CustomerAddressForm/CustomerAddressForm.vue + 3 modules
var CustomerAddressForm = __webpack_require__(2661);
// EXTERNAL MODULE: ./src/components/CustomerAddressList/CustomerAddressList.vue + 3 modules
var CustomerAddressList = __webpack_require__(1223);
// EXTERNAL MODULE: ./src/components/CustomerSpeedItem/CustomerSpeedItem.vue + 3 modules
var CustomerSpeedItem = __webpack_require__(2930);
// EXTERNAL MODULE: ./src/components/ContactSpeedItem/ContactSpeedItem.vue + 3 modules
var ContactSpeedItem = __webpack_require__(4256);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerInformations/CustomerInformations.ts?vue&type=script&lang=ts&external












var CustomerInformations = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerInformations, _super);
    function CustomerInformations() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.customer = null;
        _this.addCustomerAddress = false;
        _this.childCa = 'current_year';
        _this.showCustomerAddresses = false;
        return _this;
    }
    CustomerInformations.prototype.mounted = function () {
        var _a;
        this.childCa = (_a = sessionStorage.getItem('customer-child-ca')) !== null && _a !== void 0 ? _a : 'current_year';
    };
    Object.defineProperty(CustomerInformations.prototype, "caOptions", {
        get: function () {
            return [
                { label: 'CA ' + (0,interface_vue_.moment)().format('YYYY'), value: 'current_year' },
                { label: 'CA ' + (0,interface_vue_.moment)().subtract(1, 'year').format('YYYY'), value: 'previous_year' },
                { label: 'CA total', value: 'total' },
                { label: 'À payer', value: 'to_paid' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    CustomerInformations.prototype.watchValue = function (customer) {
        this.customer = JSON.parse(JSON.stringify(customer));
    };
    CustomerInformations.prototype.watchChildCa = function () {
        sessionStorage.setItem('customer-child-ca', this.childCa);
    };
    CustomerInformations.prototype.addressesUpdated = function (address) {
        var customer = this.customer;
        var index = customer.addresses.findIndex(function (val) { return val.id === address.id; });
        if (index === -1) {
            customer.addresses.push(address);
        }
        else {
            lib/* Vue */.lD.set(customer.addresses, index, address);
        }
        if (address.use_for_delivery) {
            if (customer.address_delivery && customer.address_delivery.id !== address.id) {
                var delivery = customer.addresses.find(function (val) { return val.use_for_delivery && val.id !== address.id; });
                if (delivery) {
                    delivery.use_for_delivery = false;
                }
            }
            customer.address_delivery = address;
        }
        if (address.use_for_invoice) {
            if (customer.address_invoice && customer.address_invoice.id !== address.id) {
                var invoice = customer.addresses.find(function (val) { return val.use_for_invoice && val.id !== address.id; });
                if (invoice) {
                    invoice.use_for_invoice = false;
                }
            }
            customer.address_invoice = address;
        }
        this.cleanAddresses(address);
    };
    // Event when an address is deleted
    CustomerInformations.prototype.addressesDeleted = function (address) {
        var customer = this.customer;
        var index = customer.addresses.findIndex(function (val) { return val.id === address.id; });
        if (index >= 0) {
            lib/* Vue */.lD.delete(customer.addresses, index);
        }
        this.cleanAddresses(address, true);
    };
    // Clean default address is needed
    CustomerInformations.prototype.cleanAddresses = function (address, deleted) {
        var _a, _b;
        if (deleted === void 0) { deleted = false; }
        var customer = this.customer;
        if ((!address.use_for_invoice || deleted) && ((_a = customer.address_invoice) === null || _a === void 0 ? void 0 : _a.id) === address.id) {
            customer.address_invoice = null;
        }
        if ((!address.use_for_delivery || deleted) && ((_b = customer.address_delivery) === null || _b === void 0 ? void 0 : _b.id) === address.id) {
            customer.address_delivery = null;
        }
        this.$emit('input', customer);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerInformations.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerInformations.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true, deep: true })
    ], CustomerInformations.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('childCa')
    ], CustomerInformations.prototype, "watchChildCa", null);
    CustomerInformations = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'team', 'teamConfigs'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                CustomFieldsDisplay: custom_fields_vue_.CustomFieldsDisplay,
                CustomerAddressForm: CustomerAddressForm/* default */.A, CustomerAddressList: CustomerAddressList/* default */.A, CustomerSpeedItem: CustomerSpeedItem/* default */.A, ContactSpeedItem: ContactSpeedItem/* default */.A,
                BCard: external_bootstrap_vue_.BCard, BBadge: external_bootstrap_vue_.BBadge, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], CustomerInformations);
    return CustomerInformations;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin, interface_vue_.PhoneMixin)));
/* harmony default export */ var CustomerInformationsvue_type_script_lang_ts_external = (CustomerInformations);

;// ./src/components/CustomerInformations/CustomerInformations.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerInformations_CustomerInformationsvue_type_script_lang_ts_external = (CustomerInformationsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerInformations/CustomerInformations.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerInformations_CustomerInformationsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerInformations_CustomerInformations = (component.exports);

/***/ }),

/***/ 5469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContactInformations_ContactInformations; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContactInformations/ContactInformations.vue?vue&type=template&id=65a7f46a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',[(_vm.contact.tags.length > 0)?_c('div',{staticClass:"mb-3"},_vm._l((_vm.contact.tags),function(tag,i){return _c('b-badge',{key:i,class:{
              'px-2': true,
              'py-1': true,
              'mb-1': true,
              'ml-1': i > 0
            },attrs:{"variant":"tag"}},[_vm._v(" "+_vm._s(tag.name)+" ")])}),1):_vm._e(),(_vm.contact.customers.length > 0)?_c('b-form-group',{attrs:{"label":"Tiers :"}},[_vm._l((_vm.contact.customers),function(customer,i){return [(i > 0)?_c('span',{key:'separator-' + i},[_c('br')]):_vm._e(),_c('b-button',{key:i,staticClass:"p-0",attrs:{"variant":"link","to":{
          name: 'contacts-customer-item',
          params: {
            id: customer.id,
            type: _vm.customerType(customer)
          }
        }}},[_vm._v(" "+_vm._s(customer.name)+" ")])]})],2):_vm._e(),(_vm.contact.function)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.function')}},[_vm._v(" "+_vm._s(_vm.contact.function.label)+" ")]):_vm._e(),(_vm.contact.comments)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.comments')}},[_c('FroalaView',{model:{value:(_vm.contact.comments),callback:function ($$v) {_vm.$set(_vm.contact, "comments", $$v)},expression:"contact.comments"}})],1):_vm._e(),(_vm.contact.phone || _vm.contact.mobile || _vm.contact.fax || _vm.contact.email || _vm.contact.website || _vm.contact.road1 ||
      _vm.contact.road2 || _vm.contact.road3 || _vm.contact.postal_code || _vm.contact.town || _vm.contact.country)?_c('h3',{staticClass:"form-title-alt"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'id-card']}}),_vm._v(" "+_vm._s(_vm.$t('customers.form.coordinates'))+" ")],1):_vm._e(),(_vm.contact.phone)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.phone')}},[(_vm.teamConfigs.phone_clickable)?_c('a',{attrs:{"href":'tel:' + _vm.contact.phone}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.contact.phone))+" ")]):[_vm._v(" "+_vm._s(_vm.showPhone(_vm.contact.phone))+" ")]],2):_vm._e(),(_vm.contact.mobile)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.mobile')}},[(_vm.teamConfigs.phone_clickable)?_c('a',{attrs:{"href":'tel:' + _vm.contact.mobile}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.contact.mobile))+" ")]):[_vm._v(" "+_vm._s(_vm.showPhone(_vm.contact.mobile))+" ")]],2):_vm._e(),(_vm.contact.fax)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.fax')}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.contact.fax))+" ")]):_vm._e(),(_vm.contact.email)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.email')}},[_vm._v(" "+_vm._s(_vm.contact.email)+" ")]):_vm._e(),(_vm.contact.website)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.website')}},[_vm._v(" "+_vm._s(_vm.contact.website)+" ")]):_vm._e(),(_vm.contact.road1 || _vm.contact.road2 || _vm.contact.road3 || _vm.contact.postal_code || _vm.contact.town || _vm.contact.country)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.address')}},[(_vm.contact.road1)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.contact.road1)+" ")]):_vm._e(),(_vm.contact.road2)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.contact.road2)+" ")]):_vm._e(),(_vm.contact.road3)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.contact.road3)+" ")]):_vm._e(),(_vm.contact.postal_code || _vm.contact.town)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.contact.postal_code)+" "+_vm._s(_vm.contact.town)+" ")]):_vm._e(),(_vm.contact.country)?_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.contact.country.name)+" ")]):_vm._e()]):_vm._e(),(_vm.contact.custom_fields.length > 0 && !_vm.team.configs.custom_field_contact_tab)?_c('CustomFieldsDisplay',{attrs:{"type":"contact","value":_vm.contact.custom_fields,"titleClass":"form-title-alt"}}):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContactInformations/ContactInformations.ts?vue&type=script&lang=ts&external








var ContactInformations = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactInformations, _super);
    function ContactInformations() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ContactInformations.prototype, "customerType", {
        get: function () {
            return function (customer) {
                var references = customer.reference;
                if (references.customer)
                    return 'customer';
                else if (references.prospect)
                    return 'prospect';
                else if (references.provider)
                    return 'provider';
                else
                    return 'subcontractor';
            };
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ContactInformations.prototype, "contact", void 0);
    ContactInformations = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['team', 'teamConfigs'])),
            components: {
                CustomFieldsDisplay: custom_fields_vue_.CustomFieldsDisplay,
                BCard: external_bootstrap_vue_.BCard, BBadge: external_bootstrap_vue_.BBadge, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                FroalaView: form_vue_.FroalaView
            }
        })
    ], ContactInformations);
    return ContactInformations;
}((0,lib/* Mixins */.Xe)(interface_vue_.PhoneMixin)));
/* harmony default export */ var ContactInformationsvue_type_script_lang_ts_external = (ContactInformations);

;// ./src/components/ContactInformations/ContactInformations.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContactInformations_ContactInformationsvue_type_script_lang_ts_external = (ContactInformationsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ContactInformations/ContactInformations.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContactInformations_ContactInformationsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContactInformations_ContactInformations = (component.exports);

/***/ }),

/***/ 5527:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 5808:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(2507);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),

/***/ 5837:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'id-card';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f2c2';
var svgPathData = 'M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Lm = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerSaleParams_CustomerSaleParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerSaleParams/CustomerSaleParams.vue?vue&type=template&id=c98c0a32
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_vm.withForm ? 'k-form' : 'div',_vm._g(_vm._b({tag:"component"},'component',_vm.formAttributes,false),_vm.formEvents),[_c('input',{attrs:{"type":"hidden","name":"configs[sales_disabled_invoice_automatic_reminder]"},domProps:{"value":_vm.localConfig.sales_disabled_invoice_automatic_reminder ?? false}}),_c('k-form-checkbox',{staticClass:"mb-4",model:{value:(_vm.localConfig.sales_disabled_invoice_automatic_reminder),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_disabled_invoice_automatic_reminder", $$v)},expression:"localConfig.sales_disabled_invoice_automatic_reminder"}},[_vm._v(" Ne pas relancer automatiquement les factures impayées pour ce client ")]),_c('b-form-group',{attrs:{"label":"Message d'alerte à afficher lors de la création d'un document de vente"}},[_c('k-form-editor',{attrs:{"name":"sales_alert_message","value":_vm.value.sales_alert_message,"size":"sm","mode":"simple"}})],1),(_vm.hasModule('sales-commissions') && _vm.can('sales-commissions', 1))?_c('div',{staticClass:"mb-4"},[_c('h3',{staticClass:"form-title-alt"},[_vm._v(" "+_vm._s(_vm.$t('customers.salesPreferences.commissionTitle'))+" ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.commissionPourcent'),"description":_vm.$t('customers.salesPreferences.commissionPourcentExplain')}},[_c('b-input-group',{staticStyle:{"width":"120px"},attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"name":"configs[sales_commissions_pourcentage]","min":0,"max":100,"noDefaultValue":""},model:{value:(_vm.localConfig.sales_commissions_pourcentage),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_commissions_pourcentage", $$v)},expression:"localConfig.sales_commissions_pourcentage"}})],1)],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.commissionValidity'),"description":_vm.$t('customers.salesPreferences.commissionValidityExplain')}},[_c('k-form-datepicker',{attrs:{"name":"configs[sales_commissions_end]"},model:{value:(_vm.localConfig.sales_commissions_end),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_commissions_end", $$v)},expression:"localConfig.sales_commissions_end"}})],1)],1)],1)],1):_vm._e(),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" "+_vm._s(_vm.$t('customers.salesPreferences.defaultTitle'))+" ")]),_c('b-row',{attrs:{"cols":"3"}},[_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.globalDiscount')}},[_c('b-input-group',{staticStyle:{"width":"120px"},attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"name":"configs[sales_global_discount]","min":0,"max":100,"noDefaultValue":""},model:{value:(_vm.localConfig.sales_global_discount),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_global_discount", $$v)},expression:"localConfig.sales_global_discount"}})],1)],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.vatRate')}},[_c('input',{attrs:{"type":"hidden","name":"configs[sales_vat_rate]"},domProps:{"value":_vm.localConfig.sales_vat_rate ? _vm.localConfig.sales_vat_rate.id : null}}),_c('VatRateSelect',{attrs:{"clearable":""},model:{value:(_vm.localConfig.sales_vat_rate),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_vat_rate", $$v)},expression:"localConfig.sales_vat_rate"}})],1)],1),(_vm.hasModule('sales-currencies'))?_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.currency')}},[_c('input',{attrs:{"type":"hidden","name":"configs[sales_currency]"},domProps:{"value":_vm.localConfig.sales_currency ? _vm.localConfig.sales_currency.id : null}}),_c('CurrencySelect',{attrs:{"clearable":""},model:{value:(_vm.localConfig.sales_currency),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_currency", $$v)},expression:"localConfig.sales_currency"}})],1)],1):_vm._e(),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.paymentTerm')}},[_c('PaymentTermSelect',{attrs:{"name":"configs[sales_payment_term]","reduce":opt => opt.id,"clearable":""},model:{value:(_vm.localConfig.sales_payment_term),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_payment_term", $$v)},expression:"localConfig.sales_payment_term"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.saleTerms')}},[_c('SaleTermsSelect',{attrs:{"name":"configs[sales_sale_term]","reduce":opt =>opt.id,"clearable":""},model:{value:(_vm.localConfig.sales_sale_term),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_sale_term", $$v)},expression:"localConfig.sales_sale_term"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.pdfModel')}},[_c('input',{attrs:{"type":"hidden","name":"configs[sales_pdf_model]"},domProps:{"value":_vm.localConfig.sales_pdf_model ? _vm.localConfig.sales_pdf_model.id : null}}),_c('PdfModelSelect',{attrs:{"clearable":true},model:{value:(_vm.localConfig.sales_pdf_model),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_model", $$v)},expression:"localConfig.sales_pdf_model"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.advanceRate')}},[_c('b-input-group',{staticStyle:{"width":"120px"},attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"name":"configs[sales_payment_advance_rate]","min":0,"max":100,"noDefaultValue":""},model:{value:(_vm.localConfig.sales_payment_advance_rate),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_payment_advance_rate", $$v)},expression:"localConfig.sales_payment_advance_rate"}})],1)],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.escompteRate')}},[_c('b-input-group',{staticStyle:{"width":"120px"},attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"name":"configs[sales_escompte_rate]","min":0,"max":100,"noDefaultValue":""},model:{value:(_vm.localConfig.sales_escompte_rate),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_escompte_rate", $$v)},expression:"localConfig.sales_escompte_rate"}})],1)],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.penaltyRate')}},[_c('b-input-group',{staticStyle:{"width":"120px"},attrs:{"append":"%"}},[_c('k-form-number',{attrs:{"name":"configs[sales_penalty_rate]","min":0,"max":100,"noDefaultValue":""},model:{value:(_vm.localConfig.sales_penalty_rate),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_penalty_rate", $$v)},expression:"localConfig.sales_penalty_rate"}})],1)],1)],1),_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.paymentMethods'),"label-class":"mb-1"}},[_c('k-form-checkbox-group',{attrs:{"options":_vm.paymentMethods,"text-field":"label","value-field":"id"},model:{value:(_vm.selectedPaymentMethods),callback:function ($$v) {_vm.selectedPaymentMethods=$$v},expression:"selectedPaymentMethods"}}),(_vm.selectedPaymentMethods.length > 0)?_vm._l((_vm.selectedPaymentMethods),function(id){return _c('input',{key:id,attrs:{"validation-name":"configs[sales_payment_methods]","type":"hidden","name":"configs[sales_payment_methods][]"},domProps:{"value":id}})}):_c('input',{attrs:{"type":"hidden","name":"configs[sales_payment_methods]"},domProps:{"value":null}})],2)],1),(_vm.hasModule('sales-guarantee-holdback'))?_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.guaranteeHoldback')}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticStyle:{"max-width":"170px"},attrs:{"cols":"auto"}},[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-spinner',{attrs:{"size":"sm","name":"configs[sales_guarantee_holdback_pourcent]","min":"0","max":"100","left":"","noDefaultValue":""},model:{value:(_vm.localConfig.sales_guarantee_holdback_pourcent),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_guarantee_holdback_pourcent", $$v)},expression:"localConfig.sales_guarantee_holdback_pourcent"}})],1)],1),_c('b-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_vm._v(_vm._s(_vm.$t('customers.salesPreferences.guaranteeHoldbackOn')))]),_c('b-col',{staticStyle:{"max-width":"170px"},attrs:{"cols":"auto"}},[_c('b-input-group',{attrs:{"append":"mois","size":"sm"}},[_c('k-form-spinner',{attrs:{"size":"sm","name":"configs[sales_guarantee_holdback_duration]","min":"0","left":"","noDefaultValue":""},model:{value:(_vm.localConfig.sales_guarantee_holdback_duration),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_guarantee_holdback_duration", $$v)},expression:"localConfig.sales_guarantee_holdback_duration"}})],1)],1)],1)],1)],1):_vm._e()],1),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" "+_vm._s(_vm.$t('customers.salesPreferences.displayOptions'))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.globalVatRate')}},[_c('k-form-select',{attrs:{"options":_vm.selectVatRates,"reduce":opt => opt.id,"name":"configs[sales_use_global_vatrate]"},model:{value:(_vm.localConfig.sales_use_global_vatrate),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_use_global_vatrate", $$v)},expression:"localConfig.sales_use_global_vatrate"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.amountsType')}},[_c('k-form-select',{attrs:{"options":_vm.amountsType,"reduce":opt => opt.id,"name":"configs[sales_amounts_type]"},model:{value:(_vm.localConfig.sales_amounts_type),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_amounts_type", $$v)},expression:"localConfig.sales_amounts_type"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('customers.salesPreferences.pdfAmounts')}},[_c('k-form-select',{attrs:{"options":_vm.amounts,"reduce":opt => opt.id,"name":"configs[sales_pdf_amounts]"},model:{value:(_vm.localConfig.sales_pdf_amounts),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_pdf_amounts", $$v)},expression:"localConfig.sales_pdf_amounts"}})],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@kwixeo/sales-vue"
var sales_vue_ = __webpack_require__(2779);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerSaleParams/CustomerSaleParams.ts?vue&type=script&lang=ts&external







var CustomerSaleParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerSaleParams, _super);
    function CustomerSaleParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localConfig = {};
        _this.selectedPaymentMethods = [];
        _this.selectVatRates = [
            { id: true, label: _this.$t('sales.form.inputOptions.vatrateSelectionOne') },
            { id: false, label: _this.$t('sales.form.inputOptions.vatrateSelectionMultiple') }
        ];
        _this.amountsType = [
            { id: 'ht', label: _this.$t('sales.form.inputOptions.amountTypesHt') },
            { id: 'ttc', label: _this.$t('sales.form.inputOptions.amountTypesTtc') }
        ];
        _this.amounts = [
            { id: 1, label: _this.$t('sales.form.pdfOptions.amountsChoice1') },
            { id: 2, label: _this.$t('sales.form.pdfOptions.amountsChoice2') },
            { id: 3, label: _this.$t('sales.form.pdfOptions.amountsChoice3') },
            { id: 4, label: _this.$t('sales.form.pdfOptions.amountsChoice4') }
        ];
        return _this;
    }
    CustomerSaleParams.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadPaymentMethods()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CustomerSaleParams.prototype, "formAttributes", {
        get: function () {
            return {
                action: this.formAction,
                method: 'PUT',
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSaleParams.prototype, "formEvents", {
        get: function () {
            return {
                submitComplete: this.formSubmitted
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSaleParams.prototype, "formAction", {
        get: function () {
            return '/customer/' + this.value.id;
        },
        enumerable: false,
        configurable: true
    });
    CustomerSaleParams.prototype.watchValue = function (value) {
        var _a;
        this.localConfig = JSON.parse(JSON.stringify((_a = value.configs) !== null && _a !== void 0 ? _a : {}));
    };
    CustomerSaleParams.prototype.watchSalesPaymentMethods = function () {
        var methods = this.localConfig.sales_payment_methods ? this.localConfig.sales_payment_methods : [];
        this.selectedPaymentMethods = methods.map(function (method) { return method.id; });
    };
    CustomerSaleParams.prototype.formSubmitted = function (response) {
        this.$emit('input', response.data);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerSaleParams.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CustomerSaleParams.prototype, "withForm", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CustomerSaleParams.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('localConfig.sales_payment_methods', { immediate: true })
    ], CustomerSaleParams.prototype, "watchSalesPaymentMethods", null);
    CustomerSaleParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KFormCheckbox: form_vue_.KFormCheckbox, KFormNumber: form_vue_.KFormNumber, KFormSelect: form_vue_.KFormSelect, KFormDatepicker: form_vue_.KFormDatepicker, KFormEditor: form_vue_.KFormEditor, KFormSpinner: form_vue_.KFormSpinner,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                SaleTermsSelect: sales_vue_.SaleTermsSelect, PdfModelSelect: sales_vue_.PdfModelSelect,
                VatRateSelect: interface_vue_.VatRateSelect, CurrencySelect: interface_vue_.CurrencySelect,
                PaymentTermSelect: interface_vue_.PaymentTermSelect
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadPaymentMethods'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['paymentMethods'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapGetters)('user', ['can']))
        })
    ], CustomerSaleParams);
    return CustomerSaleParams;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerSaleParamsvue_type_script_lang_ts_external = (CustomerSaleParams);

;// ./src/components/CustomerSaleParams/CustomerSaleParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerSaleParams_CustomerSaleParamsvue_type_script_lang_ts_external = (CustomerSaleParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerSaleParams/CustomerSaleParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerSaleParams_CustomerSaleParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerSaleParams_CustomerSaleParams = (component.exports);

/***/ }),

/***/ 5950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerReference_CustomerReference; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerReference/CustomerReference.vue?vue&type=template&id=2157548e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.buttonLabel,"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_c('p',[_vm._v(_vm._s(_vm.message))])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerReference/CustomerReference.ts?vue&type=script&lang=ts&external



var CustomerReference = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerReference, _super);
    function CustomerReference() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(CustomerReference.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerReference.prototype, "buttonLabel", {
        get: function () {
            var references = this.value.reference;
            switch (this.type) {
                case 'provider':
                    return this.$t('customers.references.provider.' + (references.provider ? 'delete' : 'add'));
                case 'subcontractor':
                    return this.$t('customers.references.subcontractor.' + (references.subcontractor ? 'delete' : 'add'));
                case 'prospect':
                    if (references.customer) {
                        return this.$t('customers.references.prospect.transform');
                    }
                    return this.$t('customers.references.prospect.' + (references.prospect ? 'delete' : 'add'));
                case 'customer':
                    if (!references.customer && references.prospect) {
                        return this.$t('customers.references.customer.transform');
                    }
                    return this.$t('customers.references.customer.' + (references.customer ? 'delete' : 'add'));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerReference.prototype, "message", {
        get: function () {
            var references = this.value.reference;
            switch (this.type) {
                case 'provider':
                    return this.$t('customers.references.provider.' + (references.provider ? 'deleteConfirm' : 'addConfirm'));
                case 'subcontractor':
                    return this.$t('customers.references.subcontractor.' + (references.subcontractor ? 'deleteConfirm' : 'addConfirm'));
                default:
                    if (references.customer) {
                        return this.$t('customers.references.prospect.transformConfirm');
                    }
                    else {
                        return this.$t('customers.references.customer.transformConfirm');
                    }
            }
        },
        enumerable: false,
        configurable: true
    });
    CustomerReference.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    CustomerReference.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    Object.defineProperty(CustomerReference.prototype, "formData", {
        get: function () {
            var references = this.value.reference;
            switch (this.type) {
                case 'provider':
                    return {
                        is_provider: references.provider === null
                    };
                case 'subcontractor':
                    return {
                        is_subcontractor: references.subcontractor === null
                    };
                case 'customer':
                    return {
                        is_customer: references.customer === null
                    };
                case 'prospect':
                    return {
                        is_prospect: references.prospect === null || references.customer !== null
                    };
            }
        },
        enumerable: false,
        configurable: true
    });
    CustomerReference.prototype.process = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCustomers.axios.put('/customer/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id), this.formData)
                                .then(function (response) {
                                _this.customerUpdated(response.data);
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerReference.prototype.closeModal = function () {
        this.$emit('closed');
    };
    CustomerReference.prototype.canceled = function () {
        this.$emit('canceled');
    };
    CustomerReference.prototype.customerUpdated = function (customer) {
        this.$emit('updated', customer);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerReference.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerReference.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], CustomerReference.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerReference.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerReference.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerReference.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerReference.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CustomerReference.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], CustomerReference.prototype, "watchModalState", null);
    CustomerReference = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], CustomerReference);
    return CustomerReference;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerReferencevue_type_script_lang_ts_external = (CustomerReference);

;// ./src/components/CustomerReference/CustomerReference.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerReference_CustomerReferencevue_type_script_lang_ts_external = (CustomerReferencevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerReference/CustomerReference.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerReference_CustomerReferencevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerReference_CustomerReference = (component.exports);

/***/ }),

/***/ 6009:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(4840);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 6059:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'arrow-alt-left';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f355';
var svgPathData = 'M448 208v96c0 13.3-10.7 24-24 24H224v103.8c0 21.4-25.8 32.1-41 17L7 273c-9.4-9.4-9.4-24.6 0-34L183 63.3c15.1-15.1 41-4.4 41 17V184h200c13.3 0 24 10.7 24 24z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.XZ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ContactsItemView_ContactsItemView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ContactsItemView/ContactsItemView.vue?vue&type=template&id=2f76162a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('ContactItem',{model:{value:(_vm.contact),callback:function ($$v) {_vm.contact=$$v},expression:"contact"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: ./src/components/ContactItem/ContactItem.vue + 7 modules
var ContactItem = __webpack_require__(3095);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/fetchDatas/contact.ts
var fetchDatas_contact = __webpack_require__(3408);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/ContactsItemView/ContactsItemView.ts?vue&type=script&lang=ts&external






var ContactsItemView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactsItemView, _super);
    function ContactsItemView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.contact = null;
        return _this;
    }
    ContactsItemView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['pageParams'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setPageParams'])),
            components: {
                ContactItem: ContactItem/* default */.A,
                Spinner: interface_vue_.Spinner
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var pageParams;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                pageParams = lib/* Vue */.lD.prototype.$kwCustomers.store.state.app.pageParams;
                                if (pageParams && !(0,fetchDatas_contact/* needFetchContact */.Hz)(pageParams)) {
                                    next(function (vm) {
                                        vm.contact = JSON.parse(JSON.stringify(vm.pageParams));
                                        vm.setPageParams(null);
                                        vm.loading = false;
                                    });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,fetchDatas_contact/* fetchContact */.tY)(to.params.id)
                                        .then(function (contact) {
                                        next(function (vm) {
                                            vm.contact = contact;
                                            vm.loading = false;
                                            if (vm.pageParams) {
                                                vm.setPageParams(null);
                                            }
                                        });
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var contact;
                    var _this = this;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!to.params.id) {
                                    next();
                                    return [2 /*return*/];
                                }
                                if (this.pageParams) {
                                    contact = JSON.parse(JSON.stringify(this.pageParams));
                                    this.setPageParams(null);
                                    if ((0,fetchDatas_contact/* needFetchContact */.Hz)(contact)) {
                                        this.contact = contact;
                                        next();
                                        return [2 /*return*/];
                                    }
                                }
                                this.loading = true;
                                this.contact = null;
                                return [4 /*yield*/, (0,fetchDatas_contact/* fetchContact */.tY)(to.params.id)
                                        .then(function (contact) {
                                        _this.contact = contact;
                                        _this.loading = false;
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], ContactsItemView);
    return ContactsItemView;
}(lib/* Vue */.lD));
/* harmony default export */ var ContactsItemViewvue_type_script_lang_ts_external = (ContactsItemView);

;// ./src/views/ContactsItemView/ContactsItemView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContactsItemView_ContactsItemViewvue_type_script_lang_ts_external = (ContactsItemViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ContactsItemView/ContactsItemView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContactsItemView_ContactsItemViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContactsItemView_ContactsItemView = (component.exports);

/***/ }),

/***/ 6449:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 6598:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'plus-circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f055';
var svgPathData = 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.OQ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(3221);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 6709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CustomersParamsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CustomersParamsView.vue?vue&type=template&id=312ce717
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tabs',{staticClass:"tabs-card"},[_c('b-tab',{attrs:{"title":"Paramètres"}},[_c('CustomersParams')],1),(_vm.hasModule('customers-group'))?_c('b-tab',{attrs:{"title":"Groupes de tiers"}},[_c('CustomersParamsGroup')],1):_vm._e(),_c('b-tab',{attrs:{"title":_vm.$t('customers.params.referenceTitle')}},[_c('CustomersParamsReferences')],1),_c('b-tab',{attrs:{"title":_vm.$t('customers.params.accountTitle')}},[_c('CustomersParamsAccount')],1),_c('b-tab',{attrs:{"title":"Export PDF"}},[_c('CustomersParamsPdf')],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/components/CustomersParams/CustomersParams.vue + 3 modules
var CustomersParams = __webpack_require__(2324);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomersParamsAccount/CustomersParamsAccount.vue?vue&type=template&id=0c6ba668
var CustomersParamsAccountvue_type_template_id_0c6ba668_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{staticClass:"customers-params",attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('p',{staticClass:"text-justify"},[_vm._v(" "+_vm._s(_vm.$t('customers.params.accountExplain'))+" ")]),_c('h3',{staticClass:"form-title-alt"},[_vm._v("Comptes clients")]),_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Type de numérotation"}},[_c('b-form-radio-group',{attrs:{"name":"configs[customer_account_custom]","stacked":""},on:{"input":_vm.customerAccountModeChanged},model:{value:(_vm.localConfig.customer_account_custom),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_account_custom", $$v)},expression:"localConfig.customer_account_custom"}},[_c('b-form-radio',{staticClass:"mt-1",attrs:{"value":0}},[_vm._v(" Compte par défaut (Ex: 411000001) ")]),_c('b-form-radio',{staticClass:"mt-3",attrs:{"value":1}},[_vm._v(" "+_vm._s(_vm.$t('customers.params.accountCustom'))+" ")]),_c('b-form-radio',{staticClass:"mt-3",attrs:{"value":2}},[_c('p',{staticClass:"mb-0"},[_vm._v(" Utiliser la référence client ")]),_c('small',{staticClass:"text-muted"},[_vm._v(" Le préfixe de la référence client ne sera pas utilisé ")])])],1)],1)],1),_c('b-col',{staticClass:"px-5",attrs:{"cols":"auto"}},[(_vm.localConfig.customer_account_custom === 0)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.params.accountLengthDefault')}},[_c('k-form-select',{staticClass:"w-25",attrs:{"name":"configs[customer_account_default_length]","options":_vm.defaultLengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.customer_account_default_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_account_default_length", $$v)},expression:"localConfig.customer_account_default_length"}})],1):(_vm.localConfig.customer_account_custom === 1)?_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.params.accountPrefix')}},[_c('k-form-input',{attrs:{"name":"configs[customer_account_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.customer_account_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_account_prefix", $$v)},expression:"localConfig.customer_account_prefix"}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.params.accountLength')}},[_c('k-form-select',{attrs:{"name":"configs[customer_account_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.customer_account_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_account_length", $$v)},expression:"localConfig.customer_account_length"}})],1)],1)],1):(_vm.localConfig.customer_account_custom === 2)?_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.params.accountPrefix')}},[_c('k-form-input',{attrs:{"name":"configs[customer_account_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.customer_account_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_account_prefix", $$v)},expression:"localConfig.customer_account_prefix"}})],1)],1)],1):_vm._e()],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Aperçu"}},[_c('p',[_vm._v(" "+_vm._s(_vm.customerAccountPreview)+" ")]),(_vm.localConfig.customer_account_custom === 1)?_c('span',[_vm._v(" Exemple avec le client : TEST COMPANY ")]):(_vm.localConfig.customer_account_custom === 2)?_c('span',[_vm._v(" Exemple avec la référence client : CL0012101 ")]):_vm._e()])],1)],1),_c('h3',{staticClass:"form-title-alt"},[_vm._v("Comptes fournisseurs")]),_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Type de numérotation"}},[_c('b-form-radio-group',{attrs:{"name":"configs[provider_account_custom]","stacked":""},on:{"input":_vm.providerAccountModeChanged},model:{value:(_vm.localConfig.provider_account_custom),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_account_custom", $$v)},expression:"localConfig.provider_account_custom"}},[_c('b-form-radio',{staticClass:"mt-1",attrs:{"value":0}},[_vm._v(" Compte par défaut (Ex: 401000001) ")]),_c('b-form-radio',{staticClass:"mt-3",attrs:{"value":1}},[_vm._v(" "+_vm._s(_vm.$t('customers.params.accountCustom'))+" ")]),_c('b-form-radio',{staticClass:"mt-3",attrs:{"value":2}},[_c('p',{staticClass:"mb-0"},[_vm._v(" Utiliser la référence fournisseur ")]),_c('small',{staticClass:"text-muted"},[_vm._v(" Le préfixe de la référence fournisseur ne sera pas utilisé ")])])],1)],1)],1),_c('b-col',{staticClass:"px-5",attrs:{"cols":"auto"}},[(_vm.localConfig.provider_account_custom === 0)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.params.accountLengthDefault')}},[_c('k-form-select',{staticClass:"w-25",attrs:{"name":"configs[provider_account_default_length]","options":_vm.defaultLengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.provider_account_default_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_account_default_length", $$v)},expression:"localConfig.provider_account_default_length"}})],1):(_vm.localConfig.provider_account_custom === 1)?_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.params.accountPrefix')}},[_c('k-form-input',{attrs:{"name":"configs[provider_account_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.provider_account_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_account_prefix", $$v)},expression:"localConfig.provider_account_prefix"}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.params.accountLength')}},[_c('k-form-select',{attrs:{"name":"configs[provider_account_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.provider_account_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_account_length", $$v)},expression:"localConfig.provider_account_length"}})],1)],1)],1):(_vm.localConfig.provider_account_custom === 2)?_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.params.accountPrefix')}},[_c('k-form-input',{attrs:{"name":"configs[provider_account_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.provider_account_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_account_prefix", $$v)},expression:"localConfig.provider_account_prefix"}})],1)],1)],1):_vm._e()],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Aperçu"}},[_c('p',[_vm._v(" "+_vm._s(_vm.providerAccountPreview)+" ")]),(_vm.localConfig.provider_account_custom === 1)?_c('span',[_vm._v(" Exemple avec le fournisseur : TEST COMPANY ")]):(_vm.localConfig.provider_account_custom === 2)?_c('span',[_vm._v(" Exemple avec la référence fournisseur : F0012101 ")]):_vm._e()])],1)],1),_c('p',{staticClass:"mt-2 mb-0 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)
}
var CustomersParamsAccountvue_type_template_id_0c6ba668_staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomersParamsAccount/CustomersParamsAccount.ts?vue&type=script&lang=ts&external





var CustomersParamsAccount = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomersParamsAccount, _super);
    function CustomersParamsAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultLengthOptions = [6, 7, 8, 9];
        _this.lengthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        return _this;
    }
    Object.defineProperty(CustomersParamsAccount.prototype, "customerAccountPreview", {
        get: function () {
            var _a;
            switch (this.localConfig.customer_account_custom) {
                case 0:
                    return 411 + this.pad(1, ((_a = this.localConfig) === null || _a === void 0 ? void 0 : _a.customer_account_default_length) - 3);
                case 1:
                    return this.localConfig.customer_account_prefix + ('TESTCOMPANY'.substr(0, this.localConfig.customer_account_length));
                case 2:
                    return this.localConfig.customer_account_prefix + '0012101';
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomersParamsAccount.prototype, "providerAccountPreview", {
        get: function () {
            var _a;
            switch (this.localConfig.provider_account_custom) {
                case 0:
                    return 401 + this.pad(1, ((_a = this.localConfig) === null || _a === void 0 ? void 0 : _a.provider_account_default_length) - 3);
                case 1:
                    return this.localConfig.provider_account_prefix + ('TESTCOMPANY'.substr(0, this.localConfig.provider_account_length));
                case 2:
                    return this.localConfig.provider_account_prefix + '0012101';
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    CustomersParamsAccount.prototype.pad = function (number, length) {
        if (!length) {
            return null;
        }
        length = length - String(number).length + 1;
        return new Array(length).join('0').slice((length || 2) * -1) + number;
    };
    CustomersParamsAccount.prototype.customerAccountModeChanged = function (mode) {
        if (mode === 1 && this.localConfig.customer_account_prefix === '411') {
            this.localConfig.customer_account_prefix = '9';
        }
        else if (mode === 2 && this.localConfig.customer_account_prefix === '9') {
            this.localConfig.customer_account_prefix = '411';
        }
    };
    CustomersParamsAccount.prototype.providerAccountModeChanged = function (mode) {
        if (mode === 1 && this.localConfig.provider_account_prefix === '401') {
            this.localConfig.provider_account_prefix = '0';
        }
        else if (mode === 2 && this.localConfig.provider_account_prefix === '0') {
            this.localConfig.provider_account_prefix = '401';
        }
    };
    CustomersParamsAccount = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol
            }
        })
    ], CustomersParamsAccount);
    return CustomersParamsAccount;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var CustomersParamsAccountvue_type_script_lang_ts_external = (CustomersParamsAccount);

;// ./src/components/CustomersParamsAccount/CustomersParamsAccount.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomersParamsAccount_CustomersParamsAccountvue_type_script_lang_ts_external = (CustomersParamsAccountvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomersParamsAccount/CustomersParamsAccount.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomersParamsAccount_CustomersParamsAccountvue_type_script_lang_ts_external,
  CustomersParamsAccountvue_type_template_id_0c6ba668_render,
  CustomersParamsAccountvue_type_template_id_0c6ba668_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomersParamsAccount_CustomersParamsAccount = (component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomersParamsPdf/CustomersParamsPdf.vue?vue&type=template&id=3cdbbdfd
var CustomersParamsPdfvue_type_template_id_3cdbbdfd_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',[_vm._v(" Il est possible d'exporter les informations d'un client en PDF, vous pouvez personnaliser le PDF qui sera généré en utilisant un document Word comme template. ")]),_c('p',{staticClass:"mb-4"},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.downloadDefaultModel.apply(null, arguments)}}},[_vm._v(" Télécharger le template de base ")])],1),(_vm.localTeam.customer_pdf_template)?_c('div',{staticClass:"mt-2"},[_c('div',[_c('p',{staticClass:"text-center d-inline-block mb-1"},[_c('font-awesome-icon',{staticClass:"icon",style:({ color: '#5959ff', 'font-size': '2rem' }),attrs:{"icon":['fad', 'file-word' ]}}),_c('span',{staticClass:"d-inline-block text-truncate w-100 small pt-1"},[_vm._v(" "+_vm._s(_vm.localTeam.customer_pdf_template.filename)+" ")])],1)]),_c('b-overlay',{attrs:{"show":_vm.loadingTemplate}},[_c('div',{staticClass:"my-2"},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.downloadCustomerPdfTemplate.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.download'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.toDelete = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")])],1)]),_c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"no-close-on-esc":_vm.loadingDelete,"hide-header-close":_vm.loadingDelete,"no-close-on-backdrop":_vm.loadingDelete,"busy":_vm.loadingDelete},on:{"ok":_vm.deleteCustomerPdfTemplate},model:{value:(_vm.toDelete),callback:function ($$v) {_vm.toDelete=$$v},expression:"toDelete"}},[(_vm.loadingDelete)?_c('Spinner'):_c('div',[_vm._v(" Êtes-vous sûr de vouloir supprimer le template ? ")])],1)],1):_c('div',[_c('small',{staticClass:"mb-2"},[_vm._v(" Fichier word (.docx) ou Open Office (.odt) uniquement. ")]),_c('k-form-file',{attrs:{"url":_vm.formAction,"method":"PUT","name":"customer_pdf_template","accept":['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.oasis.opendocument.text'],"btnMode":"","btnSize":"sm"},on:{"onUpload":_vm.fileUploaded}})],1),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" Liste des variables disponibles ")]),_vm._m(0),_vm._m(1),_c('b-tabs',[_c('b-tab',{attrs:{"title":"Client"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Variable")]),_c('th',[_vm._v("Désignation")])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$type$")]),_c('td',[_vm._v("Type de client")])]),_c('tr',[_c('td',[_vm._v("$companyName$")]),_c('td',[_vm._v("Nom de l'entreprise")])]),_c('tr',[_c('td',[_vm._v("$civility$")]),_c('td',[_vm._v("Civilité")])]),_c('tr',[_c('td',[_vm._v("$firstname$")]),_c('td',[_vm._v("Prénom")])]),_c('tr',[_c('td',[_vm._v("$lastname$")]),_c('td',[_vm._v("Nom de famille")])]),_c('tr',[_c('td',[_vm._v("$fullname$")]),_c('td',[_vm._v("Nom complet (Civilité + Prénom + Nom)")])]),_c('tr',[_c('td',[_vm._v("$name$")]),_c('td',[_vm._v("Nom complet (Entreprise ou nom complet)")])]),_c('tr',[_c('td',[_vm._v("$companyType$")]),_c('td',[_vm._v("Type d'entreprise")])]),_c('tr',[_c('td',[_vm._v("$companySiret$")]),_c('td',[_vm._v("N° SIRET")])]),_c('tr',[_c('td',[_vm._v("$companyRcs$")]),_c('td',[_vm._v("N° RCS")])]),_c('tr',[_c('td',[_vm._v("$companyVatrate$")]),_c('td',[_vm._v("N° TVA intracommunautaire")])]),_c('tr',[_c('td',[_vm._v("$companyNaf$")]),_c('td',[_vm._v("Code NAF")])]),_c('tr',[_c('td',[_vm._v("$companyCapital$")]),_c('td',[_vm._v("Capital de l'entreprise")])]),_c('tr',[_c('td',[_vm._v("$email$")]),_c('td',[_vm._v("Email")])]),_c('tr',[_c('td',[_vm._v("$website$")]),_c('td',[_vm._v("Site internet")])]),_c('tr',[_c('td',[_vm._v("$phone$")]),_c('td',[_vm._v("Téléphone")])]),_c('tr',[_c('td',[_vm._v("$mobile$")]),_c('td',[_vm._v("Portable")])]),_c('tr',[_c('td',[_vm._v("$fax$")]),_c('td',[_vm._v("Fax")])]),_c('tr',[_c('td',[_vm._v("$invoiceAddress$")]),_c('td',[_vm._v("Adresse de facturation")])]),_c('tr',[_c('td',[_vm._v("$invoiceDelivery$")]),_c('td',[_vm._v("Adresse de livraison")])]),_c('tr',[_c('td',[_vm._v("$activity$")]),_c('td',[_vm._v("Activité")])]),_c('tr',[_c('td',[_vm._v("$origin$")]),_c('td',[_vm._v("Origine")])]),_c('tr',[_c('td',[_vm._v("$tag$")]),_c('td',[_vm._v("Mot-clés")])]),_c('tr',[_c('td',[_vm._v("$commercial$")]),_c('td',[_vm._v("Commercial en charge")])]),_c('tr',[_c('td',[_vm._v("$reference$")]),_c('td',[_vm._v("N° du prospect/client")])])])])]),(_vm.customFields && _vm.customFields.length > 0)?_c('b-tab',{attrs:{"title":"Champs personalisés"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Variable")]),_c('th',[_vm._v("Désignation")])])]),_c('tbody',_vm._l((_vm.customFields),function(field,i){return _c('tr',{key:i},[_c('td',[_vm._v("$customField"+_vm._s(field.id)+"$")]),_c('td',[_vm._v(_vm._s(field.label))])])}),0)])]):_vm._e()],1)],1)
}
var CustomersParamsPdfvue_type_template_id_3cdbbdfd_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',[_vm._v(" Vous pouvez ajouter une condition pour afficher du texte uniquement si la variable contient une valeur."),_c('br'),_vm._v(" Pour cela, vous devez entourer votre texte avec la variable suivante : $nomVariable"),_c('strong',{staticClass:"text-danger"},[_vm._v("If")]),_vm._v("$. ")])
},function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',[_c('u',[_vm._v("Exemple avec l'information \"Type d'entreprise\" dont la variable est $companyType$ :")]),_vm._v("  "),_c('span',{staticClass:"text-danger"},[_vm._v("$companyTypeIf$")]),_vm._v("Type d'entreprise : $companyType$"),_c('span',{staticClass:"text-danger"},[_vm._v("$companyTypeIf$")]),_c('br')])
}]


;// ./src/components/CustomersParamsPdf/CustomersParamsPdf.vue?vue&type=template&id=3cdbbdfd

// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomersParamsPdf/CustomersParamsPdf.ts?vue&type=script&lang=ts&external







var CustomersParamsPdf = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomersParamsPdf, _super);
    function CustomersParamsPdf() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingTemplate = false;
        _this.loadingDefaultModel = false;
        _this.loadingDelete = false;
        _this.toDelete = false;
        _this.loading = false;
        return _this;
    }
    CustomersParamsPdf.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCustomFields()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CustomersParamsPdf.prototype, "customFields", {
        get: function () {
            return this.getCustomFields(['customer', 'prospect', 'provider', 'subcontractor']);
        },
        enumerable: false,
        configurable: true
    });
    CustomersParamsPdf.prototype.fileUploaded = function (team) {
        this.applyNewTeam(team);
    };
    CustomersParamsPdf.prototype.downloadCustomerPdfTemplate = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var model;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        model = this.localTeam.customer_pdf_template;
                        if (!model) {
                            return [2 /*return*/];
                        }
                        this.loadingTemplate = true;
                        return [4 /*yield*/, this.$kwCustomers.axios.get('/file/' + model.id + '?with_file=1')
                                .then(function (response) {
                                _this.downloadFile(response.data.file, model.filename);
                            })
                                .finally(function () {
                                _this.loadingTemplate = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomersParamsPdf.prototype.deleteCustomerPdfTemplate = function (evt) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        evt.preventDefault();
                        this.loadingDelete = true;
                        return [4 /*yield*/, this.$kwSales.axios.put(this.formAction, {
                                customer_pdf_template: null
                            })
                                .then(function () {
                                _this.localTeam.customer_pdf_template = null;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.toDelete = false;
                                _this.loadingDelete = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomersParamsPdf.prototype.downloadDefaultModel = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingDefaultModel = true;
                        return [4 /*yield*/, this.$kwCommunication.axios.get('/customer/default-template')
                                .then(function (response) {
                                _this.downloadFile(response.data, 'customer-template-example.docx');
                            })
                                .finally(function () {
                                _this.loadingDefaultModel = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomersParamsPdf = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('customFields', ['getCustomFields'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customFields', ['loadCustomFields'])),
            components: {
                KFormFile: form_vue_.KFormFile,
                BButton: external_bootstrap_vue_.BButton, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BOverlay: external_bootstrap_vue_.BOverlay, BModal: external_bootstrap_vue_.BModal,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], CustomersParamsPdf);
    return CustomersParamsPdf;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin, interface_vue_.FileMixin)));
/* harmony default export */ var CustomersParamsPdfvue_type_script_lang_ts_external = (CustomersParamsPdf);

;// ./src/components/CustomersParamsPdf/CustomersParamsPdf.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomersParamsPdf_CustomersParamsPdfvue_type_script_lang_ts_external = (CustomersParamsPdfvue_type_script_lang_ts_external); 
;// ./src/components/CustomersParamsPdf/CustomersParamsPdf.vue





/* normalize component */
;
var CustomersParamsPdf_component = (0,componentNormalizer/* default */.A)(
  CustomersParamsPdf_CustomersParamsPdfvue_type_script_lang_ts_external,
  CustomersParamsPdfvue_type_template_id_3cdbbdfd_render,
  CustomersParamsPdfvue_type_template_id_3cdbbdfd_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomersParamsPdf_CustomersParamsPdf = (CustomersParamsPdf_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomersParamsReferences/CustomersParamsReferences.vue?vue&type=template&id=52710e8f
var CustomersParamsReferencesvue_type_template_id_52710e8f_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{staticClass:"customers-params",attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12","xl":"auto","order":"2","order-xl":"1"}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table w-auto table-references text-nowrap"},[_c('thead',[_c('tr',{staticClass:"small-text"},[_c('th'),_c('th',[_vm._v(_vm._s(_vm.$t('customers.params.referencePrefix')))]),_c('th',[_vm._v(_vm._s(_vm.$t('customers.params.referenceNextNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('customers.params.referenceLength')))]),_c('th',[_vm._v(_vm._s(_vm.$t('interface.example')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.customer.label'))+" :")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[customer_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.customer_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_reference_prefix", $$v)},expression:"localConfig.customer_reference_prefix"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[customer_reference_number]","min":1,"maxDecimal":0,"size":"sm"},model:{value:(_vm.localConfig.customer_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_reference_number", $$v)},expression:"localConfig.customer_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[customer_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.customer_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_reference_length", $$v)},expression:"localConfig.customer_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.customerReferenceExample))])]),(_vm.hasModule('customers-prospects'))?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.prospect.label'))+" :")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[prospect_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.prospect_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "prospect_reference_prefix", $$v)},expression:"localConfig.prospect_reference_prefix"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[prospect_reference_number]","min":1,"maxDecimal":0,"size":"sm"},model:{value:(_vm.localConfig.prospect_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "prospect_reference_number", $$v)},expression:"localConfig.prospect_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[prospect_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.prospect_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "prospect_reference_length", $$v)},expression:"localConfig.prospect_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.prospectReferenceExample))])]):_vm._e(),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.provider.label'))+" :")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[provider_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.provider_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_reference_prefix", $$v)},expression:"localConfig.provider_reference_prefix"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[provider_reference_number]","min":1,"maxDecimal":0,"size":"sm"},model:{value:(_vm.localConfig.provider_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_reference_number", $$v)},expression:"localConfig.provider_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[provider_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.provider_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "provider_reference_length", $$v)},expression:"localConfig.provider_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.providerReferenceExample))])]),(_vm.hasModule('customers-subcontractors'))?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('customers.subcontractor.label'))+" :")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[subcontractor_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.subcontractor_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "subcontractor_reference_prefix", $$v)},expression:"localConfig.subcontractor_reference_prefix"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[subcontractor_reference_number]","min":1,"maxDecimal":0,"size":"sm"},model:{value:(_vm.localConfig.subcontractor_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "subcontractor_reference_number", $$v)},expression:"localConfig.subcontractor_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[subcontractor_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.subcontractor_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "subcontractor_reference_length", $$v)},expression:"localConfig.subcontractor_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.subcontractorReferenceExample))])]):_vm._e()])])])]),_c('b-col',{attrs:{"order":"1","order-xl":"2"}},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('customers.params.referenceExplain'))+" ")]),_c('table',{staticClass:"table table-sm table-bordered w-auto"},[_c('tr',[_c('td',{staticClass:"pr-4"},[_vm._v("{YY}")]),_c('td',[_vm._v(_vm._s(_vm.$t('customers.params.referenceYear4')))])]),_c('tr',[_c('td',[_vm._v("{Y}")]),_c('td',[_vm._v(_vm._s(_vm.$t('customers.params.referenceYear2')))])]),_c('tr',[_c('td',[_vm._v("{m}")]),_c('td',[_vm._v(_vm._s(_vm.$t('customers.params.referenceMonth')))])]),_c('tr',[_c('td',[_vm._v("{d}")]),_c('td',[_vm._v(_vm._s(_vm.$t('customers.params.referenceDay')))])])])])],1),_c('p',{staticClass:"mt-2 mb-0 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)
}
var CustomersParamsReferencesvue_type_template_id_52710e8f_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomersParamsReferences/CustomersParamsReferences.ts?vue&type=script&lang=ts&external






var CustomersParamsReferences = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomersParamsReferences, _super);
    function CustomersParamsReferences() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultLengthOptions = [6, 7, 8, 9];
        _this.lengthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        return _this;
    }
    Object.defineProperty(CustomersParamsReferences.prototype, "customerReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.customer_reference_prefix, this.localConfig.customer_reference_number, this.localConfig.customer_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomersParamsReferences.prototype, "prospectReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.prospect_reference_prefix, this.localConfig.prospect_reference_number, this.localConfig.prospect_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomersParamsReferences.prototype, "providerReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.provider_reference_prefix, this.localConfig.provider_reference_number, this.localConfig.provider_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomersParamsReferences.prototype, "subcontractorReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.subcontractor_reference_prefix, this.localConfig.subcontractor_reference_number, this.localConfig.subcontractor_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    CustomersParamsReferences.prototype.pad = function (number, length) {
        if (!length) {
            return null;
        }
        length = length - String(number).length + 1;
        return new Array(length).join('0').slice((length || 2) * -1) + number;
    };
    CustomersParamsReferences.prototype.generateReferenceExample = function (prefix, number, length) {
        if (!prefix) {
            return null;
        }
        var numberLength = String(number).length;
        if (numberLength > length) {
            length = numberLength;
        }
        var example = this.pad(number, length);
        var date = new Date();
        prefix = prefix.replace('{YY}', String(date.getFullYear()))
            .replace('{Y}', String(date.getFullYear()).substr(2, 2))
            .replace('{m}', String(('0' + (date.getMonth() + 1)).slice(-2)))
            .replace('{d}', String(('0' + date.getDate()).slice(-2)));
        return prefix + example;
    };
    CustomersParamsReferences = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormNumber: form_vue_.KFormNumber, KFormSelect: form_vue_.KFormSelect,
                BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol
            }
        })
    ], CustomersParamsReferences);
    return CustomersParamsReferences;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var CustomersParamsReferencesvue_type_script_lang_ts_external = (CustomersParamsReferences);

;// ./src/components/CustomersParamsReferences/CustomersParamsReferences.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomersParamsReferences_CustomersParamsReferencesvue_type_script_lang_ts_external = (CustomersParamsReferencesvue_type_script_lang_ts_external); 
;// ./src/components/CustomersParamsReferences/CustomersParamsReferences.vue





/* normalize component */
;
var CustomersParamsReferences_component = (0,componentNormalizer/* default */.A)(
  CustomersParamsReferences_CustomersParamsReferencesvue_type_script_lang_ts_external,
  CustomersParamsReferencesvue_type_template_id_52710e8f_render,
  CustomersParamsReferencesvue_type_template_id_52710e8f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomersParamsReferences_CustomersParamsReferences = (CustomersParamsReferences_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomersParamsGroup/CustomersParamsGroup.vue?vue&type=template&id=15464d59
var CustomersParamsGroupvue_type_template_id_15464d59_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{staticClass:"customers-params",attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('h2',{staticClass:"form-title-alt mt-0"},[_vm._v(" Personnalisation des groupes de tiers ")]),_c('b-form-group',{attrs:{"label":"Nom des \"parents\""}},[_c('k-form-input',{attrs:{"name":"configs[customer_group_parent_name]","required":""},model:{value:(_vm.localConfig.customer_group_parent_name),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_group_parent_name", $$v)},expression:"localConfig.customer_group_parent_name"}})],1),_c('b-form-group',{attrs:{"label":"Nom des \"enfants\""}},[_c('k-form-input',{attrs:{"name":"configs[customer_group_child_name]","required":""},model:{value:(_vm.localConfig.customer_group_child_name),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_group_child_name", $$v)},expression:"localConfig.customer_group_child_name"}})],1),_c('h2',{staticClass:"form-title-alt"},[_vm._v(" Rédaction des documents de vente ")]),_c('input',{attrs:{"type":"hidden","name":"configs[customer_group_sales_parent_select]"},domProps:{"value":_vm.localConfig.customer_group_sales_parent_select ?? false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.customer_group_sales_parent_select),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_group_sales_parent_select", $$v)},expression:"localConfig.customer_group_sales_parent_select"}},[_vm._v(" Lors de la sélection d'un enfant comme client, facturer automatiquement le parent. ")]),_c('input',{attrs:{"type":"hidden","name":"configs[customer_group_sales_child_delivery]"},domProps:{"value":_vm.localConfig.customer_group_sales_child_delivery ?? false}}),_c('k-form-checkbox',{staticClass:"mt-3",model:{value:(_vm.localConfig.customer_group_sales_child_delivery),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_group_sales_child_delivery", $$v)},expression:"localConfig.customer_group_sales_child_delivery"}},[_vm._v(" Utiliser l'adresse de l'enfant comme adresse de livraison lorsqu'il est sélectionné ")]),_c('h2',{staticClass:"form-title-alt"},[_vm._v(" Création des opportunités ")]),_c('input',{attrs:{"type":"hidden","name":"configs[customer_group_opportunity_parent_select]"},domProps:{"value":_vm.localConfig.customer_group_opportunity_parent_select ?? false}}),_c('k-form-checkbox',{staticClass:"mt-3 mb-5",model:{value:(_vm.localConfig.customer_group_opportunity_parent_select),callback:function ($$v) {_vm.$set(_vm.localConfig, "customer_group_opportunity_parent_select", $$v)},expression:"localConfig.customer_group_opportunity_parent_select"}},[_vm._v(" Lors de la sélection d'un enfant comme client, sélectionner automatiquement le parent. ")]),_c('p',{staticClass:"mt-4 mb-0 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)
}
var CustomersParamsGroupvue_type_template_id_15464d59_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomersParamsGroup/CustomersParamsGroup.ts?vue&type=script&lang=ts&external





var CustomersParamsGroup = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomersParamsGroup, _super);
    function CustomersParamsGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomersParamsGroup = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormCheckbox: form_vue_.KFormCheckbox,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], CustomersParamsGroup);
    return CustomersParamsGroup;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var CustomersParamsGroupvue_type_script_lang_ts_external = (CustomersParamsGroup);

;// ./src/components/CustomersParamsGroup/CustomersParamsGroup.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomersParamsGroup_CustomersParamsGroupvue_type_script_lang_ts_external = (CustomersParamsGroupvue_type_script_lang_ts_external); 
;// ./src/components/CustomersParamsGroup/CustomersParamsGroup.vue





/* normalize component */
;
var CustomersParamsGroup_component = (0,componentNormalizer/* default */.A)(
  CustomersParamsGroup_CustomersParamsGroupvue_type_script_lang_ts_external,
  CustomersParamsGroupvue_type_template_id_15464d59_render,
  CustomersParamsGroupvue_type_template_id_15464d59_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomersParamsGroup_CustomersParamsGroup = (CustomersParamsGroup_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CustomersParamsView.vue?vue&type=script&lang=ts









var CustomersParamsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomersParamsView, _super);
    function CustomersParamsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomersParamsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab,
                CustomersParams: CustomersParams/* default */.A,
                CustomersParamsReferences: CustomersParamsReferences_CustomersParamsReferences,
                CustomersParamsPdf: CustomersParamsPdf_CustomersParamsPdf,
                CustomersParamsAccount: CustomersParamsAccount_CustomersParamsAccount,
                CustomersParamsGroup: CustomersParamsGroup_CustomersParamsGroup
            }
        })
    ], CustomersParamsView);
    return CustomersParamsView;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomersParamsViewvue_type_script_lang_ts = (CustomersParamsView);

;// ./src/views/CustomersParamsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CustomersParamsViewvue_type_script_lang_ts = (CustomersParamsViewvue_type_script_lang_ts); 
;// ./src/views/CustomersParamsView.vue





/* normalize component */
;
var CustomersParamsView_component = (0,componentNormalizer/* default */.A)(
  views_CustomersParamsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CustomersParamsView = (CustomersParamsView_component.exports);

/***/ }),

/***/ 6867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerMerge_CustomerMerge; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerMerge/CustomerMerge.vue?vue&type=template&id=d5e65832
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e(),_c('FormModal',{attrs:{"title":_vm.$t('customers.item.mergeTitle'),"ok-title":_vm.$t('customers.item.mergeBtn'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":"PUT"},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.item.mergeDestination')}},[_c('input',{attrs:{"type":"hidden","name":"id"},domProps:{"value":_vm.customer ? _vm.customer.id : null}}),_c('k-form-select',{attrs:{"ajax":"/customer","ajaxDatas":{
            sort: 'name',
            filter: {
              exclude: _vm.value.id
            }
          },"ajaxSearch":_vm.selectSearch,"label":"name","required":""},model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}})],1)],1),_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('customers.item.mergeExplain1'))+" ")]),_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('customers.item.mergeExplain2'))+" ")])])],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerMerge/CustomerMerge.ts?vue&type=script&lang=ts&external





var CustomerMerge = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerMerge, _super);
    function CustomerMerge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.customer = null;
        return _this;
    }
    Object.defineProperty(CustomerMerge.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerMerge.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('customers.item.merge');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerMerge.prototype, "formAction", {
        get: function () {
            return '/customer/' + this.value.id + '/merge';
        },
        enumerable: false,
        configurable: true
    });
    CustomerMerge.prototype.selectSearch = function (params, term) {
        if (!('filter' in params)) {
            params.filter = {};
        }
        if (term !== '' && term !== null) {
            term = '%25' + term + '%25';
        }
        params.filter.name = term;
        return params;
    };
    CustomerMerge.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    CustomerMerge.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    CustomerMerge.prototype.submitComplete = function (response) {
        return response.data;
    };
    CustomerMerge.prototype.closeModal = function () {
        this.$emit('closed');
    };
    CustomerMerge.prototype.canceled = function () {
        this.$emit('canceled');
    };
    CustomerMerge.prototype.deleted = function () {
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerMerge.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], CustomerMerge.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerMerge.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerMerge.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerMerge.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerMerge.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CustomerMerge.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], CustomerMerge.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('merged')
    ], CustomerMerge.prototype, "submitComplete", null);
    CustomerMerge = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal,
                KForm: form_vue_.KForm,
                KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                BAlert: external_bootstrap_vue_.BAlert
            }
        })
    ], CustomerMerge);
    return CustomerMerge;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerMergevue_type_script_lang_ts_external = (CustomerMerge);

;// ./src/components/CustomerMerge/CustomerMerge.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerMerge_CustomerMergevue_type_script_lang_ts_external = (CustomerMergevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerMerge/CustomerMerge.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerMerge_CustomerMergevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerMerge_CustomerMerge = (component.exports);

/***/ }),

/***/ 7167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(4901),
    baseUnary = __webpack_require__(7301),
    nodeUtil = __webpack_require__(6009);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 7301:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 7534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 7556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    arrayMap = __webpack_require__(4932),
    isArray = __webpack_require__(6449),
    isSymbol = __webpack_require__(4394);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 7711:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'caret-down';
var width = 320;
var height = 512;
var ligatures = [];
var unicode = 'f0d7';
var svgPathData = 'M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.xB = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ContactOrigins_ContactOrigins; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContactOrigins/ContactOrigins.vue?vue&type=template&id=555651f1
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"createTitle":_vm.$t('customers.contactOrigin.new'),"updateTitle":_vm.$t('customers.contactOrigin.edit'),"deleteMsg":_vm.$t('customers.contactOrigin.deleteMsg'),"sort":"label","withDefault":"","exportable":"origin"},on:{"submitted":origin => _vm.setOrigin(origin),"deleted":origin => _vm.deleteOrigin(origin)}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContactOrigins/ContactOrigins.ts?vue&type=script&lang=ts&external




var ContactOrigins = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactOrigins, _super);
    function ContactOrigins() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columns = [
            {
                label: _this.$t('customers.contactOrigin.label'),
                key: 'label',
                required: true
            }
        ];
        return _this;
    }
    Object.defineProperty(ContactOrigins.prototype, "apiUrl", {
        get: function () {
            return '/customer/origin';
        },
        enumerable: false,
        configurable: true
    });
    ContactOrigins = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customers', ['setOrigin', 'deleteOrigin'])),
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], ContactOrigins);
    return ContactOrigins;
}(lib/* Vue */.lD));
/* harmony default export */ var ContactOriginsvue_type_script_lang_ts_external = (ContactOrigins);

;// ./src/components/ContactOrigins/ContactOrigins.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContactOrigins_ContactOriginsvue_type_script_lang_ts_external = (ContactOriginsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ContactOrigins/ContactOrigins.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ContactOrigins_ContactOriginsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContactOrigins_ContactOrigins = (component.exports);

/***/ }),

/***/ 8031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerArchivate_CustomerArchivate; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerArchivate/CustomerArchivate.vue?vue&type=template&id=8a921a3c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.buttonLabel,"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_c('p',[_vm._v(_vm._s(_vm.message))])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerArchivate/CustomerArchivate.ts?vue&type=script&lang=ts&external



var CustomerArchivate = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerArchivate, _super);
    function CustomerArchivate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(CustomerArchivate.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerArchivate.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return this.$t('customers.item.' + (((_a = this.value) === null || _a === void 0 ? void 0 : _a.archived_at) ? 'unarchive' : 'archive'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerArchivate.prototype, "message", {
        get: function () {
            var _a;
            return this.$t('customers.item.' + (((_a = this.value) === null || _a === void 0 ? void 0 : _a.archived_at) ? 'unarchiveConfirm' : 'archiveConfirm'));
        },
        enumerable: false,
        configurable: true
    });
    CustomerArchivate.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    CustomerArchivate.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    CustomerArchivate.prototype.process = function () {
        var _a, _b;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCustomers.axios.put('/customer/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id), {
                                archived: ((_b = this.value) === null || _b === void 0 ? void 0 : _b.archived_at) === null
                            })
                                .then(function (response) {
                                _this.archivated(response.data);
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerArchivate.prototype.closeModal = function () {
        this.$emit('closed');
    };
    CustomerArchivate.prototype.canceled = function () {
        this.$emit('canceled');
    };
    CustomerArchivate.prototype.archivated = function (customer) {
        this.$emit(customer.archived_at === null ? 'unarchivated' : 'archivated', customer);
        this.$emit('input', customer);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerArchivate.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], CustomerArchivate.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerArchivate.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerArchivate.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerArchivate.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerArchivate.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CustomerArchivate.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], CustomerArchivate.prototype, "watchModalState", null);
    CustomerArchivate = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], CustomerArchivate);
    return CustomerArchivate;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerArchivatevue_type_script_lang_ts_external = (CustomerArchivate);

;// ./src/components/CustomerArchivate/CustomerArchivate.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerArchivate_CustomerArchivatevue_type_script_lang_ts_external = (CustomerArchivatevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerArchivate/CustomerArchivate.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerArchivate_CustomerArchivatevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerArchivate_CustomerArchivate = (component.exports);

/***/ }),

/***/ 8057:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/form-vue");

/***/ }),

/***/ 8096:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 8129:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/subscriptions-vue");

/***/ }),

/***/ 8223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerAddressDelete_CustomerAddressDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerAddressDelete/CustomerAddressDelete.vue?vue&type=template&id=bb1221a4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ConfirmModal',{attrs:{"ok-title":_vm.$t('interface.delete'),"message":_vm.$t('customers.address.deleteMsg')},on:{"confirmed":_vm.deleteAddress,"hidden":function($event){return _vm.$emit('hidden')}}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerAddressDelete/CustomerAddressDelete.ts?vue&type=script&lang=ts&external



var CustomerAddressDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerAddressDelete, _super);
    function CustomerAddressDelete() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomerAddressDelete.prototype.deleteAddress = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.$kwCustomers.axios.delete('/customer/' + this.customer.id + '/address/' + this.value.id)
                    .then(function () {
                    _this.$emit('deleted');
                })
                    .catch(function (error) {
                    throw new Error(error);
                });
                return [2 /*return*/];
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerAddressDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerAddressDelete.prototype, "customer", void 0);
    CustomerAddressDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ConfirmModal: interface_vue_.ConfirmModal
            }
        })
    ], CustomerAddressDelete);
    return CustomerAddressDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerAddressDeletevue_type_script_lang_ts_external = (CustomerAddressDelete);

;// ./src/components/CustomerAddressDelete/CustomerAddressDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerAddressDelete_CustomerAddressDeletevue_type_script_lang_ts_external = (CustomerAddressDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerAddressDelete/CustomerAddressDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerAddressDelete_CustomerAddressDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerAddressDelete_CustomerAddressDelete = (component.exports);

/***/ }),

/***/ 8266:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/opportunities-vue");

/***/ }),

/***/ 8329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(4894);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 8358:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'map-signs';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f277';
var svgPathData = 'M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.kn = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8399:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/table-vue");

/***/ }),

/***/ 8402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerContacts_CustomerContacts; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerContacts/CustomerContacts.vue?vue&type=template&id=afaf5d64
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('k-table',{ref:"table",attrs:{"url":"/customer/contact","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"rowLink":_vm.rowLink,"rowActions":_vm.rowActions,"stateKey":"customer-contact-list","saveMainSearch":false},on:{"totalUpdated":nb => _vm.total = nb}}),_c('ContactDelete',{attrs:{"element":"modal","modal":_vm.deleteModel !== null},on:{"closed":function($event){_vm.deleteModel = null}},model:{value:(_vm.deleteModel),callback:function ($$v) {_vm.deleteModel=$$v},expression:"deleteModel"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: ./src/components/ContactDelete/ContactDelete.vue + 3 modules
var ContactDelete = __webpack_require__(4779);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerContacts/CustomerContacts.ts?vue&type=script&lang=ts&external








var CustomerContacts = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerContacts, _super);
    function CustomerContacts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.total = 0;
        _this.deleteModel = null;
        return _this;
    }
    Object.defineProperty(CustomerContacts.prototype, "ajaxDatas", {
        get: function () {
            return {
                include: 'customers,function,tags,customFields',
                filter: {
                    with_customer: this.customer.id
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerContacts.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'civility.name',
                    name: this.$t('customers.list.civility'),
                    visible: false
                },
                {
                    data: 'firstname',
                    name: this.$t('customers.list.firstname'),
                    visible: false
                },
                {
                    data: 'lastname',
                    name: this.$t('customers.list.lastname'),
                    visible: false
                },
                {
                    data: 'fullname',
                    name: this.$t('customers.list.name'),
                    sticky: true
                },
                {
                    data: 'function.label',
                    name: this.$t('customers.list.function')
                },
                {
                    data: 'phone',
                    name: this.$t('customers.list.phone'),
                    render: 'phone'
                },
                {
                    data: 'mobile',
                    name: this.$t('customers.list.mobile'),
                    render: 'phone'
                },
                {
                    data: 'fax',
                    name: this.$t('customers.list.fax'),
                    visible: false,
                    render: 'phone'
                },
                {
                    data: 'email',
                    name: this.$t('customers.list.email')
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerContacts.prototype, "rowActions", {
        get: function () {
            var _this = this;
            var buttons = [];
            if (this.can('contact', 2)) {
                buttons.push({
                    icon: 'edit',
                    click: function (contact, index) {
                        _this.openModal({
                            key: 'contact-form',
                            value: contact,
                            submitted: function (response) {
                                var table = _this.$refs.table;
                                table.updateRow(index, response.data);
                            }
                        });
                    }
                });
            }
            if (this.can('contact', 3)) {
                buttons.push({
                    icon: 'delete',
                    click: function (contact) {
                        _this.toDelete(contact);
                    }
                });
            }
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    CustomerContacts.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                interface_vue_.emitter.on('contactCreated', this.contactCreated);
                interface_vue_.emitter.on('contactUpdated', this.contactUpdated);
                interface_vue_.emitter.on('contactDeleted', this.contactDeleted);
                return [2 /*return*/];
            });
        });
    };
    CustomerContacts.prototype.destroyed = function () {
        interface_vue_.emitter.off('contactCreated', this.contactCreated);
        interface_vue_.emitter.off('contactUpdated', this.contactUpdated);
        interface_vue_.emitter.off('contactDeleted', this.contactDeleted);
    };
    CustomerContacts.prototype.watchTotal = function (total) {
        this.$emit('totalUpdated', total);
    };
    CustomerContacts.prototype.rowLink = function (contact) {
        return {
            name: 'contacts-contact-item',
            params: {
                id: String(contact.id),
                customer: JSON.stringify(contact)
            }
        };
    };
    CustomerContacts.prototype.toDelete = function (contact) {
        this.deleteModel = contact;
    };
    CustomerContacts.prototype.newContact = function () {
        var _this = this;
        this.openModal({
            key: 'contact-form',
            attributes: {
                customer: this.customer
            },
            submitted: function (response) {
                var table = _this.$refs.table;
                table.addRow(response.data);
            }
        });
    };
    CustomerContacts.prototype.contactHasCustomer = function (contact) {
        var _this = this;
        return contact.customers.find(function (customer) { return customer.id === _this.customer.id; }) !== undefined;
    };
    CustomerContacts.prototype.contactCreated = function (contact) {
        if (this.contactHasCustomer(contact)) {
            var table = this.$refs.table;
            table.addRow(contact);
        }
    };
    CustomerContacts.prototype.contactUpdated = function (event) {
        var table = this.$refs.table;
        var contact = event.new;
        var hasCustomer = this.contactHasCustomer(contact);
        var index = table.getDatas().findIndex(function (data) { return data.id === event.new.id; });
        if (index >= 0) {
            if (hasCustomer) {
                table.updateRow(index, event.new);
            }
            else {
                table.deleteRow(index);
            }
        }
        else if (hasCustomer) {
            table.addRow(event.new);
        }
    };
    CustomerContacts.prototype.contactDeleted = function (contact) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === contact.id; });
        if (index >= 0) {
            table.deleteRow(index);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerContacts.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('total')
    ], CustomerContacts.prototype, "watchTotal", null);
    CustomerContacts = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])),
            components: {
                KTable: table_vue_.KTable,
                ContactDelete: ContactDelete/* default */.A,
                BTab: external_bootstrap_vue_.BTab, BBadge: external_bootstrap_vue_.BBadge, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], CustomerContacts);
    return CustomerContacts;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerContactsvue_type_script_lang_ts_external = (CustomerContacts);

;// ./src/components/CustomerContacts/CustomerContacts.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerContacts_CustomerContactsvue_type_script_lang_ts_external = (CustomerContactsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerContacts/CustomerContacts.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerContacts_CustomerContactsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerContacts_CustomerContacts = (component.exports);

/***/ }),

/***/ 8540:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'users';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f0c0';
var svgPathData = 'M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.gd = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8742:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/tickets-vue");

/***/ }),

/***/ 8754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(5160);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 8984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(5527),
    nativeKeys = __webpack_require__(3650);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 9068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CustomerTypesView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CustomerTypesView.vue?vue&type=template&id=2ed35e40
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CustomerTypes')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CustomerTypes/CustomerTypes.vue + 3 modules
var CustomerTypes = __webpack_require__(4388);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CustomerTypesView.vue?vue&type=script&lang=ts



var CustomerTypesView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerTypesView, _super);
    function CustomerTypesView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomerTypesView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CustomerTypes: CustomerTypes/* default */.A
            }
        })
    ], CustomerTypesView);
    return CustomerTypesView;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerTypesViewvue_type_script_lang_ts = (CustomerTypesView);

;// ./src/views/CustomerTypesView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CustomerTypesViewvue_type_script_lang_ts = (CustomerTypesViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/CustomerTypesView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_CustomerTypesViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CustomerTypesView = (component.exports);

/***/ }),

/***/ 9325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(4840);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 9350:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 9356:
/***/ (function(module) {

"use strict";
module.exports = require("@fortawesome/vue-fontawesome");

/***/ }),

/***/ 9529:
/***/ (function(module) {

"use strict";
module.exports = require("bootstrap-vue");

/***/ }),

/***/ 9603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  uA: function() { return /* reexport */ vue_class_component_esm; },
  O5: function() { return /* reexport */ Emit; },
  Xe: function() { return /* reexport */ mixins; },
  kv: function() { return /* reexport */ Prop; },
  lD: function() { return /* reexport */ (external_vue_default()); },
  ox: function() { return /* reexport */ Watch; }
});

// UNUSED EXPORTS: Inject, InjectReactive, Model, ModelSync, PropSync, Provide, ProvideReactive, Ref, VModel

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function vue_class_component_esm_createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_vue_default().extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) // removed by dead control flow
{}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof (external_vue_default()) ? superProto.constructor : (external_vue_default());
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter']));
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) // removed by dead control flow
{}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (Component);


;// ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, __spreadArrays([emitName], args));
                    }
                }
                else {
                    args.unshift(returnValue);
                    _this.$emit.apply(_this, __spreadArrays([emitName], args));
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

;// ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function metadata_applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            !options.hasOwnProperty('type') &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}

;// ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function ModelSync(propName, event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = { prop: propName, event: event || k };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit(event, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        metadata_applyMetadata(options, target, key);
        vue_class_component_esm_createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return vue_class_component_esm_createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

;// ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>

















/***/ }),

/***/ 9698:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 9754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(3729),
    baseEach = __webpack_require__(909),
    castFunction = __webpack_require__(4066),
    isArray = __webpack_require__(6449);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 9792:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/calendars-vue");

/***/ }),

/***/ 9935:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 9998:
/***/ (function(module) {

"use strict";
module.exports = require("vuex");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	!function() {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = function(chunkId) {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce(function(promises, key) {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	!function() {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = function(chunkId) {
/******/ 			// return url for filenames based on template
/******/ 			return "customers.common." + "customers" + ".js";
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	!function() {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = function(chunkId) {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	!function() {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "@kwixeo/customers-vue:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = function(url, done, key, chunkId) {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = function(prev, event) {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach(function(fn) { return fn(event); });
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			755: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = function(chunkId, promises) {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise(function(resolve, reject) { installedChunkData = installedChunks[chunkId] = [resolve, reject]; });
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = function(event) {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = (typeof self !== 'undefined' ? self : this)["webpackChunk_kwixeo_customers_vue"] = (typeof self !== 'undefined' ? self : this)["webpackChunk_kwixeo_customers_vue"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ContactActivities: function() { return /* reexport */ ContactActivities/* default */.A; },
  ContactActivitiesView: function() { return /* reexport */ ContactActivitiesView["default"]; },
  ContactDelete: function() { return /* reexport */ ContactDelete/* default */.A; },
  ContactForm: function() { return /* reexport */ ContactForm_ContactForm; },
  ContactFunctions: function() { return /* reexport */ ContactFunctions/* default */.A; },
  ContactFunctionsView: function() { return /* reexport */ ContactFunctionsView["default"]; },
  ContactInformations: function() { return /* reexport */ ContactInformations/* default */.A; },
  ContactItem: function() { return /* reexport */ ContactItem/* default */.A; },
  ContactOrigins: function() { return /* reexport */ ContactOrigins/* default */.A; },
  ContactOriginsView: function() { return /* reexport */ ContactOriginsView["default"]; },
  ContactSelect: function() { return /* reexport */ ContactSelect_ContactSelect; },
  ContactSpeedItem: function() { return /* reexport */ ContactSpeedItem/* default */.A; },
  ContactsItemView: function() { return /* reexport */ ContactsItemView["default"]; },
  ContactsList: function() { return /* reexport */ ContactsList/* default */.A; },
  ContactsListView: function() { return /* reexport */ ContactsListView["default"]; },
  CustomerAddressDelete: function() { return /* reexport */ CustomerAddressDelete/* default */.A; },
  CustomerAddressForm: function() { return /* reexport */ CustomerAddressForm/* default */.A; },
  CustomerAddressList: function() { return /* reexport */ CustomerAddressList/* default */.A; },
  CustomerAddressSelect: function() { return /* reexport */ CustomerAddressSelect_CustomerAddressSelect; },
  CustomerArchivate: function() { return /* reexport */ CustomerArchivate/* default */.A; },
  CustomerChargeParams: function() { return /* reexport */ CustomerChargeParams/* default */.A; },
  CustomerContacts: function() { return /* reexport */ CustomerContacts/* default */.A; },
  CustomerDelete: function() { return /* reexport */ CustomerDelete/* default */.A; },
  CustomerForm: function() { return /* reexport */ CustomerForm_CustomerForm; },
  CustomerInformations: function() { return /* reexport */ CustomerInformations/* default */.A; },
  CustomerItem: function() { return /* reexport */ CustomerItem/* default */.A; },
  CustomerMerge: function() { return /* reexport */ CustomerMerge/* default */.A; },
  CustomerReference: function() { return /* reexport */ CustomerReference/* default */.A; },
  CustomerSaleParams: function() { return /* reexport */ CustomerSaleParams/* default */.A; },
  CustomerSelect: function() { return /* reexport */ CustomerSelect_CustomerSelect; },
  CustomerSpeedItem: function() { return /* reexport */ CustomerSpeedItem/* default */.A; },
  CustomerTypes: function() { return /* reexport */ CustomerTypes/* default */.A; },
  CustomerTypesView: function() { return /* reexport */ CustomerTypesView["default"]; },
  CustomersItemView: function() { return /* reexport */ CustomersItemView["default"]; },
  CustomersList: function() { return /* reexport */ CustomersList/* default */.A; },
  CustomersListView: function() { return /* reexport */ CustomersListView["default"]; },
  CustomersParams: function() { return /* reexport */ CustomersParams/* default */.A; },
  CustomersParamsView: function() { return /* reexport */ CustomersParamsView["default"]; },
  CustomersStore: function() { return /* reexport */ modules_CustomersStore; },
  KwixeoCustomers: function() { return /* reexport */ install; },
  Lang: function() { return /* reexport */ lang; },
  ProspectsListView: function() { return /* reexport */ ProspectsListView["default"]; },
  ProvidersListView: function() { return /* reexport */ ProvidersListView["default"]; },
  SubcontractorsListView: function() { return /* reexport */ SubcontractorsListView["default"]; },
  configRoutes: function() { return /* reexport */ configRoutes; },
  contactRelations: function() { return /* reexport */ fetchDatas_contact/* contactRelations */.uE; },
  customerRelations: function() { return /* reexport */ customer/* customerRelations */.qD; },
  fetchContact: function() { return /* reexport */ fetchDatas_contact/* fetchContact */.tY; },
  fetchCustomer: function() { return /* reexport */ customer/* fetchCustomer */.LO; },
  needFetchContact: function() { return /* reexport */ fetchDatas_contact/* needFetchContact */.Hz; },
  needFetchCustomer: function() { return /* reexport */ customer/* needFetchCustomer */.t3; },
  routes: function() { return /* reexport */ router_routes; }
});

;// ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) // removed by dead control flow
{ var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/components/ContactActivities/ContactActivities.vue + 3 modules
var ContactActivities = __webpack_require__(4016);
// EXTERNAL MODULE: ./src/components/ContactDelete/ContactDelete.vue + 3 modules
var ContactDelete = __webpack_require__(4779);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContactForm/ContactForm.vue?vue&type=template&id=7cd23212
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.apiFormUrl,"method":this.localContact.id ? 'PUT' : 'POST'},on:{"submitComplete":_vm.submitComplete}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"7"}},[_c('b-form-row',[_c('b-col',[_c('input',{attrs:{"type":"hidden","name":"civility"},domProps:{"value":_vm.localContact.civility ? _vm.localContact.civility.id : null}}),_c('CivilitySelect',{attrs:{"label":"short_name","placeholder":_vm.$t('customers.form.civility'),"selectDefault":""},model:{value:(_vm.localContact.civility),callback:function ($$v) {_vm.$set(_vm.localContact, "civility", $$v)},expression:"localContact.civility"}})],1),_c('b-col',[_c('k-form-input',{attrs:{"name":"firstname","placeholder":_vm.$t('customers.form.firstname')},model:{value:(_vm.localContact.firstname),callback:function ($$v) {_vm.$set(_vm.localContact, "firstname", $$v)},expression:"localContact.firstname"}})],1),_c('b-col',[_c('k-form-input',{attrs:{"name":"lastname","placeholder":_vm.$t('customers.form.lastname'),"required":"","autofocus":""},model:{value:(_vm.localContact.lastname),callback:function ($$v) {_vm.$set(_vm.localContact, "lastname", $$v)},expression:"localContact.lastname"}})],1)],1),(_vm.localContact.customers.length < 2)?[(_vm.isBillingContact !== null)?_c('input',{attrs:{"type":"hidden","name":"is_billing_contact"},domProps:{"value":_vm.isBillingContact}}):_vm._e(),_c('k-form-checkbox',{staticClass:"mt-3",attrs:{"validationName":"is_billing_contact"},model:{value:(_vm.isBillingContact),callback:function ($$v) {_vm.isBillingContact=$$v},expression:"isBillingContact"}},[_vm._v(" Utiliser comme contact de facturation ")])]:_vm._e(),_c('h3',{staticClass:"form-title"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'id-card']}}),_vm._v(" "+_vm._s(_vm.$t('customers.form.coordinates'))+" ")],1),_c('b-form-row',[_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.phone')}},[_c('k-form-phone',{attrs:{"name":"phone","initialCountry":_vm.initialCountry},model:{value:(_vm.localContact.phone),callback:function ($$v) {_vm.$set(_vm.localContact, "phone", $$v)},expression:"localContact.phone"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.mobile')}},[_c('k-form-phone',{attrs:{"name":"mobile","placeholderNumberType":"MOBILE","initialCountry":_vm.initialCountry},model:{value:(_vm.localContact.mobile),callback:function ($$v) {_vm.$set(_vm.localContact, "mobile", $$v)},expression:"localContact.mobile"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.fax')}},[_c('k-form-phone',{attrs:{"name":"fax","initialCountry":_vm.initialCountry},model:{value:(_vm.localContact.fax),callback:function ($$v) {_vm.$set(_vm.localContact, "fax", $$v)},expression:"localContact.fax"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('customers.form.email')}},[_c('k-form-input',{attrs:{"type":"email","name":"email"},model:{value:(_vm.localContact.email),callback:function ($$v) {_vm.$set(_vm.localContact, "email", $$v)},expression:"localContact.email"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('customers.form.website')}},[_c('k-form-input',{attrs:{"name":"website","validate":"url"},model:{value:(_vm.localContact.website),callback:function ($$v) {_vm.$set(_vm.localContact, "website", $$v)},expression:"localContact.website"}})],1)],1)],1),_c('h3',{staticClass:"form-title"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'map-signs']}}),_vm._v(" "+_vm._s(_vm.$t('customers.form.address'))+" ")],1),_c('k-form-address',{attrs:{"with-road3":"","countries-list":_vm.countries},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],2),_c('b-col',{staticClass:"customer-secondary-part pt-3 mt-4 mt-md-0",attrs:{"cols":"12","md":"4","offset-md":"1"}},[_vm._l((_vm.localContact.customers),function(customer,i){return _c('input',{key:i,attrs:{"type":"hidden","name":"customers[]"},domProps:{"value":customer.id}})}),(_vm.localContact.customers && _vm.localContact.customers.length === 0)?_c('input',{attrs:{"type":"hidden","name":"customers"},domProps:{"value":null}}):_vm._e(),_c('CustomerSelect',{attrs:{"label":_vm.$t('customers.form.tiers'),"multiple":""},model:{value:(_vm.localContact.customers),callback:function ($$v) {_vm.$set(_vm.localContact, "customers", $$v)},expression:"localContact.customers"}}),_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.function')}},[_c('input',{attrs:{"type":"hidden","name":"function"},domProps:{"value":_vm.localContact.function ? _vm.localContact.function.label : null}}),_c('k-form-select',{attrs:{"options":_vm.contactFunctions,"label":"label","taggable":""},model:{value:(_vm.localContact.function),callback:function ($$v) {_vm.$set(_vm.localContact, "function", $$v)},expression:"localContact.function"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.tags')}},[_vm._l((_vm.localContact.tags),function(tag,i){return _c('input',{key:i,attrs:{"type":"hidden","name":"tags[]"},domProps:{"value":tag.name}})}),(_vm.localContact.tags && _vm.localContact.tags.length === 0)?_c('input',{attrs:{"type":"hidden","name":"tags"},domProps:{"value":null}}):_vm._e(),_c('TagSelect',{model:{value:(_vm.localContact.tags),callback:function ($$v) {_vm.$set(_vm.localContact, "tags", $$v)},expression:"localContact.tags"}})],2),_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.comments')}},[_c('k-form-editor',{attrs:{"name":"comments","config":_vm.editorConfig,"size":"sm"},model:{value:(_vm.localContact.comments),callback:function ($$v) {_vm.$set(_vm.localContact, "comments", $$v)},expression:"localContact.comments"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.newsletter'),"description":_vm.$t('customers.form.newsletterExplain')}},[_c('b-form-radio-group',{attrs:{"name":"newsletter_inscription"},model:{value:(_vm.localContact.newsletter_inscription),callback:function ($$v) {_vm.$set(_vm.localContact, "newsletter_inscription", $$v)},expression:"localContact.newsletter_inscription"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" "+_vm._s(_vm.$t('interface.yes'))+" ")]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" "+_vm._s(_vm.$t('interface.no'))+" ")])],1)],1)],2)],1),_c('CustomFieldsForm',{attrs:{"type":"contact"},model:{value:(_vm.localContact.custom_fields),callback:function ($$v) {_vm.$set(_vm.localContact, "custom_fields", $$v)},expression:"localContact.custom_fields"}})],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: ./src/fetchDatas/contact.ts
var fetchDatas_contact = __webpack_require__(3408);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerSelect/CustomerSelect.vue?vue&type=template&id=8fb0bb82
var CustomerSelectvue_type_template_id_8fb0bb82_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.labelComponent,{tag:"component",attrs:{"label":_vm.computedLabel,"label-size":_vm.labelSize}},[_c('b-input-group',[_c('k-form-select',{ref:"select",attrs:{"ajax":_vm.customerApiUrl,"label":"name","required":_vm.required !== false,"disabled":_vm.disabled !== false,"clearable":_vm.clearable,"validationName":_vm.validationName,"multiple":_vm.multiple !== false,"size":_vm.size},on:{"input":_vm.onChange},model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}}),(_vm.withForm || (_vm.withLink !== false && _vm.multiple === false))?_c('b-input-group-append',[(_vm.withForm)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"px-1",attrs:{"title":_vm.buttonTitle,"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.openForm.apply(null, arguments)}}},[(_vm.multiple !== false || !_vm.value)?_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus']}}):_c('font-awesome-icon',{attrs:{"icon":['fas', 'pencil']}})],1):_vm._e(),(_vm.withLink !== false && _vm.multiple === false)?_c('b-button',{staticClass:"px-1",attrs:{"variant":_vm.withForm ? 'secondary' : 'primary',"size":"sm","disabled":!_vm.customer},on:{"click":function($event){$event.preventDefault();return _vm.goToItem.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'search']}})],1):_vm._e()],1):_vm._e()],1)],1)
}
var CustomerSelectvue_type_template_id_8fb0bb82_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerSelect/CustomerSelect.ts?vue&type=script&lang=ts&external






var CustomerSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerSelect, _super);
    function CustomerSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.customer = null;
        return _this;
    }
    Object.defineProperty(CustomerSelect.prototype, "customerApiUrl", {
        get: function () {
            var url = '/customer?sort=name';
            if (this.type) {
                url += '&filter[is_' + this.type + ']=1';
            }
            if (this.contactId) {
                url += '&filter[hasContact]=' + this.contactId;
            }
            if (this.exclude) {
                url += '&filter[exclude]=' + this.exclude;
            }
            if (this.include) {
                url += '&include=' + this.include.join(',');
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSelect.prototype, "computedLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('customers.customer.label');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSelect.prototype, "labelComponent", {
        get: function () {
            return this.withLabel ? 'b-form-group' : 'div';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSelect.prototype, "computedType", {
        get: function () {
            switch (this.type) {
                case 'prospect_or_customer':
                case 'prospect':
                case null:
                    return this.hasModule('customers-prospects') ? 'prospect' : 'customer';
                case 'subcontractor':
                    return this.hasModule('customers-subcontractors') ? 'subcontractor' : 'provider';
                default:
                    return this.type;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerSelect.prototype, "buttonTitle", {
        get: function () {
            return this.$t('customers.' + this.computedType + '.' + (this.multiple !== false || !this.value ? 'addLabel' : 'editLabel'));
        },
        enumerable: false,
        configurable: true
    });
    CustomerSelect.prototype.watchValue = function (value) {
        if (value === null) {
            this.customer = null;
        }
        else if (Array.isArray(value)) {
            this.customer = Array.from(value);
        }
        else {
            this.customer = JSON.parse(JSON.stringify(this.value));
        }
    };
    CustomerSelect.prototype.onChange = function () {
        return this.customer;
    };
    // Open modal for create or edit a customer
    CustomerSelect.prototype.openForm = function () {
        var _this = this;
        this.openModal({
            key: this.computedType + '-form',
            value: this.multiple === false ? this.value : null,
            attributes: {
                withRedirection: false
            },
            submitted: function (response) {
                var customer = response.data;
                if (_this.multiple === false) {
                    _this.customer = customer;
                }
                else {
                    if (!Array.isArray(_this.customer)) {
                        _this.customer = [];
                    }
                    _this.customer.push(customer);
                }
                var select = _this.$refs.select;
                select.updateOption(customer);
                _this.onChange();
            }
        });
    };
    CustomerSelect.prototype.goToItem = function () {
        var _a, _b, _c, _d, _e;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var type;
            return (0,tslib_es6/* __generator */.YH)(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (Array.isArray(this.customer)) {
                            return [2 /*return*/];
                        }
                        type = 'customer';
                        if ((_a = this.customer) === null || _a === void 0 ? void 0 : _a.reference.customer) {
                            type = 'customer';
                        }
                        else if ((_b = this.customer) === null || _b === void 0 ? void 0 : _b.reference.provider) {
                            type = 'provider';
                        }
                        else if ((_c = this.customer) === null || _c === void 0 ? void 0 : _c.reference.subcontractor) {
                            type = 'subcontractor';
                        }
                        else if ((_d = this.customer) === null || _d === void 0 ? void 0 : _d.reference.prospect) {
                            type = 'prospect';
                        }
                        return [4 /*yield*/, this.$router.push({
                                name: 'contacts-customer-item',
                                params: {
                                    type: type,
                                    id: String((_e = this.customer) === null || _e === void 0 ? void 0 : _e.id)
                                }
                            })];
                    case 1:
                        _f.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSelect.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSelect.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'prospect_or_customer' })
    ], CustomerSelect.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSelect.prototype, "include", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CustomerSelect.prototype, "withForm", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerSelect.prototype, "withLink", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CustomerSelect.prototype, "withLabel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSelect.prototype, "validationName", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerSelect.prototype, "required", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerSelect.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CustomerSelect.prototype, "clearable", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerSelect.prototype, "multiple", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSelect.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSelect.prototype, "labelSize", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSelect.prototype, "contactId", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerSelect.prototype, "exclude", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CustomerSelect.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], CustomerSelect.prototype, "onChange", null);
    CustomerSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                BFormGroup: external_bootstrap_vue_.BFormGroup, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                KFormSelect: form_vue_.KFormSelect
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CustomerSelect);
    return CustomerSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerSelectvue_type_script_lang_ts_external = (CustomerSelect);

;// ./src/components/CustomerSelect/CustomerSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerSelect_CustomerSelectvue_type_script_lang_ts_external = (CustomerSelectvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerSelect/CustomerSelect.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerSelect_CustomerSelectvue_type_script_lang_ts_external,
  CustomerSelectvue_type_template_id_8fb0bb82_render,
  CustomerSelectvue_type_template_id_8fb0bb82_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerSelect_CustomerSelect = (component.exports);
;// ./src/components/ContactForm/editorConfig.ts
var config = {
    enter: 2,
    fontSizeUnit: 'pt',
    zIndex: 999999,
    heightMin: 100,
    toolbarButtons: {
        moreText: {
            buttons: [
                'bold',
                'italic',
                'underline',
                '|',
                'textColor',
                'backgroundColor',
                '|',
                'formatUL',
                'formatOL',
                '|',
                'align'
            ],
            buttonsVisible: 18
        },
        moreParagraph: {
            buttons: [],
            buttonsVisible: 1
        },
        moreRich: {
            buttons: [],
            buttonsVisible: 1
        },
        moreMisc: {
            buttons: [],
            align: 'right',
            buttonsVisible: 0
        }
    },
    pastePlain: true,
    imagePaste: false,
    pasteDeniedTags: ['div', 'span', 'p'],
    htmlAllowComments: false,
    htmlAllowedAttrs: [
        'align', 'alt', 'background', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'checked', 'class', 'color',
        'cols', 'colspan', 'content', 'contenteditable', 'data', 'data-.*', 'datetime', 'disabled', 'form', 'height',
        'hidden', 'href', 'id', 'label', 'max', 'min', 'multiple', 'name', 'placeholder', 'radiogroup', 'readonly',
        'rel', 'required', 'rows', 'rowspan', 'selected', 'size', 'sizes', 'span', 'src', 'step', 'style', 'tabindex',
        'target', 'title', 'type', 'value', 'valign', 'width'
    ],
    tableEditButtons: [
        'tableRemove',
        'tableRows',
        'tableColumns',
        'tableBorder',
        'tableBackground',
        '-',
        'tableCells',
        'tableCellBackground',
        'tableCellBorder',
        'tableCellHorizontalAlign'
    ],
};
/* harmony default export */ var editorConfig = (config);

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContactForm/ContactForm.ts?vue&type=script&lang=ts&external











var ContactForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactForm, _super);
    function ContactForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.localContact = {
            customers: []
        };
        _this.address = {};
        _this.isBillingContact = null;
        _this.editorConfig = editorConfig;
        return _this;
    }
    ContactForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadContactFunctions()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.setLocalContact(this.value)];
                    case 3:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ContactForm.prototype, "initialCountry", {
        get: function () {
            var _a, _b, _c;
            if (this.localContact && this.address.country) {
                return this.address.country.code;
            }
            return (_c = (_b = (_a = this.team) === null || _a === void 0 ? void 0 : _a.country) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : 'fr';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactForm.prototype, "apiFormUrl", {
        get: function () {
            var url = '/customer/contact';
            if (this.localContact.id) {
                url += '/' + this.localContact.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    ContactForm.prototype.setLocalContact = function (contact) {
        var _a, _b;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var local;
            return (0,tslib_es6/* __generator */.YH)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(contact === null)) return [3 /*break*/, 1];
                        local = {
                            newsletter_inscription: this.teamConfigs.automatic_newsletter_subscription,
                            function: this.defaultContactFunction,
                            customers: []
                        };
                        if (this.customer)
                            local.customers.push(this.customer);
                        if (this.defaultContactFunction)
                            local.function = this.defaultContactFunction;
                        this.localContact = local;
                        this.address = {
                            country: this.team.country
                        };
                        return [2 /*return*/];
                    case 1:
                        if (!(contact.id && (0,fetchDatas_contact/* needFetchContact */.Hz)(contact))) return [3 /*break*/, 3];
                        return [4 /*yield*/, (0,fetchDatas_contact/* fetchContact */.tY)(contact.id)];
                    case 2:
                        contact = _c.sent();
                        _c.label = 3;
                    case 3:
                        this.localContact = JSON.parse(JSON.stringify(contact));
                        this.address = {
                            road1: contact.road1,
                            road2: contact.road2,
                            road3: contact.road3,
                            town: contact.town,
                            postal_code: contact.postal_code,
                            country: contact.country
                        };
                        this.isBillingContact = !((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? null : ((_b = this.localContact.customers[0]) === null || _b === void 0 ? void 0 : _b.billing_contact_id) === this.localContact.id;
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactForm.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var contact;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        contact = response.data;
                        if (!(this.value && this.value.id)) return [3 /*break*/, 1];
                        interface_vue_.emitter.emit('contactUpdated', {
                            old: this.value,
                            new: contact
                        });
                        return [3 /*break*/, 3];
                    case 1:
                        interface_vue_.emitter.emit('contactCreated', contact);
                        if (!this.withRedirection) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.$router.push({
                                name: 'contacts-contact-item',
                                params: {
                                    id: String(contact.id)
                                }
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactForm.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], ContactForm.prototype, "withRedirection", void 0);
    ContactForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['countries'])), (0,external_vuex_.mapGetters)('user', ['team', 'teamConfigs'])), (0,external_vuex_.mapState)('customers', ['contactFunctions'])), (0,external_vuex_.mapGetters)('customers', ['defaultContactFunction'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])), (0,external_vuex_.mapActions)('customers', ['loadContactFunctions'])),
            components: {
                CustomerSelect: CustomerSelect_CustomerSelect,
                CustomFieldsForm: custom_fields_vue_.CustomFieldsForm,
                Spinner: interface_vue_.Spinner,
                CivilitySelect: interface_vue_.CivilitySelect, TagSelect: interface_vue_.TagSelect,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormInput: form_vue_.KFormInput, KFormPhone: form_vue_.KFormPhone, KFormAddress: form_vue_.KFormAddress, KFormEditor: form_vue_.KFormEditor, KFormCheckbox: form_vue_.KFormCheckbox,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormRow: external_bootstrap_vue_.BFormRow, BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], ContactForm);
    return ContactForm;
}(lib/* Vue */.lD));
/* harmony default export */ var ContactFormvue_type_script_lang_ts_external = (ContactForm);

;// ./src/components/ContactForm/ContactForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContactForm_ContactFormvue_type_script_lang_ts_external = (ContactFormvue_type_script_lang_ts_external); 
;// ./src/components/ContactForm/ContactForm.vue





/* normalize component */
;
var ContactForm_component = (0,componentNormalizer/* default */.A)(
  ContactForm_ContactFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContactForm_ContactForm = (ContactForm_component.exports);
// EXTERNAL MODULE: ./src/components/ContactFunctions/ContactFunctions.vue + 3 modules
var ContactFunctions = __webpack_require__(4771);
// EXTERNAL MODULE: ./src/components/ContactInformations/ContactInformations.vue + 3 modules
var ContactInformations = __webpack_require__(5469);
// EXTERNAL MODULE: ./src/components/ContactItem/ContactItem.vue + 7 modules
var ContactItem = __webpack_require__(3095);
// EXTERNAL MODULE: ./src/components/ContactOrigins/ContactOrigins.vue + 3 modules
var ContactOrigins = __webpack_require__(7785);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ContactSelect/ContactSelect.vue?vue&type=template&id=79647730
var ContactSelectvue_type_template_id_79647730_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.labelComponent,{tag:"component",attrs:{"label":_vm.computedLabel,"label-size":_vm.labelSize}},[_c('b-input-group',[_c('k-form-select',_vm._b({ref:"select",on:{"input":_vm.onChange},model:{value:(_vm.contact),callback:function ($$v) {_vm.contact=$$v},expression:"contact"}},'k-form-select',_vm.attributes,false)),(_vm.withForm || _vm.withLink !== false)?_c('b-input-group-append',[(_vm.withForm)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"px-1",attrs:{"title":_vm.$t('customers.contact.' + (!_vm.contact ? 'addLabel' : 'editLabel')),"variant":"primary","size":_vm.size,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.openForm.apply(null, arguments)}}},[(!_vm.contact)?_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus']}}):_c('font-awesome-icon',{attrs:{"icon":['fas', 'pencil']}})],1):_vm._e(),(_vm.withLink !== false)?_c('b-button',{staticClass:"px-1",attrs:{"variant":_vm.withForm ? 'secondary' : 'primary',"size":"sm","disabled":!_vm.contact},on:{"click":function($event){$event.preventDefault();return _vm.goToItem.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'search']}})],1):_vm._e()],1):_vm._e()],1)],1)
}
var ContactSelectvue_type_template_id_79647730_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ContactSelect/ContactSelect.ts?vue&type=script&lang=ts&external






var ContactSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ContactSelect, _super);
    function ContactSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contact = null;
        return _this;
    }
    Object.defineProperty(ContactSelect.prototype, "computedLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('customers.contact.label');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactSelect.prototype, "labelComponent", {
        get: function () {
            return this.withLabel ? 'b-form-group' : 'div';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactSelect.prototype, "attributes", {
        get: function () {
            var attrs = {
                getOptionLabel: this.selectLabel,
                required: this.required !== false,
                disabled: this.disabled !== false,
                clearable: this.clearable,
                validationName: this.validationName,
                size: this.size
            };
            if (this.customer && this.customer.contacts) {
                attrs.options = this.customer.contacts;
            }
            else {
                attrs.ajax = this.contactApiUrl;
            }
            return attrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContactSelect.prototype, "contactApiUrl", {
        get: function () {
            var url = '/customer/contact?sort=fullname';
            if (this.customer) {
                url += '&filter[with_customer]=' + this.customer.id;
            }
            if (this.include) {
                url += '&include=' + (typeof this.include === 'string' ? this.include : this.include.join(','));
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    ContactSelect.prototype.watchValue = function (value) {
        this.contact = value === null ? null : JSON.parse(JSON.stringify(this.value));
    };
    ContactSelect.prototype.onChange = function () {
        return this.contact;
    };
    // Open modal for create or edit a customer
    ContactSelect.prototype.openForm = function () {
        var _this = this;
        this.openModal({
            key: 'contact-form',
            value: this.contact,
            attributes: {
                customer: this.customer,
                withRedirection: false
            },
            submitted: function (response) {
                var contact = response.data;
                _this.contact = contact;
                var select = _this.$refs.select;
                select.updateOption(contact);
                _this.onChange();
            }
        });
    };
    ContactSelect.prototype.goToItem = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.$router.push({
                            name: 'contacts-contact-item',
                            params: {
                                id: String((_a = this.contact) === null || _a === void 0 ? void 0 : _a.id)
                            }
                        })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactSelect.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactSelect.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactSelect.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], ContactSelect.prototype, "withLabel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], ContactSelect.prototype, "withForm", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContactSelect.prototype, "withLink", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactSelect.prototype, "validationName", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContactSelect.prototype, "required", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ContactSelect.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], ContactSelect.prototype, "clearable", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactSelect.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactSelect.prototype, "labelSize", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ContactSelect.prototype, "include", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return function (contact) { return contact === null || contact === void 0 ? void 0 : contact.fullname; }; } })
    ], ContactSelect.prototype, "selectLabel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ContactSelect.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], ContactSelect.prototype, "onChange", null);
    ContactSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            components: {
                KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], ContactSelect);
    return ContactSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var ContactSelectvue_type_script_lang_ts_external = (ContactSelect);

;// ./src/components/ContactSelect/ContactSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ContactSelect_ContactSelectvue_type_script_lang_ts_external = (ContactSelectvue_type_script_lang_ts_external); 
;// ./src/components/ContactSelect/ContactSelect.vue





/* normalize component */
;
var ContactSelect_component = (0,componentNormalizer/* default */.A)(
  ContactSelect_ContactSelectvue_type_script_lang_ts_external,
  ContactSelectvue_type_template_id_79647730_render,
  ContactSelectvue_type_template_id_79647730_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ContactSelect_ContactSelect = (ContactSelect_component.exports);
// EXTERNAL MODULE: ./src/components/ContactsList/ContactsList.vue + 3 modules
var ContactsList = __webpack_require__(5097);
// EXTERNAL MODULE: ./src/components/ContactSpeedItem/ContactSpeedItem.vue + 3 modules
var ContactSpeedItem = __webpack_require__(4256);
// EXTERNAL MODULE: ./src/components/CustomerAddressDelete/CustomerAddressDelete.vue + 3 modules
var CustomerAddressDelete = __webpack_require__(8223);
// EXTERNAL MODULE: ./src/components/CustomerAddressForm/CustomerAddressForm.vue + 3 modules
var CustomerAddressForm = __webpack_require__(2661);
// EXTERNAL MODULE: ./src/components/CustomerAddressList/CustomerAddressList.vue + 3 modules
var CustomerAddressList = __webpack_require__(1223);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerAddressSelect/CustomerAddressSelect.vue?vue&type=template&id=0a07da36
var CustomerAddressSelectvue_type_template_id_0a07da36_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-group',{attrs:{"label":_vm.label,"size":_vm.size}},[_c('b-input-group',[_c('k-form-select',_vm._b({ref:"select",attrs:{"size":_vm.size},on:{"input":_vm.onChange},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}},'k-form-select',_vm.attributes,false)),(_vm.withForm)?_c('b-input-group-append',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"px-1",attrs:{"title":_vm.$t('customers.address.' + (!_vm.address ? 'addLabel' : 'editLabel')),"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.openForm.apply(null, arguments)}}},[(!_vm.address)?_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus']}}):_c('font-awesome-icon',{attrs:{"icon":['fas', 'pencil']}})],1),(_vm.toEdit)?_c('CustomerAddressForm',{attrs:{"customer":_vm.customer,"modalState":true},on:{"hidden":function($event){_vm.toEdit = false},"submitComplete":_vm.submitComplete},model:{value:(_vm.addressForm),callback:function ($$v) {_vm.addressForm=$$v},expression:"addressForm"}}):_vm._e()],1):_vm._e()],1)],1)
}
var CustomerAddressSelectvue_type_template_id_0a07da36_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerAddressSelect/CustomerAddressSelect.ts?vue&type=script&lang=ts&external






var CustomerAddressSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerAddressSelect, _super);
    function CustomerAddressSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.address = null;
        _this.addressForm = {};
        _this.toEdit = false;
        return _this;
    }
    Object.defineProperty(CustomerAddressSelect.prototype, "attributes", {
        get: function () {
            var attrs = {
                required: this.required !== false,
                disabled: this.disabled !== false,
                clearable: this.clearable,
                validationName: this.validationName,
                placeholder: this.placeholder
            };
            if (!this.customer.addresses) {
                attrs.ajax = this.apiUrl;
            }
            return attrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerAddressSelect.prototype, "apiUrl", {
        get: function () {
            return '/customer/' + this.customer.id + '/address?sort=label';
        },
        enumerable: false,
        configurable: true
    });
    CustomerAddressSelect.prototype.watchValue = function (value) {
        if (value === null) {
            this.address = null;
            this.addressForm = {};
            return;
        }
        this.address = JSON.parse(JSON.stringify(this.value));
        this.addressForm = JSON.parse(JSON.stringify(this.value));
    };
    CustomerAddressSelect.prototype.onChange = function () {
        var _this = this;
        var address = this.address ? JSON.parse(JSON.stringify(this.address)) : {};
        this.addressForm = address;
        if (this.clearOnSelect !== false) {
            this.$nextTick(function () {
                _this.address = null;
            });
        }
        return address;
    };
    // Open modal for create or edit a customer
    CustomerAddressSelect.prototype.openForm = function () {
        this.toEdit = true;
    };
    CustomerAddressSelect.prototype.submitComplete = function (address) {
        var select = this.$refs.select;
        select.updateOption(address);
        this.address = address;
        this.onChange();
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerAddressSelect.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Adresse' })
    ], CustomerAddressSelect.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerAddressSelect.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CustomerAddressSelect.prototype, "withForm", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerAddressSelect.prototype, "validationName", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerAddressSelect.prototype, "required", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerAddressSelect.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CustomerAddressSelect.prototype, "clearable", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CustomerAddressSelect.prototype, "clearOnSelect", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerAddressSelect.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerAddressSelect.prototype, "placeholder", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CustomerAddressSelect.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], CustomerAddressSelect.prototype, "onChange", null);
    CustomerAddressSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CustomerAddressForm: CustomerAddressForm/* default */.A,
                KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CustomerAddressSelect);
    return CustomerAddressSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerAddressSelectvue_type_script_lang_ts_external = (CustomerAddressSelect);

;// ./src/components/CustomerAddressSelect/CustomerAddressSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerAddressSelect_CustomerAddressSelectvue_type_script_lang_ts_external = (CustomerAddressSelectvue_type_script_lang_ts_external); 
;// ./src/components/CustomerAddressSelect/CustomerAddressSelect.vue





/* normalize component */
;
var CustomerAddressSelect_component = (0,componentNormalizer/* default */.A)(
  CustomerAddressSelect_CustomerAddressSelectvue_type_script_lang_ts_external,
  CustomerAddressSelectvue_type_template_id_0a07da36_render,
  CustomerAddressSelectvue_type_template_id_0a07da36_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerAddressSelect_CustomerAddressSelect = (CustomerAddressSelect_component.exports);
// EXTERNAL MODULE: ./src/components/CustomerArchivate/CustomerArchivate.vue + 3 modules
var CustomerArchivate = __webpack_require__(8031);
// EXTERNAL MODULE: ./src/components/CustomerChargeParams/CustomerChargeParams.vue + 3 modules
var CustomerChargeParams = __webpack_require__(3407);
// EXTERNAL MODULE: ./src/components/CustomerContacts/CustomerContacts.vue + 3 modules
var CustomerContacts = __webpack_require__(8402);
// EXTERNAL MODULE: ./src/components/CustomerDelete/CustomerDelete.vue + 3 modules
var CustomerDelete = __webpack_require__(3878);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerForm/CustomerForm.vue?vue&type=template&id=3e3014e8
var CustomerFormvue_type_template_id_3e3014e8_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.apiFormUrl,"method":_vm.localCustomer.id ? 'PUT' : 'POST'},on:{"submitComplete":_vm.submitComplete}},[(!_vm.localCustomer.id)?_c('input',{attrs:{"name":'is_' + _vm.type,"type":"hidden"},domProps:{"value":true}}):_vm._e(),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"7"}},[_c('input',{attrs:{"name":"type","type":"hidden"},domProps:{"value":_vm.localCustomer.type ? _vm.localCustomer.type.id : null}}),(_vm.customerTypes.length > 3)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.type')}},[_c('k-form-select',{attrs:{"options":_vm.customerTypes},model:{value:(_vm.localCustomer.type),callback:function ($$v) {_vm.$set(_vm.localCustomer, "type", $$v)},expression:"localCustomer.type"}})],1):_c('b-form-group',[_c('b-form-radio-group',{model:{value:(_vm.localCustomer.type),callback:function ($$v) {_vm.$set(_vm.localCustomer, "type", $$v)},expression:"localCustomer.type"}},_vm._l((_vm.customerTypes),function(type,i){return _c('b-form-radio',{key:i,attrs:{"value":type}},[_vm._v(" "+_vm._s(type.label)+" ")])}),1)],1),(_vm.computedType.is_company)?_c('b-form-group',{staticClass:"position-relative customer-name-form-part"},[_c('k-form-input',{attrs:{"name":"company_name","label":_vm.$t('customers.form.companyName'),"required":_vm.computedType.is_company && !_vm.computedType.is_person,"autofocus":_vm.computedType.is_company,"autocomplete":"do-not-autofill"},on:{"input":_vm.searchCompany},model:{value:(_vm.localCustomer.company_name),callback:function ($$v) {_vm.$set(_vm.localCustomer, "company_name", $$v)},expression:"localCustomer.company_name"}}),(_vm.searchCompanyResults)?_c('b-list-group',{staticClass:"api-sirene-dropdown"},_vm._l((_vm.searchCompanyResults),function(siret,i){return _c('b-list-group-item',{key:i,staticClass:"px-2 py-1",on:{"click":function($event){return _vm.selectCompany(siret)}}},[_c('p',{staticClass:"mb-0"},[(siret.unite_legale.denominationUniteLegale)?_c('span',[_vm._v(" "+_vm._s(siret.unite_legale.denominationUniteLegale)+" ")]):_c('span',[_vm._v(" "+_vm._s(siret.unite_legale.prenomUsuelUniteLegale)+" "+_vm._s(siret.unite_legale.nomUniteLegale)+" "),(siret.denominationUsuelleEtablissement)?[_vm._v(" - "+_vm._s(siret.denominationUsuelleEtablissement)+" ")]:_vm._e()],2),(siret.enseigne1Etablissement)?_c('span',[_vm._v(" - "+_vm._s(siret.enseigne1Etablissement)+" ")]):_vm._e()]),_c('span',{staticClass:"small text-muted"},[_vm._v(" "+_vm._s(siret.codePostalEtablissement)+" "+_vm._s(siret.libelleCommuneEtablissement)+" - SIRET : "+_vm._s(siret.siret)+" ")])])}),1):_vm._e()],1):_vm._e(),(_vm.computedType.is_person)?_c('b-form-row',[_c('b-col',[_c('input',{attrs:{"type":"hidden","name":"civility"},domProps:{"value":_vm.localCustomer.civility ? _vm.localCustomer.civility.id : null}}),_c('CivilitySelect',{attrs:{"label":"short_name","placeholder":_vm.$t('customers.form.civility'),"selectDefault":""},model:{value:(_vm.localCustomer.civility),callback:function ($$v) {_vm.$set(_vm.localCustomer, "civility", $$v)},expression:"localCustomer.civility"}})],1),_c('b-col',[_c('k-form-input',{attrs:{"name":"firstname","placeholder":_vm.$t('customers.form.firstname'),"required":_vm.teamConfigs.check_duplicates_for_person && _vm.computedType.is_person && !_vm.computedType.is_company},model:{value:(_vm.localCustomer.firstname),callback:function ($$v) {_vm.$set(_vm.localCustomer, "firstname", $$v)},expression:"localCustomer.firstname"}})],1),_c('b-col',[_c('k-form-input',{attrs:{"name":"lastname","placeholder":_vm.$t('customers.form.lastname'),"required":_vm.computedType.is_person && !_vm.computedType.is_company,"autofocus":_vm.computedType.is_person && !_vm.computedType.is_company},model:{value:(_vm.localCustomer.lastname),callback:function ($$v) {_vm.$set(_vm.localCustomer, "lastname", $$v)},expression:"localCustomer.lastname"}})],1)],1):_vm._e(),_c('b-tabs',{staticClass:"mt-4",attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":_vm.$t('customers.form.invoiceAddress'),"active":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deliveryUseInvoiceAddress),expression:"deliveryUseInvoiceAddress"}],attrs:{"type":"hidden","name":"address_invoice[use_for_delivery]"},domProps:{"value":(_vm.deliveryUseInvoiceAddress)},on:{"input":function($event){if($event.target.composing)return;_vm.deliveryUseInvoiceAddress=$event.target.value}}}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deliveryUseInvoiceAddress),expression:"deliveryUseInvoiceAddress"}],attrs:{"type":"hidden","name":"address_invoice[override_other_use]"},domProps:{"value":(_vm.deliveryUseInvoiceAddress)},on:{"input":function($event){if($event.target.composing)return;_vm.deliveryUseInvoiceAddress=$event.target.value}}}),_c('k-form-address',{attrs:{"road-name":"address_invoice[road1]","road2-name":"address_invoice[road2]","road3-name":"address_invoice[road3]","postal-code-name":"address_invoice[postal_code]","city-name":"address_invoice[town]","country-name":"address_invoice[country]","with-road3":"","countries-list":_vm.countries},model:{value:(_vm.localCustomer.address_invoice),callback:function ($$v) {_vm.$set(_vm.localCustomer, "address_invoice", $$v)},expression:"localCustomer.address_invoice"}})],1),_c('b-tab',{attrs:{"title":_vm.$t('customers.form.deliveryAddress')}},[_c('k-form-checkbox',{staticClass:"mb-2",model:{value:(_vm.deliveryUseInvoiceAddress),callback:function ($$v) {_vm.deliveryUseInvoiceAddress=$$v},expression:"deliveryUseInvoiceAddress"}},[_vm._v(" "+_vm._s(_vm.$t('customers.form.useInvoiceAddress'))+" ")]),_c('k-form-address',{attrs:{"road-name":"address_delivery[road1]","road2-name":"address_delivery[road2]","road3-name":"address_delivery[road3]","postal-code-name":"address_delivery[postal_code]","city-name":"address_delivery[town]","country-name":"address_delivery[country]","with-road3":"","countries-list":_vm.countries,"disabled":_vm.deliveryUseInvoiceAddress},model:{value:(_vm.localCustomer.address_delivery),callback:function ($$v) {_vm.$set(_vm.localCustomer, "address_delivery", $$v)},expression:"localCustomer.address_delivery"}})],1)],1),_c('h3',{staticClass:"form-title"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'id-card']}}),_vm._v(" "+_vm._s(_vm.$t('customers.form.coordinates'))+" ")],1),_c('b-form-row',[_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.phone')}},[_c('k-form-phone',{attrs:{"name":"phone","initialCountry":_vm.initialCountry},model:{value:(_vm.localCustomer.phone),callback:function ($$v) {_vm.$set(_vm.localCustomer, "phone", $$v)},expression:"localCustomer.phone"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.mobile')}},[_c('k-form-phone',{attrs:{"name":"mobile","placeholderNumberType":"MOBILE","initialCountry":_vm.initialCountry},model:{value:(_vm.localCustomer.mobile),callback:function ($$v) {_vm.$set(_vm.localCustomer, "mobile", $$v)},expression:"localCustomer.mobile"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"4"}},[_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.fax')}},[_c('k-form-phone',{attrs:{"name":"fax","initialCountry":_vm.initialCountry},model:{value:(_vm.localCustomer.fax),callback:function ($$v) {_vm.$set(_vm.localCustomer, "fax", $$v)},expression:"localCustomer.fax"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('customers.form.email')}},[_c('k-form-input',{attrs:{"type":"email","name":"email"},model:{value:(_vm.localCustomer.email),callback:function ($$v) {_vm.$set(_vm.localCustomer, "email", $$v)},expression:"localCustomer.email"}})],1)],1),_c('b-col',{attrs:{"sm":"12","md":"6"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('customers.form.website')}},[_c('k-form-input',{attrs:{"name":"website","validate":"url"},model:{value:(_vm.localCustomer.website),callback:function ($$v) {_vm.$set(_vm.localCustomer, "website", $$v)},expression:"localCustomer.website"}})],1)],1)],1),(_vm.teamConfigs.customer_add_company_datas && _vm.computedType.is_company)?_c('CustomFieldsForm',{attrs:{"type":_vm.type},model:{value:(_vm.localCustomer.custom_fields),callback:function ($$v) {_vm.$set(_vm.localCustomer, "custom_fields", $$v)},expression:"localCustomer.custom_fields"}}):_vm._e()],1),_c('b-col',{staticClass:"customer-secondary-part pt-3 mt-4 mt-md-0",attrs:{"cols":"12","md":"4","offset-md":"1"}},[_c('input',{attrs:{"type":"hidden","name":"billing_contact"},domProps:{"value":_vm.localCustomer.billing_contact ? _vm.localCustomer.billing_contact.id : null}}),_c('ContactSelect',{attrs:{"label":"Contact facturation","customer":_vm.value?.id ? _vm.value : null},model:{value:(_vm.localCustomer.billing_contact),callback:function ($$v) {_vm.$set(_vm.localCustomer, "billing_contact", $$v)},expression:"localCustomer.billing_contact"}}),(_vm.hasModule('customers-group'))?[_c('input',{attrs:{"type":"hidden","name":"parent"},domProps:{"value":_vm.localCustomer.parent ? _vm.localCustomer.parent.id : null}}),_c('CustomerSelect',{attrs:{"label":_vm.teamConfigs.customer_group_parent_name,"exclude":_vm.localCustomer.id},model:{value:(_vm.localCustomer.parent),callback:function ($$v) {_vm.$set(_vm.localCustomer, "parent", $$v)},expression:"localCustomer.parent"}})]:_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.tags')}},[_vm._l((_vm.localCustomer.tags),function(tag,i){return _c('input',{key:i,attrs:{"type":"hidden","name":"tags[]"},domProps:{"value":typeof tag === 'object' ? tag.name : tag}})}),(_vm.localCustomer.tags && _vm.localCustomer.tags.length === 0)?_c('input',{attrs:{"type":"hidden","name":"tags"},domProps:{"value":null}}):_vm._e(),_c('TagSelect',{model:{value:(_vm.localCustomer.tags),callback:function ($$v) {_vm.$set(_vm.localCustomer, "tags", $$v)},expression:"localCustomer.tags"}})],2),_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.activity')}},[_c('input',{attrs:{"type":"hidden","name":"activity"},domProps:{"value":_vm.localCustomer.activity ? _vm.localCustomer.activity.label : null}}),_c('k-form-select',{attrs:{"options":_vm.activities,"label":"label","taggable":""},model:{value:(_vm.localCustomer.activity),callback:function ($$v) {_vm.$set(_vm.localCustomer, "activity", $$v)},expression:"localCustomer.activity"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.origin')}},[_c('input',{attrs:{"type":"hidden","name":"origin"},domProps:{"value":_vm.localCustomer.origin ? _vm.localCustomer.origin.label : null}}),_c('k-form-select',{attrs:{"options":_vm.origins,"label":"label","taggable":""},model:{value:(_vm.localCustomer.origin),callback:function ($$v) {_vm.$set(_vm.localCustomer, "origin", $$v)},expression:"localCustomer.origin"}})],1),(_vm.computedType.is_company)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.siret')}},[_c('k-form-input',{attrs:{"name":"company_siret"},model:{value:(_vm.localCustomer.company_siret),callback:function ($$v) {_vm.$set(_vm.localCustomer, "company_siret", $$v)},expression:"localCustomer.company_siret"}})],1):_vm._e(),(_vm.computedType.is_company)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.vatrate')}},[_c('k-form-input',{attrs:{"name":"company_vatrate"},model:{value:(_vm.localCustomer.company_vatrate),callback:function ($$v) {_vm.$set(_vm.localCustomer, "company_vatrate", $$v)},expression:"localCustomer.company_vatrate"}})],1):_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.commercial')}},[_c('input',{attrs:{"type":"hidden","name":"team_user"},domProps:{"value":_vm.localCustomer.team_user ? _vm.localCustomer.team_user.id : null}}),_c('TeamUserSelect',{model:{value:(_vm.localCustomer.team_user),callback:function ($$v) {_vm.$set(_vm.localCustomer, "team_user", $$v)},expression:"localCustomer.team_user"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.newsletter'),"description":_vm.$t('customers.form.newsletterExplain')}},[_c('b-form-radio-group',{attrs:{"name":"newsletter_inscription"},model:{value:(_vm.localCustomer.newsletter_inscription),callback:function ($$v) {_vm.$set(_vm.localCustomer, "newsletter_inscription", $$v)},expression:"localCustomer.newsletter_inscription"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" "+_vm._s(_vm.$t('interface.yes'))+" ")]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" "+_vm._s(_vm.$t('interface.no'))+" ")])],1)],1),(_vm.computedType.is_person)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.birthDate')}},[_c('k-form-datepicker',{attrs:{"name":"birth_date"},model:{value:(_vm.localCustomer.birth_date),callback:function ($$v) {_vm.$set(_vm.localCustomer, "birth_date", $$v)},expression:"localCustomer.birth_date"}})],1):_vm._e(),(_vm.type === 'customer' || _vm.localCustomer.reference?.customer)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.customerAccount')}},[_c('k-form-input',{attrs:{"name":"customer_account"},model:{value:(_vm.localCustomer.customer_account),callback:function ($$v) {_vm.$set(_vm.localCustomer, "customer_account", $$v)},expression:"localCustomer.customer_account"}})],1):_vm._e(),(_vm.type === 'provider' || _vm.localCustomer.reference?.provider)?_c('b-form-group',{attrs:{"label":_vm.$t('customers.form.providerAccount')}},[_c('k-form-input',{attrs:{"name":"provider_account"},model:{value:(_vm.localCustomer.provider_account),callback:function ($$v) {_vm.$set(_vm.localCustomer, "provider_account", $$v)},expression:"localCustomer.provider_account"}})],1):_vm._e(),(_vm.teamConfigs.customer_add_company_datas && _vm.computedType.is_company)?[_c('b-form-group',{attrs:{"label":"Type d'entreprise"}},[_c('k-form-input',{attrs:{"name":"company_type"},model:{value:(_vm.localCustomer.company_type),callback:function ($$v) {_vm.$set(_vm.localCustomer, "company_type", $$v)},expression:"localCustomer.company_type"}})],1),_c('b-form-group',{attrs:{"label":"Numéro RCS"}},[_c('k-form-input',{attrs:{"name":"company_rcs"},model:{value:(_vm.localCustomer.company_rcs),callback:function ($$v) {_vm.$set(_vm.localCustomer, "company_rcs", $$v)},expression:"localCustomer.company_rcs"}})],1),_c('b-form-group',{attrs:{"label":"Code NAF"}},[_c('k-form-input',{attrs:{"name":"company_naf"},model:{value:(_vm.localCustomer.company_naf),callback:function ($$v) {_vm.$set(_vm.localCustomer, "company_naf", $$v)},expression:"localCustomer.company_naf"}})],1),_c('b-form-group',{attrs:{"label":"Capital"}},[_c('k-form-input',{attrs:{"name":"company_capital"},model:{value:(_vm.localCustomer.company_capital),callback:function ($$v) {_vm.$set(_vm.localCustomer, "company_capital", $$v)},expression:"localCustomer.company_capital"}})],1)]:_vm._e()],2)],1),(!_vm.teamConfigs.customer_add_company_datas || !_vm.computedType.is_company)?_c('CustomFieldsForm',{attrs:{"type":_vm.type},model:{value:(_vm.localCustomer.custom_fields),callback:function ($$v) {_vm.$set(_vm.localCustomer, "custom_fields", $$v)},expression:"localCustomer.custom_fields"}}):_vm._e(),_c('b-button',{staticClass:"mt-4",attrs:{"variant":"link","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.showSalesPreferences = !_vm.showSalesPreferences}}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":['fas', _vm.showSalesPreferences ? 'caret-up' : 'caret-down']}}),_vm._v(" Préférences de vente ")],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSalesPreferences),expression:"showSalesPreferences"}]},[_c('h2',{staticClass:"form-title-alt mt-2"},[_vm._v(" Préférences de ventes ")]),_c('CustomerSaleParams',{staticClass:"mt-2",attrs:{"value":_vm.localCustomer,"withForm":false}})],1)],1)],1)
}
var CustomerFormvue_type_template_id_3e3014e8_staticRenderFns = []


;// external "axios"
var external_axios_namespaceObject = require("axios");
var external_axios_default = /*#__PURE__*/__webpack_require__.n(external_axios_namespaceObject);
// EXTERNAL MODULE: ./src/components/CustomerSaleParams/CustomerSaleParams.vue + 3 modules
var CustomerSaleParams = __webpack_require__(5911);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerForm/CustomerForm.ts?vue&type=script&lang=ts&external












var CustomerForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerForm, _super);
    function CustomerForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.localCustomer = {};
        _this.deliveryUseInvoiceAddress = true;
        _this.showSalesPreferences = false;
        _this.searchCompanyTimeout = null;
        _this.searchCompanyResults = null;
        return _this;
    }
    Object.defineProperty(CustomerForm.prototype, "initialCountry", {
        get: function () {
            var _a, _b, _c, _d, _e;
            if (this.localCustomer && ((_a = this.localCustomer.address_invoice) === null || _a === void 0 ? void 0 : _a.country)) {
                return (_b = this.localCustomer.address_invoice) === null || _b === void 0 ? void 0 : _b.country.code;
            }
            return (_e = (_d = (_c = this.team) === null || _c === void 0 ? void 0 : _c.country) === null || _d === void 0 ? void 0 : _d.code) !== null && _e !== void 0 ? _e : 'fr';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerForm.prototype, "computedType", {
        get: function () {
            if (this.localCustomer.type) {
                return this.localCustomer.type;
            }
            if (this.customerTypes && this.customerTypes.length > 0) {
                var defaultType = this.customerTypes.find(function (type) { return type.use_default; });
                if (defaultType) {
                    return defaultType;
                }
                return this.customerTypes[0];
            }
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerForm.prototype, "apiFormUrl", {
        get: function () {
            var url = '/customer';
            if (this.localCustomer.id) {
                url += '/' + this.localCustomer.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    CustomerForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCustomerTypes()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadCountries()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.loadActivities()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.loadOrigins()];
                    case 5:
                        _a.sent();
                        this.setLocalCustomer(this.value);
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerForm.prototype.beforeDestroy = function () {
        window.document.removeEventListener('click', this.searchCompanyClose);
    };
    CustomerForm.prototype.setLocalCustomer = function (customer) {
        if (!customer) {
            this.localCustomer = {
                address_invoice: {
                    country: this.team.country
                },
                team_user: this.teamUser,
                newsletter_inscription: this.teamConfigs.automatic_newsletter_subscription,
                type: this.computedType,
                activity: this.defaultActivity,
                origin: this.defaultOrigin
            };
            return;
        }
        customer = JSON.parse(JSON.stringify(customer));
        var delivery = customer.address_delivery;
        var invoice = customer.address_invoice;
        if (delivery && (!invoice || invoice.id !== delivery.id)) {
            this.deliveryUseInvoiceAddress = false;
        }
        this.localCustomer = customer;
    };
    CustomerForm.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var customer;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        customer = response.data;
                        if (!(this.value && this.value.id)) return [3 /*break*/, 1];
                        interface_vue_.emitter.emit('customerUpdated', { old: this.value, new: customer });
                        return [3 /*break*/, 3];
                    case 1:
                        interface_vue_.emitter.emit('customerCreated', customer);
                        if (!this.withRedirection) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.$router.push({
                                name: 'contacts-customer-item',
                                params: {
                                    id: String(customer.id),
                                    type: this.type
                                }
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerForm.prototype.searchCompany = function () {
        var _a, _b, _c, _d;
        if (!this.teamConfigs.fetch_customer_sirene_api || !this.$kwCustomers.sireneApitoken || (((_a = this.localCustomer.address_invoice) === null || _a === void 0 ? void 0 : _a.country) && !['FR', 'GP', 'RE', 'MQ'].includes((_d = (_c = (_b = this.localCustomer.address_invoice) === null || _b === void 0 ? void 0 : _b.country) === null || _c === void 0 ? void 0 : _c.code) !== null && _d !== void 0 ? _d : ''))) {
            return;
        }
        if (this.searchCompanyTimeout) {
            clearTimeout(this.searchCompanyTimeout);
        }
        if (!this.localCustomer.company_name) {
            this.searchCompanyResults = null;
            return;
        }
        this.searchCompanyTimeout = setTimeout(this.processSearchCompany, 500);
    };
    CustomerForm.prototype.processSearchCompany = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var name;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        name = this.localCustomer.company_name;
                        if (((_a = name === null || name === void 0 ? void 0 : name.length) !== null && _a !== void 0 ? _a : 0) < 3) {
                            this.searchCompanyResults = null;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, external_axios_default().get(this.$kwCustomers.sireneApiUrl + '/siret', {
                                headers: {
                                    Authorization: 'Bearer ' + this.$kwCustomers.sireneApitoken
                                },
                                withCredentials: true,
                                params: {
                                    name: name,
                                    per_page: 5
                                }
                            })
                                .then(function (response) {
                                _this.searchCompanyResults = response.data.data;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CustomerForm.prototype.watchSearchCompanyResults = function () {
        if (this.searchCompanyResults === null || this.searchCompanyResults.length === 0) {
            window.document.removeEventListener('click', this.searchCompanyClose);
        }
        else {
            window.document.addEventListener('click', this.searchCompanyClose);
        }
    };
    CustomerForm.prototype.searchCompanyClose = function (event) {
        var target = event.target;
        var parent = target.closest('.customer-name-form-part');
        if (!target.classList.contains('customer-name-form-part') && !parent) {
            this.searchCompanyResults = null;
        }
    };
    CustomerForm.prototype.selectCompany = function (siret) {
        var _a, _b, _c, _d, _e, _f, _g;
        this.searchCompanyResults = null;
        var company_name;
        if ((_a = siret.unite_legale) === null || _a === void 0 ? void 0 : _a.denominationUniteLegale) {
            company_name = (_b = siret.unite_legale) === null || _b === void 0 ? void 0 : _b.denominationUniteLegale;
        }
        else if (siret.denominationUsuelleEtablissement) {
            company_name = siret.denominationUsuelleEtablissement;
        }
        else {
            company_name = ((_c = siret.unite_legale) === null || _c === void 0 ? void 0 : _c.prenomUsuelUniteLegale) + ' ' + ((_d = siret.unite_legale) === null || _d === void 0 ? void 0 : _d.nomUniteLegale);
        }
        this.localCustomer.company_name = this.uppercaseFirstLetter(company_name);
        if (!this.localCustomer.address_invoice) {
            this.localCustomer.address_invoice = {};
        }
        var road1 = [siret.numeroVoieEtablissement, siret.indiceRepetitionEtablissement, siret.typeVoieEtablissement, siret.libelleVoieEtablissement];
        this.localCustomer.address_invoice.road1 = this.uppercaseFirstLetter(road1.filter(function (road) { return road !== null; }).join(' '));
        this.localCustomer.address_invoice.road2 = this.uppercaseFirstLetter(siret.complementAdresseEtablissement);
        this.localCustomer.address_invoice.road3 = '';
        this.localCustomer.address_invoice.town = this.uppercaseFirstLetter(siret.libelleCommuneEtablissement);
        this.localCustomer.address_invoice.postal_code = this.uppercaseFirstLetter(siret.codePostalEtablissement);
        this.localCustomer.company_siret = siret.siret;
        if ((_e = siret.unite_legale) === null || _e === void 0 ? void 0 : _e.vatrateChecked) {
            this.localCustomer.company_vatrate = (_f = siret.unite_legale) === null || _f === void 0 ? void 0 : _f.vatrateNumber;
        }
        else if (this.$kwCustomers.sireneApiCheckVatrate !== false) {
            this.checkVatRateNumber((_g = siret.unite_legale) === null || _g === void 0 ? void 0 : _g.siren);
        }
    };
    CustomerForm.prototype.uppercaseFirstLetter = function (term) {
        if (!term || !this.teamConfigs.fetch_customer_sirene_api_styles) {
            return term;
        }
        return term.charAt(0).toUpperCase() + term.slice(1).toLowerCase();
    };
    CustomerForm.prototype.checkVatRateNumber = function (siren) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, external_axios_default().get(this.$kwCustomers.sireneApiUrl + '/vatrate', {
                            headers: {
                                Authorization: 'Bearer ' + this.$kwCustomers.sireneApitoken
                            },
                            withCredentials: true,
                            params: {
                                siren: siren
                            }
                        })
                            .then(function (response) {
                            _this.localCustomer.company_vatrate = response.data;
                        })
                            .catch(function () {
                            //
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerForm.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: true })
    ], CustomerForm.prototype, "withRedirection", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('searchCompanyResults')
    ], CustomerForm.prototype, "watchSearchCompanyResults", null);
    CustomerForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['countries'])), (0,external_vuex_.mapGetters)('user', ['team', 'teamUser', 'teamConfigs'])), (0,external_vuex_.mapState)('customers', ['customerTypes', 'origins', 'activities'])), (0,external_vuex_.mapGetters)('customers', ['defaultOrigin', 'defaultActivity'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadCountries', 'loadTeamUsers'])), (0,external_vuex_.mapActions)('customers', ['loadCustomerTypes', 'loadActivities', 'loadOrigins'])),
            components: {
                CustomerSelect: CustomerSelect_CustomerSelect,
                ContactSelect: ContactSelect_ContactSelect,
                CustomFieldsForm: custom_fields_vue_.CustomFieldsForm,
                CustomerSaleParams: CustomerSaleParams/* default */.A,
                CivilitySelect: interface_vue_.CivilitySelect, TagSelect: interface_vue_.TagSelect, Spinner: interface_vue_.Spinner, TeamUserSelect: interface_vue_.TeamUserSelect,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormInput: form_vue_.KFormInput, KFormAddress: form_vue_.KFormAddress, KFormPhone: form_vue_.KFormPhone, KFormCheckbox: form_vue_.KFormCheckbox, KFormDatepicker: form_vue_.KFormDatepicker,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BFormRow: external_bootstrap_vue_.BFormRow, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BListGroup: external_bootstrap_vue_.BListGroup, BListGroupItem: external_bootstrap_vue_.BListGroupItem, BButton: external_bootstrap_vue_.BButton,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            }
        })
    ], CustomerForm);
    return CustomerForm;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerFormvue_type_script_lang_ts_external = (CustomerForm);

;// ./src/components/CustomerForm/CustomerForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerForm_CustomerFormvue_type_script_lang_ts_external = (CustomerFormvue_type_script_lang_ts_external); 
;// ./src/components/CustomerForm/CustomerForm.vue





/* normalize component */
;
var CustomerForm_component = (0,componentNormalizer/* default */.A)(
  CustomerForm_CustomerFormvue_type_script_lang_ts_external,
  CustomerFormvue_type_template_id_3e3014e8_render,
  CustomerFormvue_type_template_id_3e3014e8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerForm_CustomerForm = (CustomerForm_component.exports);
// EXTERNAL MODULE: ./src/components/CustomerInformations/CustomerInformations.vue + 3 modules
var CustomerInformations = __webpack_require__(5278);
// EXTERNAL MODULE: ./src/components/CustomerItem/CustomerItem.vue + 9 modules
var CustomerItem = __webpack_require__(197);
// EXTERNAL MODULE: ./src/components/CustomerMerge/CustomerMerge.vue + 3 modules
var CustomerMerge = __webpack_require__(6867);
// EXTERNAL MODULE: ./src/components/CustomerReference/CustomerReference.vue + 3 modules
var CustomerReference = __webpack_require__(5950);
// EXTERNAL MODULE: ./src/components/CustomersList/CustomersList.vue + 3 modules
var CustomersList = __webpack_require__(45);
// EXTERNAL MODULE: ./src/components/CustomersParams/CustomersParams.vue + 3 modules
var CustomersParams = __webpack_require__(2324);
// EXTERNAL MODULE: ./src/components/CustomerSpeedItem/CustomerSpeedItem.vue + 3 modules
var CustomerSpeedItem = __webpack_require__(2930);
// EXTERNAL MODULE: ./src/components/CustomerTypes/CustomerTypes.vue + 3 modules
var CustomerTypes = __webpack_require__(4388);
// EXTERNAL MODULE: ./src/views/ContactsItemView/ContactsItemView.vue + 3 modules
var ContactsItemView = __webpack_require__(6175);
// EXTERNAL MODULE: ./src/views/CustomersItemView/CustomersItemView.vue + 3 modules
var CustomersItemView = __webpack_require__(2279);
// EXTERNAL MODULE: ./src/views/ContactActivitiesView.vue + 3 modules
var ContactActivitiesView = __webpack_require__(4658);
// EXTERNAL MODULE: ./src/views/ContactFunctionsView.vue + 3 modules
var ContactFunctionsView = __webpack_require__(3836);
// EXTERNAL MODULE: ./src/views/ContactOriginsView.vue + 3 modules
var ContactOriginsView = __webpack_require__(2913);
// EXTERNAL MODULE: ./src/views/ContactsListView.vue + 3 modules
var ContactsListView = __webpack_require__(3462);
// EXTERNAL MODULE: ./src/views/CustomersListView.vue + 3 modules
var CustomersListView = __webpack_require__(2541);
// EXTERNAL MODULE: ./src/views/CustomersParamsView.vue + 20 modules
var CustomersParamsView = __webpack_require__(6709);
// EXTERNAL MODULE: ./src/views/CustomerTypesView.vue + 3 modules
var CustomerTypesView = __webpack_require__(9068);
// EXTERNAL MODULE: ./src/views/ProspectsListView.vue + 3 modules
var ProspectsListView = __webpack_require__(877);
// EXTERNAL MODULE: ./src/views/ProvidersListView.vue + 3 modules
var ProvidersListView = __webpack_require__(792);
// EXTERNAL MODULE: ./src/views/SubcontractorsListView.vue + 3 modules
var SubcontractorsListView = __webpack_require__(3645);
;// ./src/lang/en.ts
var customersLang = {};
/* harmony default export */ var en = ({
    customers: customersLang
});

;// ./src/lang/fr.ts
var fr_customersLang = {
    menuTitle: 'Contacts',
    company: 'Entreprise',
    person: 'Personne',
    customer: {
        label: 'Client',
        menu: 'Clients',
        addTitle: 'Nouveau client',
        editTitle: 'Modification d\'un client',
        addLabel: 'Créer un client',
        editLabel: 'Modifier le client',
        listTitle: 'Liste des clients',
        listReference: 'N° client'
    },
    prospect: {
        label: 'Prospect',
        menu: 'Prospects',
        addTitle: 'Nouveau prospect',
        editTitle: 'Modification d\'un prospect',
        addLabel: 'Créer un prospect',
        editLabel: 'Modifier le prospect',
        listTitle: 'Liste des prospects',
        listReference: 'N° prospect'
    },
    provider: {
        label: 'Fournisseur',
        menu: 'Fournisseurs',
        addTitle: 'Nouveau fournisseur',
        editTitle: 'Modification d\'un fournisseur',
        addLabel: 'Créer un fournisseur',
        editLabel: 'Modifier le fournisseur',
        listTitle: 'Liste des fournisseurs',
        listReference: 'N° fournisseur'
    },
    subcontractor: {
        label: 'Sous-traitant',
        menu: 'Sous-traitants',
        addTitle: 'Nouveau sous-traitant',
        editTitle: 'Modification d\'un sous-traitant',
        addLabel: 'Créer un sous-traitant',
        editLabel: 'Modifier le sous-traitant',
        listTitle: 'Liste des sous-traitants',
        listReference: 'N° sous-traitant'
    },
    list: {
        name: 'Nom',
        companyName: 'Nom entreprise',
        activity: 'Activité',
        origin: 'Origine',
        addressRoad1: 'Adresse rue 1',
        addressRoad2: 'Adresse rue 2',
        addressRoad3: 'Adresse rue 3',
        postalCode: 'Code postal',
        city: 'Ville',
        country: 'Pays',
        phone: 'Téléphone',
        mobile: 'Mobile',
        fax: 'Fax',
        email: 'Email',
        website: 'Site internet',
        commercial: 'Commercial',
        tags: 'Mots-clés',
        siret: 'N°SIRET',
        vatrate: 'N°TVA intracommunautaire',
        tiers: 'Tiers',
        firstname: 'Prénom',
        lastname: 'Nom de famille',
        civility: 'Civilité',
        function: 'Fonction',
        comments: 'Commentaires',
        birthDate: 'Date de naissance',
        customerType: 'Type de tiers',
        customerAccount: 'Compte client',
        providerAccount: 'Compte fournisseur',
        salesStatistics: 'Chiffre d\'affaires',
        salesStatisticsPreviousYear: 'Chiffre d\'affaires année en cours',
        salesStatisticsCurrentYear: 'Chiffre d\'affaires année N-1',
        toPaid: 'Paiement en attente',
        waitingQuotations: 'Devis en attente'
    },
    filters: {
        companyName: 'Entreprise',
        lastname: 'Nom',
        phone: 'Téléphone fixe',
        mobile: 'Téléphone portable',
        allPhone: 'Téléphone fixe ou portable',
        allTags: 'Tous les mots-clés',
        archived: 'Archiver'
    },
    contact: {
        label: 'Contact',
        menu: 'Contacts',
        tabTitle: 'Contacts',
        addTitle: 'Nouveau contact',
        editTitle: 'Modification d\'un contact',
        addLabel: 'Créer un contact',
        editLabel: 'Modifier le contact',
        listTitle: 'Liste des contacts',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce contact ?',
        merge: 'Fusionner avec un autre contact',
        mergeTitle: 'Fusion du contact avec un autre contact',
        mergeBtn: 'Fusionner',
        mergeDestination: 'Contact de destination :',
        mergeExplain1: 'Tous ses éléments liés à ce contact seront rattachés au nouveau contact et ce contact sera supprimé.',
        mergeExplain2: 'Attention, cette action est irreversible.',
    },
    documentTabTitle: 'Documents',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce tiers ?',
    form: {
        type: 'Type de tiers :',
        companyName: 'Nom de l\'entreprise',
        civility: 'Civilité',
        firstname: 'Prénom',
        lastname: 'Nom',
        address: 'Adresse',
        tiers: 'Tiers :',
        function: 'Fonction :',
        comments: 'Commentaires :',
        invoiceAddress: 'Adresse de facturation',
        deliveryAddress: 'Adresse de livraison',
        useInvoiceAddress: 'Utiliser l\'adresse de facturation',
        coordinates: 'Coordonnées',
        phone: 'Téléphone :',
        mobile: 'Portable :',
        fax: 'Fax :',
        email: 'Email :',
        website: 'Site internet :',
        tags: 'Mots-clés :',
        activity: 'Activité',
        origin: 'Origine :',
        siret: 'Siret :',
        vatrate: 'N° TVA-intracommunautaire :',
        commercial: 'Commercial :',
        newsletter: 'Inscription à la newsletter :',
        newsletterExplain: 'Constituez votre base de données pour l\'envoi de newsletter à vos prospects et clients.',
        birthDate: 'Date de naissance',
        customerAccount: 'Compte client',
        providerAccount: 'Compte fournisseur'
    },
    item: {
        elements: 'Éléments',
        subscription: 'Abonnement',
        opportunities: 'Opportunités',
        sales: 'Ventes',
        contracts: 'Contrats',
        sepa: 'Mandats SEPA',
        quotations: 'Devis',
        commands: 'Bons de commande',
        deliveries: 'Bons de livraison',
        proformas: 'Factures proforma',
        depositInvoices: 'Factures d\'acompte',
        invoices: 'Factures',
        credits: 'Avoirs',
        payments: 'Encaissements',
        constructions: 'Chantiers',
        contactItem: 'Fiche contact',
        prospectItem: 'Fiche prospect',
        customerItem: 'Fiche client',
        providerItem: 'Fiche fournisseur',
        subcontractorItem: 'Fiche sous-traitant',
        noCoordinates: 'Aucune coordonnée',
        unarchive: 'Désarchiver',
        archive: 'Archiver',
        unarchiveConfirm: 'Êtes-vous sûr de vouloir désarchiver ce tiers ?',
        archiveConfirm: 'Êtes-vous sûr de vouloir archiver ce tiers ?',
        isArchived: 'Ce tiers est archivé',
        customerReference: 'Référence client',
        prospectReference: 'Référence prospect',
        providerReference: 'Référence fournisseur',
        subcontractorReference: 'Référence sous-traitant',
        addContact: 'Nouveau contact',
        salesPreferences: 'Préférences vente',
        chargesPreferences: 'Préférences charges',
        downloadPdf: 'Fiche PDF',
        catalog: 'Catalogue',
        purchases: 'Achats',
        catalogCommands: 'Commandes',
        charges: 'Charges',
        merge: 'Fusionner avec un autre tiers',
        mergeTitle: 'Fusion du tiers avec un autre tiers',
        mergeBtn: 'Fusionner',
        mergeDestination: 'Tiers de destination :',
        mergeExplain1: 'Tous ses éléments liés à ce tiers seront rattachés au nouveau tiers et ce tiers sera supprimé.',
        mergeExplain2: 'Attention, cette action est irreversible.',
        birthDate: 'Date de naissance',
        customerAccount: 'Compte client',
        providerAccount: 'Compte fournisseur',
        createdAt: 'Date de création',
        updatedAt: 'Date de modification',
        transformedAt: 'Date de transformation',
        salesStatistics: 'Chiffre d\'affaires',
        salesStatisticsPreviousYear: 'Chiffre d\'affaires année en cours',
        salesStatisticsCurrentYear: 'Chiffre d\'affaires année N-1',
        toPaid: 'Paiement en attente'
    },
    params: {
        menu: 'Paramètres',
        pageTitle: 'Configuration des tiers',
        creationTitle: 'Création des tiers :',
        cannotCreateDouble: 'Empêcher la création de doublon',
        cannotCreateDoubleExplain: 'Impose de renseigner le prénom et le nom pour les particuliers',
        canCreateDouble: 'Permettre la création de doublon',
        canCreateDoubleExplain: 'Seul le nom sera obligatoire lors de la création de particuliers',
        referenceTitle: 'Numérotation des tiers',
        referencePrefix: 'Préfixe',
        referenceNextNumber: 'Prochain numéro',
        referenceLength: 'Nombre de chiffre',
        referenceExplain: 'Vous pouvez utiliser le jour, le mois ou l\'année en cours dans les préfixes des numéros. Pour cela, insérez l\'une des variables ci-dessous :',
        referenceYear4: 'l\'année sur 4 chiffres',
        referenceYear2: 'l\'année sur 2 chiffres',
        referenceMonth: 'le mois',
        referenceDay: 'le jour',
        accountTitle: 'Comptes comptable',
        accountExplain: 'Le numéro de compte client n\'est utile que pour les exports comptables. Il permet d\'identifier le client dans un logiciel comptable. Nous vous invitons à vous rapprocher de votre expert comptable pour connaître la nomenclature qu\'il utilise. Par défaut, un numéro de compte du type 401000001 pour les fournisseurs et 411000001 pour les clients est automatiquement généré lors de la création d\'un tiers. Le numéro de compte s\'incrémente automatiquement. Vous avez la possibilité de personnaliser cette numérotation en utilisant un préfixe + une partie du nom du tiers.',
        accountPrefix: 'Préfixe',
        accountLength: 'Nombre de lettre à utiliser',
        accountLengthDefault: 'Longueur des comptes par défaut',
        accountCustom: 'N° personnalisé',
        newsletterTitle: 'Inscription automatique à votre newsletter :',
        newsletterExplain: 'Constituez-vous une base de données pour l\'envoi de vos newsletters.'
    },
    civility: {
        menu: 'Civilités',
        pageTitle: 'Gestion des civilités',
        label: 'Nom de la civilité',
        label2: 'Nom court',
        new: 'Création d\'une civilité',
        edit: 'Modification d\'une civilité',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette civilité ?'
    },
    contactActivity: {
        menu: 'Activités des tiers',
        pageTitle: 'Gestion des activités des tiers',
        label: 'Nom de l\'activité',
        new: 'Création d\'une activité',
        edit: 'Modification d\'une activité',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette activité ?'
    },
    contactFunction: {
        menu: 'Fonctions des contacts',
        pageTitle: 'Gestion des fonctions des contacts',
        label: 'Nom de la fonction',
        new: 'Création de la fonction',
        edit: 'Modification de la fonction',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette fonction ?'
    },
    contactOrigin: {
        menu: 'Origines des tiers',
        pageTitle: 'Gestion des origines des tiers',
        label: 'Nom de l\' origine',
        new: 'Création de l\' origine',
        edit: 'Modification de l\' origine',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette origine ?'
    },
    customerType: {
        menu: 'Type de tiers',
        pageTitle: 'Gestion des types de tiers',
        label: 'Nom du type de tiers',
        isCompanylabel: 'Possède un nom d\'entreprise',
        isPersonlabel: 'Possède un prénom et un nom',
        new: 'Création d\'un type de tiers',
        edit: 'Modification d\'un type de tiers',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce type de tiers ?'
    },
    address: {
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette adresse ?',
        newTitle: 'Création d\'une adresse',
        editTitle: 'Modification d\'une adresse',
        name: 'Nom de l\'adresse',
        useInvoice: 'Utiliser comme adresse de facturation par défaut',
        useDelivery: 'Utiliser comme adresse de livraison par défaut',
        address: 'Adresse :',
        list: 'Liste des adresses',
        addAddress: 'Créer une adresse',
        forInvoice: 'Adresse de facturation par défaut',
        forDelivery: 'Adresse de livraison par défaut',
        manage: 'Gérer les adresses',
        addLabel: 'Ajouter une adresse',
        editLabel: 'Modifier l\'adresse'
    },
    references: {
        customer: {
            delete: 'Supprimer la référence client',
            add: 'Attribuer une référence client',
            transform: 'Transformer en client',
            transformConfirm: 'Êtes-vous sûr de vouloir transformer le prospect en client ?'
        },
        prospect: {
            delete: 'Supprimer la référence prospect',
            add: 'Attribuer une référence prospect',
            transform: 'Transformer en prospect',
            transformConfirm: 'Êtes-vous sûr de vouloir transformer le client en prospect ?',
        },
        provider: {
            delete: 'Supprimer la référence fournisseur',
            deleteConfirm: 'Êtes-vous sûr de vouloir supprimer la référence fournisseur ?',
            add: 'Attribuer une référence fournisseur',
            addConfirm: 'Êtes-vous sûr de vouloir attribuer une référence fournisseur ?'
        },
        subcontractor: {
            delete: 'Supprimer la référence sous-traitant',
            deleteConfirm: 'Êtes-vous sûr de vouloir supprimer la référence sous-traitant ?',
            add: 'Attribuer une référence sous-traitant',
            addConfirm: 'Êtes-vous sûr de vouloir attribuer une référence sous-traitant ?'
        }
    },
    salesPreferences: {
        title: 'Paramètres par défaut des documents de vente',
        defaultTitle: 'Valeurs par défaut',
        displayOptions: 'Options de saisie et d\'affichage',
        globalDiscount: 'Remise générale',
        vatRate: 'Taux de TVA',
        currency: 'Devise',
        paymentTerm: 'Conditions de paiement',
        saleTerms: 'Conditions générales de vente',
        paymentMethods: 'Moyens de paiement par défaut',
        guaranteeHoldback: 'Retenue de garantie',
        guaranteeHoldbackOn: 'sur',
        advanceRate: 'Taux d\'acompte',
        escompteRate: 'Taux d\'escompe',
        penaltyRate: 'Taux de pénalité',
        globalVatRate: 'Sélection du taux de TVA',
        amountsType: 'Mode de saisie des montants',
        pdfAmounts: 'Affichage des montants dans le contenu du document',
        pdfModel: 'Modèle PDF',
        commissionTitle: 'Commissions sur les ventes',
        commissionPourcent: 'Pourcentage de commission',
        commissionPourcentExplain: 'Laisser vide pour utiliser la commission par défaut',
        commissionValidity: 'Activer les commissions jusqu\'au',
        commissionValidityExplain: 'N\'est utilisé que lorsque la durée est activée sur la commission'
    },
    chargesPreferences: {
        title: 'Paramètres par défaut des charges',
        vatRate: 'Taux de TVA',
        currency: 'Devise',
        chargeCategory: 'Catégorie de charge',
        paymentDelay: 'Calcul de la date limite de paiement',
        paymentTerm: 'Conditions de paiement',
        paymentDelayUseTerm: 'Utiliser la condition de paiement pour calculer la date de paiement',
        paymentDelayPart1: 'Paiement à',
        paymentDelayPart2: 'jours',
        fecExports: 'Exports comptable',
        fecIncludeCharge: 'Exclure ce fournisseur dans les exports des charges',
        fecIncludeBank: 'Exclure ce fournisseur dans les exports de la banque'
    }
};
/* harmony default export */ var fr = ({
    customers: fr_customersLang
});

;// ./src/lang/index.ts


var Lang = {
    en: en,
    fr: fr
};
/* harmony default export */ var lang = (Lang);

;// ./src/router/routes.ts
var routes_ProspectsListView = function () { return __webpack_require__.e(/* import() | customers */ 154).then(__webpack_require__.bind(__webpack_require__, 877)); };
var routes_CustomersListView = function () { return __webpack_require__.e(/* import() | customers */ 154).then(__webpack_require__.bind(__webpack_require__, 2541)); };
var routes_ProvidersListView = function () { return __webpack_require__.e(/* import() | customers */ 154).then(__webpack_require__.bind(__webpack_require__, 792)); };
var routes_SubcontractorsListView = function () { return __webpack_require__.e(/* import() | customers */ 154).then(__webpack_require__.bind(__webpack_require__, 3645)); };
var routes_CustomersItemView = function () { return __webpack_require__.e(/* import() | customers */ 154).then(__webpack_require__.bind(__webpack_require__, 2279)); };
var routes_ContactsListView = function () { return __webpack_require__.e(/* import() | customers */ 154).then(__webpack_require__.bind(__webpack_require__, 3462)); };
var routes_ContactsItemView = function () { return __webpack_require__.e(/* import() | customers */ 154).then(__webpack_require__.bind(__webpack_require__, 6175)); };
var CustomerStatisticsView = function () { return __webpack_require__.e(/* import() | customers */ 154).then(__webpack_require__.bind(__webpack_require__, 7095)); };
var routes = function (i18n) { return ([
    {
        path: '/contacts/prospect',
        name: 'contacts-prospects-list',
        component: routes_ProspectsListView,
        meta: {
            title: i18n.t('customers.prospect.listTitle'),
            appModule: 'customers-prospects',
            userPermission: ['prospect', 1],
            buttons: [
                {
                    label: i18n.t('customers.prospect.addLabel'),
                    userPermission: ['prospect', 2],
                    modal: {
                        key: 'prospect-form',
                        attributes: {
                            withRedirection: true
                        }
                    }
                }
            ]
        }
    },
    {
        path: '/contacts/customer',
        name: 'contacts-customers-list',
        component: routes_CustomersListView,
        meta: {
            title: i18n.t('customers.customer.listTitle'),
            userPermission: ['customer', 1],
            buttons: [
                {
                    label: i18n.t('customers.customer.addLabel'),
                    userPermission: ['customer', 2],
                    modal: {
                        key: 'customer-form',
                        attributes: {
                            withRedirection: true
                        }
                    }
                }
            ]
        }
    },
    {
        path: '/contacts/provider',
        name: 'contacts-providers-list',
        component: routes_ProvidersListView,
        meta: {
            title: i18n.t('customers.provider.listTitle'),
            userPermission: ['provider', 1],
            buttons: [
                {
                    label: i18n.t('customers.provider.addLabel'),
                    userPermission: ['provider', 2],
                    modal: {
                        key: 'provider-form',
                        attributes: {
                            withRedirection: true
                        }
                    }
                }
            ]
        }
    },
    {
        path: '/contacts/subcontractor',
        name: 'contacts-subcontractors-list',
        component: routes_SubcontractorsListView,
        meta: {
            title: i18n.t('customers.subcontractor.listTitle'),
            userPermission: ['subcontractor', 1],
            appModule: 'customers-subcontractors',
            buttons: [
                {
                    label: i18n.t('customers.subcontractor.addLabel'),
                    userPermission: ['subcontractor', 2],
                    modal: {
                        key: 'subcontractor-form',
                        attributes: {
                            withRedirection: true
                        }
                    }
                }
            ]
        }
    },
    {
        path: '/contacts/:type(customer|prospect|provider|subcontractor)/:id',
        name: 'contacts-customer-item',
        component: routes_CustomersItemView,
        meta: {
            pageHeader: false,
            title: function (customer) { return customer.name; },
            appClass: { 'contact-page-item': true }
        }
    },
    {
        path: '/contacts/contacts',
        name: 'contacts-contacts-list',
        component: routes_ContactsListView,
        meta: {
            title: i18n.t('customers.contact.listTitle'),
            buttons: [
                {
                    label: i18n.t('customers.contact.addLabel'),
                    userPermission: ['contact', 1],
                    modal: {
                        key: 'contact-form',
                        attributes: {
                            withRedirection: true
                        }
                    }
                }
            ]
        }
    },
    {
        path: '/contacts/contacts/:id',
        name: 'contacts-contact-item',
        component: routes_ContactsItemView,
        meta: {
            pageHeader: false,
            appClass: { 'contact-page-item': true }
        }
    },
    {
        path: '/contacts/statistics',
        name: 'contacts-statistics',
        component: CustomerStatisticsView,
        meta: {
            title: 'Chiffre d\'affaires par client'
        }
    }
]); };
/* harmony default export */ var router_routes = (routes);

;// ./src/router/configRoutes.ts
var configRoutes_CustomersParamsView = function () { return __webpack_require__.e(/* import() | customers */ 154).then(__webpack_require__.bind(__webpack_require__, 6709)); };
var configRoutes_CustomerTypesView = function () { return __webpack_require__.e(/* import() | customers */ 154).then(__webpack_require__.bind(__webpack_require__, 9068)); };
var configRoutes_ContactActivitiesView = function () { return __webpack_require__.e(/* import() | customers */ 154).then(__webpack_require__.bind(__webpack_require__, 4658)); };
var configRoutes_ContactFunctionsView = function () { return __webpack_require__.e(/* import() | customers */ 154).then(__webpack_require__.bind(__webpack_require__, 3836)); };
var configRoutes_ContactOriginsView = function () { return __webpack_require__.e(/* import() | customers */ 154).then(__webpack_require__.bind(__webpack_require__, 2913)); };
var configRoutes_routes = function (i18n) { return ([
    {
        name: 'tiers-params',
        path: 'tiers/params',
        component: configRoutes_CustomersParamsView,
        meta: {
            title: i18n.t('customers.params.pageTitle')
        }
    },
    {
        name: 'tiers-types',
        path: 'tiers/types',
        component: configRoutes_CustomerTypesView,
        meta: {
            title: i18n.t('customers.customerType.pageTitle')
        }
    },
    {
        name: 'tiers-contact-activities',
        path: 'tiers/contact-activities',
        component: configRoutes_ContactActivitiesView,
        meta: {
            title: i18n.t('customers.contactActivity.pageTitle')
        }
    },
    {
        name: 'tiers-contact-functions',
        path: 'tiers/contact-functions',
        component: configRoutes_ContactFunctionsView,
        meta: {
            title: i18n.t('customers.contactFunction.pageTitle')
        }
    },
    {
        name: 'tiers-contact-origins',
        path: 'tiers/contact-origins',
        component: configRoutes_ContactOriginsView,
        meta: {
            title: i18n.t('customers.contactOrigin.pageTitle')
        }
    },
]); };
/* harmony default export */ var configRoutes = (configRoutes_routes);

;// ./src/dynamicModals.ts


var modals = [
    {
        key: 'customer-form',
        title: function (customer) { return customer && customer.id ? 'customers.customer.editTitle' : 'customers.customer.addTitle'; },
        component: CustomerForm_CustomerForm,
        size: 'xl',
        attributes: {
            type: 'customer'
        }
    },
    {
        key: 'provider-form',
        title: function (customer) { return customer && customer.id ? 'customers.provider.editTitle' : 'customers.provider.addTitle'; },
        component: CustomerForm_CustomerForm,
        size: 'xl',
        attributes: {
            type: 'provider'
        }
    },
    {
        key: 'contact-form',
        title: function (contact) { return contact && contact.id ? 'customers.contact.editTitle' : 'customers.contact.addTitle'; },
        component: ContactForm_ContactForm,
        size: 'xl'
    },
    {
        key: 'prospect-form',
        title: function (customer) { return customer && customer.id ? 'customers.prospect.editTitle' : 'customers.prospect.addTitle'; },
        component: CustomerForm_CustomerForm,
        size: 'xl',
        attributes: {
            type: 'prospect'
        }
    },
    {
        key: 'subcontractor-form',
        title: function (customer) { return customer && customer.id ? 'customers.subcontractor.editTitle' : 'customers.subcontractor.addTitle'; },
        component: CustomerForm_CustomerForm,
        size: 'xl',
        attributes: {
            type: 'subcontractor'
        }
    }
];
/* harmony default export */ var dynamicModals = (modals);

// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(9754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./node_modules/vuex-module-decorators/dist/esm/index.js
/**
 * Takes the properties on object from parameter source and adds them to the object
 * parameter target
 * @param {object} target  Object to have properties copied onto from y
 * @param {object} source  Object with properties to be copied to x
 */
function addPropertiesToObject(target, source) {
    var _loop_1 = function (k) {
        Object.defineProperty(target, k, {
            get: function () { return source[k]; }
        });
    };
    for (var _i = 0, _a = Object.keys(source || {}); _i < _a.length; _i++) {
        var k = _a[_i];
        _loop_1(k);
    }
}
/**
 * Returns a namespaced name of the module to be used as a store getter
 * @param module
 */
function getModuleName(module) {
    if (!module._vmdModuleName) {
        throw new Error("ERR_GET_MODULE_NAME : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    return "vuexModuleDecorators/".concat(module._vmdModuleName);
}

var VuexModule = /** @class */ (function () {
    function VuexModule(module) {
        this.actions = module.actions;
        this.mutations = module.mutations;
        this.state = module.state;
        this.getters = module.getters;
        this.namespaced = module.namespaced;
        this.modules = module.modules;
    }
    return VuexModule;
}());
function getModule(moduleClass, store) {
    var moduleName = getModuleName(moduleClass);
    if (store && store.getters[moduleName]) {
        return store.getters[moduleName];
    }
    else if (moduleClass._statics) {
        return moduleClass._statics;
    }
    var genStatic = moduleClass._genStatic;
    if (!genStatic) {
        throw new Error("ERR_GET_MODULE_NO_STATICS : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    var storeModule = genStatic(store);
    if (store) {
        store.getters[moduleName] = storeModule;
    }
    else {
        moduleClass._statics = storeModule;
    }
    return storeModule;
}

var reservedKeys = ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit'];
function stateFactory(module) {
    var state = new module.prototype.constructor({});
    var s = {};
    Object.keys(state).forEach(function (key) {
        if (reservedKeys.indexOf(key) !== -1) {
            if (typeof state[key] !== 'undefined') {
                throw new Error("ERR_RESERVED_STATE_KEY_USED: You cannot use the following\n        ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit']\n        as fields in your module. These are reserved as they have special purpose in Vuex");
            }
            return;
        }
        if (state.hasOwnProperty(key)) {
            if (typeof state[key] !== 'function') {
                s[key] = state[key];
            }
        }
    });
    return s;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function staticStateGenerator(module, modOpt, statics) {
    var state = modOpt.stateFactory ? module.state() : module.state;
    Object.keys(state).forEach(function (key) {
        if (state.hasOwnProperty(key)) {
            // If not undefined or function means it is a state value
            if (['undefined', 'function'].indexOf(typeof state[key]) === -1) {
                Object.defineProperty(statics, key, {
                    get: function () {
                        var path = modOpt.name.split('/');
                        var data = statics.store.state;
                        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
                            var segment = path_1[_i];
                            data = data[segment];
                        }
                        return data[key];
                    }
                });
            }
        }
    });
}
function staticGetterGenerator(module, modOpt, statics) {
    Object.keys(module.getters).forEach(function (key) {
        if (module.namespaced) {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters["".concat(modOpt.name, "/").concat(key)];
                }
            });
        }
        else {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters[key];
                }
            });
        }
    });
}
function staticMutationGenerator(module, modOpt, statics) {
    Object.keys(module.mutations).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false));
            };
        }
        else {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray([key], args, false));
            };
        }
    });
}
function staticActionGenerators(module, modOpt, statics) {
    Object.keys(module.actions).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false))];
                    });
                });
            };
        }
        else {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray([key], args, false))];
                    });
                });
            };
        }
    });
}

function registerDynamicModule(module, modOpt) {
    if (!modOpt.name) {
        throw new Error('Name of module not provided in decorator options');
    }
    if (!modOpt.store) {
        throw new Error('Store not provided in decorator options when using dynamic option');
    }
    modOpt.store.registerModule(modOpt.name, // TODO: Handle nested modules too in future
    module, { preserveState: modOpt.preserveState || false });
}
function addGettersToModule(targetModule, srcModule) {
    Object.getOwnPropertyNames(srcModule.prototype).forEach(function (funcName) {
        var descriptor = Object.getOwnPropertyDescriptor(srcModule.prototype, funcName);
        if (descriptor.get && targetModule.getters) {
            targetModule.getters[funcName] = function (state, getters, rootState, rootGetters) {
                var thisObj = { context: { state: state, getters: getters, rootState: rootState, rootGetters: rootGetters } };
                addPropertiesToObject(thisObj, state);
                addPropertiesToObject(thisObj, getters);
                var got = descriptor.get.call(thisObj);
                return got;
            };
        }
    });
}
function moduleDecoratorFactory(moduleOptions) {
    return function (constructor) {
        var module = constructor;
        var stateFactory$1 = function () { return stateFactory(module); };
        if (!module.state) {
            module.state = moduleOptions && moduleOptions.stateFactory ? stateFactory$1 : stateFactory$1();
        }
        if (!module.getters) {
            module.getters = {};
        }
        if (!module.namespaced) {
            module.namespaced = moduleOptions && moduleOptions.namespaced;
        }
        var parentModule = Object.getPrototypeOf(module);
        while (parentModule.name !== 'VuexModule' && parentModule.name !== '') {
            addGettersToModule(module, parentModule);
            parentModule = Object.getPrototypeOf(parentModule);
        }
        addGettersToModule(module, module);
        var modOpt = moduleOptions;
        if (modOpt.name) {
            Object.defineProperty(constructor, '_genStatic', {
                value: function (store) {
                    var statics = { store: store || modOpt.store };
                    if (!statics.store) {
                        throw new Error("ERR_STORE_NOT_PROVIDED: To use getModule(), either the module\n            should be decorated with store in decorator, i.e. @Module({store: store}) or\n            store should be passed when calling getModule(), i.e. getModule(MyModule, this.$store)");
                    }
                    // ===========  For statics ==============
                    // ------ state -------
                    staticStateGenerator(module, modOpt, statics);
                    // ------- getters -------
                    if (module.getters) {
                        staticGetterGenerator(module, modOpt, statics);
                    }
                    // -------- mutations --------
                    if (module.mutations) {
                        staticMutationGenerator(module, modOpt, statics);
                    }
                    // -------- actions ---------
                    if (module.actions) {
                        staticActionGenerators(module, modOpt, statics);
                    }
                    return statics;
                }
            });
            Object.defineProperty(constructor, '_vmdModuleName', {
                value: modOpt.name
            });
        }
        if (modOpt.dynamic) {
            registerDynamicModule(module, modOpt);
        }
        return constructor;
    };
}
function Module(modOrOpt) {
    if (typeof modOrOpt === 'function') {
        /*
         * @Module decorator called without options (directly on the class definition)
         */
        moduleDecoratorFactory({})(modOrOpt);
    }
    else {
        /*
         * @Module({...}) decorator called with options
         */
        return moduleDecoratorFactory(modOrOpt);
    }
}

var esm_config = {};

function actionDecoratorFactory(params) {
    var _a = params || {}, _b = _a.commit, commit = _b === void 0 ? undefined : _b, _c = _a.rawError, rawError = _c === void 0 ? !!esm_config.rawError : _c, _d = _a.root, root = _d === void 0 ? false : _d;
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var actionFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var actionPayload, moduleName, moduleAccessor, thisObj, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, , 6]);
                            actionPayload = null;
                            if (!module._genStatic) return [3 /*break*/, 2];
                            moduleName = getModuleName(module);
                            moduleAccessor = context.rootGetters[moduleName]
                                ? context.rootGetters[moduleName]
                                : getModule(module);
                            moduleAccessor.context = context;
                            return [4 /*yield*/, actionFunction.call(moduleAccessor, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, actionFunction.call(thisObj, payload)];
                        case 3:
                            actionPayload = _a.sent();
                            _a.label = 4;
                        case 4:
                            if (commit) {
                                context.commit(commit, actionPayload);
                            }
                            return [2 /*return*/, actionPayload];
                        case 5:
                            e_1 = _a.sent();
                            throw rawError
                                ? e_1
                                : new Error('ERR_ACTION_ACCESS_UNDEFINED: Are you trying to access ' +
                                    'this.someMutation() or this.someGetter inside an @Action? \n' +
                                    'That works only in dynamic modules. \n' +
                                    'If not dynamic use this.context.commit("mutationName", payload) ' +
                                    'and this.context.getters["getterName"]' +
                                    '\n' +
                                    new Error("Could not perform action ".concat(key.toString())).stack +
                                    '\n' +
                                    e_1.stack);
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        module.actions[key] = root ? { root: root, handler: action } : action;
    };
}
/**
 * The @Action decorator turns an async function into an Vuex action
 *
 * @param targetOrParams the module class
 * @param key name of the action
 * @param descriptor the action function descriptor
 * @constructor
 */
function Action(targetOrParams, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `targetOrParams` is params.
         * i.e. when used as -
         * <pre>
            @Action({commit: 'incrCount'})
            async getCountDelta() {
              return 5
            }
         * </pre>
         */
        return actionDecoratorFactory(targetOrParams);
    }
    else {
        /*
         * This is the case when @Action is called on action function
         * without any params
         * <pre>
         *   @Action
         *   async doSomething() {
         *    ...
         *   }
         * </pre>
         */
        actionDecoratorFactory()(targetOrParams, key, descriptor);
    }
}

function Mutation(target, key, descriptor) {
    var module = target.constructor;
    if (!module.hasOwnProperty('mutations')) {
        module.mutations = Object.assign({}, module.mutations);
    }
    var mutationFunction = descriptor.value;
    var mutation = function (state, payload) {
        mutationFunction.call(state, payload);
    };
    module.mutations[key] = mutation;
}

function mutationActionDecoratorFactory(params) {
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('mutations')) {
            module.mutations = Object.assign({}, module.mutations);
        }
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var mutactFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var thisObj, actionPayload, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, mutactFunction.call(thisObj, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            if (actionPayload === undefined)
                                return [2 /*return*/];
                            context.commit(key, actionPayload);
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            if (params.rawError) {
                                throw e_1;
                            }
                            else {
                                console.error('Could not perform action ' + key.toString());
                                console.error(e_1);
                                return [2 /*return*/, Promise.reject(e_1)];
                            }
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        var mutation = function (state, payload) {
            if (!params.mutate) {
                params.mutate = Object.keys(payload);
            }
            for (var _i = 0, _a = params.mutate; _i < _a.length; _i++) {
                var stateItem = _a[_i];
                if (state.hasOwnProperty(stateItem) && payload.hasOwnProperty(stateItem)) {
                    state[stateItem] = payload[stateItem];
                }
                else {
                    throw new Error("ERR_MUTATE_PARAMS_NOT_IN_PAYLOAD\n          In @MutationAction, mutate: ['a', 'b', ...] array keys must\n          match with return type = {a: {}, b: {}, ...} and must\n          also be in state.");
                }
            }
        };
        module.actions[key] = params.root ? { root: true, handler: action } : action;
        module.mutations[key] = mutation;
    };
}
/**
 * The @MutationAction decorator turns this into an action that further calls a mutation
 * Both the action and the mutation are generated for you
 *
 * @param paramsOrTarget the params or the target class
 * @param key the name of the function
 * @param descriptor the function body
 * @constructor
 */
function MutationAction(paramsOrTarget, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `paramsOrTarget` is params.
         * i.e. when used as -
         * <pre>
            @MutationAction({mutate: ['incrCount']})
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        return mutationActionDecoratorFactory(paramsOrTarget);
    }
    else {
        /*
         * This is the case when `paramsOrTarget` is target.
         * i.e. when used as -
         * <pre>
            @MutationAction
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        mutationActionDecoratorFactory({})(paramsOrTarget, key, descriptor);
    }
}


//# sourceMappingURL=index.js.map

;// ./src/store/modules/CustomersStore.ts



var CustomersStore = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomersStore, _super);
    function CustomersStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.customerTypesLoaded = false;
        _this.customerTypes = [];
        _this.contactFunctionsLoaded = false;
        _this.contactFunctions = [];
        _this.originsLoaded = false;
        _this.origins = [];
        _this.activitiesLoaded = false;
        _this.activities = [];
        return _this;
    }
    // CLEAR STORE STATE
    CustomersStore.prototype.clearStore = function () {
        var _this = this;
        var elements = ['CustomerTypes', 'ContactFunctions', 'Origins', 'Activities'];
        elements.forEach(function (key) {
            _this.context.commit('set' + key, []);
            _this.context.commit('set' + key + 'Loaded', false);
        });
    };
    // Sort a list alphabetically
    CustomersStore.prototype.orderList = function (param) {
        var key = param.key;
        param.list.sort(function (a, b) {
            var aKey = a[key].toLowerCase();
            var bKey = b[key].toLowerCase();
            if (aKey < bKey)
                return -1;
            else if (aKey > bKey)
                return 1;
            else
                return 0;
        });
    };
    Object.defineProperty(CustomersStore.prototype, "defaultCustomerType", {
        // Return the default customer type to use
        get: function () {
            return this.customerTypes.find(function (type) { return type.use_default; });
        },
        enumerable: false,
        configurable: true
    });
    // Change the loaded state
    CustomersStore.prototype.setCustomerTypesLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.customerTypesLoaded = state;
    };
    // Set the customer types
    CustomersStore.prototype.setCustomerTypes = function (customerTypes) {
        this.customerTypes = customerTypes;
    };
    // Add or update a customer type
    CustomersStore.prototype.updateCustomerType = function (customerType) {
        if (!this.customerTypesLoaded) {
            return;
        }
        var index = this.customerTypes.findIndex(function (type) { return type.id === customerType.id; });
        if (index >= 0) {
            external_vue_default().set(this.customerTypes, index, customerType);
        }
        else {
            this.customerTypes.push(customerType);
        }
    };
    // Remove a customer type
    CustomersStore.prototype.removeCustomerType = function (customerType) {
        if (!this.customerTypesLoaded) {
            return;
        }
        var index = this.customerTypes.findIndex(function (type) { return type.id === customerType.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.customerTypes, index);
        }
    };
    // Load the customer types for server
    CustomersStore.prototype.loadCustomerTypes = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.customerTypesLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCustomers.axios.get('/customer/type?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setCustomerTypes', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setCustomerTypesLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a customer type
    CustomersStore.prototype.setCustomerType = function (customerType) {
        this.context.commit('updateCustomerType', customerType);
        if (this.customerTypesLoaded) {
            this.context.commit('orderList', { list: this.customerTypes, key: 'label' });
        }
    };
    // Delete a customer type
    CustomersStore.prototype.deleteCustomerType = function (customerType) {
        this.context.commit('removeCustomerType', customerType);
    };
    Object.defineProperty(CustomersStore.prototype, "defaultContactFunction", {
        // Return the default contact function to use
        get: function () {
            return this.contactFunctions.find(function (contactFunction) { return contactFunction.use_default; });
        },
        enumerable: false,
        configurable: true
    });
    // Change the loaded state
    CustomersStore.prototype.setContactFunctionsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.contactFunctionsLoaded = state;
    };
    // Set the contact functions
    CustomersStore.prototype.setContactFunctions = function (contactFunctions) {
        this.contactFunctions = contactFunctions;
    };
    // Add or update a contact function
    CustomersStore.prototype.updateContactFunction = function (contactFunction) {
        if (!this.contactFunctionsLoaded) {
            return;
        }
        var index = this.contactFunctions.findIndex(function (type) { return type.id === contactFunction.id; });
        if (index >= 0) {
            external_vue_default().set(this.contactFunctions, index, contactFunction);
        }
        else {
            this.contactFunctions.push(contactFunction);
        }
    };
    // Remove a contact function
    CustomersStore.prototype.removeContactFunction = function (contactFunction) {
        if (!this.contactFunctionsLoaded) {
            return;
        }
        var index = this.contactFunctions.findIndex(function (type) { return type.id === contactFunction.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.contactFunctions, index);
        }
    };
    // Load the contact functions for server
    CustomersStore.prototype.loadContactFunctions = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.contactFunctionsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCustomers.axios.get('/customer/contact/function?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setContactFunctions', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setContactFunctionsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a contact function
    CustomersStore.prototype.setContactFunction = function (contactFunction) {
        this.context.commit('updateContactFunction', contactFunction);
        if (this.contactFunctionsLoaded) {
            this.context.commit('orderList', { list: this.contactFunctions, key: 'label' });
        }
    };
    // Delete a contact function
    CustomersStore.prototype.deleteContactFunction = function (contactFunction) {
        this.context.commit('removeContactFunction', contactFunction);
    };
    Object.defineProperty(CustomersStore.prototype, "defaultOrigin", {
        // Return the default customer origin to use
        get: function () {
            return this.origins.find(function (origin) { return origin.use_default; });
        },
        enumerable: false,
        configurable: true
    });
    // Change the loaded state
    CustomersStore.prototype.setOriginsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.originsLoaded = state;
    };
    // Set the customer origins
    CustomersStore.prototype.setOrigins = function (origins) {
        this.origins = origins;
    };
    // Add or update a customer origin
    CustomersStore.prototype.updateOrigin = function (origin) {
        if (!this.originsLoaded) {
            return;
        }
        var index = this.origins.findIndex(function (type) { return type.id === origin.id; });
        if (index >= 0) {
            external_vue_default().set(this.origins, index, origin);
        }
        else {
            this.origins.push(origin);
        }
    };
    // Remove a customer origin
    CustomersStore.prototype.removeOrigin = function (origin) {
        if (!this.originsLoaded) {
            return;
        }
        var index = this.origins.findIndex(function (type) { return type.id === origin.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.origins, index);
        }
    };
    // Load the customer origins for server
    CustomersStore.prototype.loadOrigins = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.originsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCustomers.axios.get('/customer/origin?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setOrigins', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setOriginsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a customer origin
    CustomersStore.prototype.setOrigin = function (origin) {
        this.context.commit('updateOrigin', origin);
        if (this.originsLoaded) {
            this.context.commit('orderList', { list: this.origins, key: 'label' });
        }
    };
    // Delete a customer origin
    CustomersStore.prototype.deleteOrigin = function (origin) {
        this.context.commit('removeOrigin', origin);
    };
    Object.defineProperty(CustomersStore.prototype, "defaultActivity", {
        // Return the default customer activity to use
        get: function () {
            return this.activities.find(function (activity) { return activity.use_default; });
        },
        enumerable: false,
        configurable: true
    });
    // Change the loaded state
    CustomersStore.prototype.setActivitiesLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.activitiesLoaded = state;
    };
    // Set the customer activities
    CustomersStore.prototype.setActivities = function (activities) {
        this.activities = activities;
    };
    // Add or update a customer activity
    CustomersStore.prototype.updateActivity = function (activity) {
        if (!this.activitiesLoaded) {
            return;
        }
        var index = this.activities.findIndex(function (type) { return type.id === activity.id; });
        if (index >= 0) {
            external_vue_default().set(this.activities, index, activity);
        }
        else {
            this.activities.push(activity);
        }
    };
    // Remove a customer activity
    CustomersStore.prototype.removeActivity = function (activity) {
        if (!this.activitiesLoaded) {
            return;
        }
        var index = this.activities.findIndex(function (type) { return type.id === activity.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.activities, index);
        }
    };
    // Load the customer activities for server
    CustomersStore.prototype.loadActivities = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.activitiesLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCustomers.axios.get('/customer/activity?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setActivities', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setActivitiesLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a customer activity
    CustomersStore.prototype.setActivity = function (activity) {
        this.context.commit('updateActivity', activity);
        if (this.activitiesLoaded) {
            this.context.commit('orderList', { list: this.activities, key: 'label' });
        }
    };
    // Delete a customer activity
    CustomersStore.prototype.deleteActivity = function (activity) {
        this.context.commit('removeActivity', activity);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomersStore.prototype, "clearStore", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "orderList", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "setCustomerTypesLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "setCustomerTypes", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "updateCustomerType", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "removeCustomerType", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomersStore.prototype, "loadCustomerTypes", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomersStore.prototype, "setCustomerType", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomersStore.prototype, "deleteCustomerType", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "setContactFunctionsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "setContactFunctions", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "updateContactFunction", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "removeContactFunction", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomersStore.prototype, "loadContactFunctions", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomersStore.prototype, "setContactFunction", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomersStore.prototype, "deleteContactFunction", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "setOriginsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "setOrigins", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "updateOrigin", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "removeOrigin", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomersStore.prototype, "loadOrigins", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomersStore.prototype, "setOrigin", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomersStore.prototype, "deleteOrigin", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "setActivitiesLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "setActivities", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "updateActivity", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CustomersStore.prototype, "removeActivity", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomersStore.prototype, "loadActivities", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomersStore.prototype, "setActivity", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CustomersStore.prototype, "deleteActivity", null);
    CustomersStore = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], CustomersStore);
    return CustomersStore;
}(VuexModule));
/* harmony default export */ var modules_CustomersStore = (CustomersStore);

;// ./src/broadcasts/team.ts
/* harmony default export */ var team = (function (store) { return ([
    {
        name: '.CustomerTypeCreated',
        callback: function (type) {
            store.dispatch('customers/setCustomerType', type);
        }
    },
    {
        name: '.CustomerTypeUpdated',
        callback: function (type) {
            store.dispatch('customers/setCustomerType', type);
        }
    },
    {
        name: '.CustomerTypeDeleted',
        callback: function (type) {
            store.dispatch('customers/deleteCustomerType', type);
        }
    },
    {
        name: '.ContactFunctionCreated',
        callback: function (contactFunction) {
            store.dispatch('customers/setContactFunction', contactFunction);
        }
    },
    {
        name: '.ContactFunctionUpdated',
        callback: function (contactFunction) {
            store.dispatch('customers/setContactFunction', contactFunction);
        }
    },
    {
        name: '.ContactFunctionDeleted',
        callback: function (contactFunction) {
            store.dispatch('customers/deleteContactFunction', contactFunction);
        }
    },
    {
        name: '.OriginCreated',
        callback: function (origin) {
            store.dispatch('customers/setOrigin', origin);
        }
    },
    {
        name: '.OriginUpdated',
        callback: function (origin) {
            store.dispatch('customers/setOrigin', origin);
        }
    },
    {
        name: '.OriginDeleted',
        callback: function (origin) {
            store.dispatch('customers/deleteOrigin', origin);
        }
    },
    {
        name: '.ActivityCreated',
        callback: function (activity) {
            store.dispatch('customers/setActivity', activity);
        }
    },
    {
        name: '.ActivityUpdated',
        callback: function (activity) {
            store.dispatch('customers/setActivity', activity);
        }
    },
    {
        name: '.ActivityDeleted',
        callback: function (activity) {
            store.dispatch('customers/deleteActivity', activity);
        }
    }
]); });

;// ./src/install.ts







var KwixeoCustomers = {
    install: function (Vue, options) {
        // Install lang
        this.installLang(options);
        Vue.prototype.$kwCustomers = options;
        // Install VueX
        this.installVueX(options);
        // Install routes
        this.installRoutes(options);
        __webpack_require__(1848);
        // Initialize broadcasts
        this.installBroadcasts(Vue, options);
    },
    installVueX: function (options) {
        var store = options.store;
        // Register VueX modules
        var modules = {
            customers: modules_CustomersStore
        };
        forEach_default()(modules, function (module, key) {
            if (!store.hasModule(key)) {
                store.registerModule(key, module);
            }
        });
        // Register dynamicModals
        dynamicModals.forEach(function (modal) { return store.dispatch('dynamicModals/registerModal', modal); });
    },
    installRoutes: function (options) {
        var router = options.router;
        var i18n = options.i18n;
        router_routes(i18n).forEach(function (route) {
            router.addRoute(route);
        });
        configRoutes(i18n).forEach(function (route) {
            router.addRoute('configuration', route);
        });
    },
    installLang: function (options) {
        var i18n = options.i18n;
        forEach_default()(lang, function (messages, locale) {
            i18n.mergeLocaleMessage(locale, messages);
        });
    },
    installBroadcasts: function (Vue, options) {
        var broadcast = Vue.prototype.$broadcast;
        if (!broadcast) {
            return;
        }
        broadcast.registerListeners('team', team(options.store));
    }
};
/* harmony default export */ var install = (KwixeoCustomers);

// EXTERNAL MODULE: ./src/fetchDatas/customer.ts
var customer = __webpack_require__(1506);
;// ./src/index.ts
// Individual components






























// Individual view components


















// Vue X Modules






;// ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=customers.common.js.map